import LocalizedStrings from "react-localization";
import { DEVELOPMENT_TYPE } from "Constants";

let LocaleStrings = new LocalizedStrings({
  en: {
    custom: "Custom",
    set: "Set",
    feature_under_construction: "This feature is under construction",
    excel: "Excel",
    reset: "Reset",
    no_data_found: "No data found",
    login: "Login",
    hello: "Hello",
    phone_preview: "Phone Preview",
    saving_changes: "Saving changes",
    you_have_changes: "You have unsaved changes",
    drag_and_drop: "Drag & Drop",
    or: "Or",
    select_file: "Click to upload",
    edit: "Edit",
    add: "Add",
    added: "Added",
    remove: "Remove",
    user: "User",
    users: "users",
    out: "out",
    of: "of",
    please_note: "Please Note",
    note: "Note",
    notes: "Notes",
    import: "Import",
    admin: "Admin",
    all: "All",
    weekly: "Weekly",
    monthly: "Monthly",
    as_per_date: "As per Date",
    installs: "Installs",
    ios: "iOS",
    android: "Android",
    web: "Web",
    day: "day",
    month: "month",
    year: "year",
    sessions: "Sessions",
    published: "Published",
    unpublished: "Unpublished",
    reply: "Reply",
    total: "Total",
    recommended: "Recommended",
    free: "Free",
    active: "Active",
    copied: "Copied",
    template: "Template",
    sample: "Sample",
    copy: "Copy",
    version: "Version",
    label: "Label",
    variable: "Variable",
    public: "Public",
    max_length: "Max length",
    options: "Options",
    values: "Values",
    width: "Width",
    height: "Height",
    url: "Url",
    paragraph: "Paragraph",
    email: "Email",
    company: "Company",
    designation: "Designation",
    qr: "QR Code",
    you: "you",
    have: "have",
    disabled: "disabled",
    hidden: "hidden",
    fee: "Fee",
    tax: "Tax",
    search: "Search",
    search_info: "Search will work after #count characters",
    select: "Select",
    required: "Required",
    small_required: "required",
    step1: "Step 1",
    step2: "Step 2",
    reviewervisible: "Visible to Reviewer",
    uploader_count: "Max File Upload",
    uploader_file_type: "File Type",
    maxuploader_size: "Max File Upload Size",
    maxentries: "Max Entries",
    lessons: "Lesson(s)",
    chapter: "Chapter",
    unlimited: "Unlimited",
    delete: "Delete",
    default: "Default",
    set_default: "Set as Default",
    pdf: "PDF",
    phone_format: "Phone number format ex: +xx xxx xxx xxxx, +xxxxxxxxxxxx",
    date_format:
      "For any “Date” column, change the cell format into date format and use YYYY-MM-DD",
    email_format: "Email format ex: xyz@xyz.xyz",
    method: "Method",
    post: "Post",
    payload: "Payload",
    header: "Header",
    column_header_format:
      "The column headers must not be changed or deleted, even if you do not have data/information under it.",
    duplicate_user_entries:
      "Please sort out the duplicate user entries before importing users to the platform.",
    three_mandatory_fields:
      "Three mandatory fields “first name”, “last name” and “email address”",
    rsvp: "RSVP",
    attach_files: "Attach Files",
    overwrite: "Overwrite",
    skip: "Skip",
    download_template: "Download template",
    drag_drop_textupload_template:
      "Click here or drag & drop to upload the completed template",
    sample_csv: "Sample CSV",
    sample_xls: "Sample XLS",
    processing_data: "Processing data",
    import_error_rows_message:
      "Below rows have some data errors; you can check them by hovering your mouse over the exclamation(!) icon. Please correct those data to add others",
    no_content_available: "No content available!",
    filter_by_all: "Filter by : All",
    cancelled: "Cancelled",
    scheduled: "Scheduled",
    sortby_all: "Sort by : All",
    paid: "Paid",
    pending: "Pending",
    icon_select_from_library: "or Select from library",
    upload_image_text: "Drag and drop or click to upload image",
    upload_image_size_text: "#width width x #height height",
    capitalize: "Capitalize",
    uppercase: "UPPERCASE",
    help_docs: "Help Docs",
    eventify_documentation: "Eventify Documentation",
    eventify_visit_doc_website: "Visit Our Documentation Website--",
    update: "Update",
    upload_image: "Upload Image",
    no_session_available_live_display:
      "No session available, please add session first",
    badge: "Badge",
    progress: "Progress",
    beta: "Beta",
    beta_info_text:
      "This feature is under beta testing, you may experience bugs/errors.",
    cm: "cm",
    inch: "inch",
    users_selected: "Users selected",
    user_selected: "User selected",
    delivered: "Delivered",
    opened: "Opened",
    failed: "Failed",
    startdate: "Start Date",
    enddate: "End Date",
    clear_all_selected_category_users: "Clear all users of selected group",
    select_all_selected_category_users:
      "Select all #total user(s) of selected group",
    by: "By",
    view_list: "View List",
    export_list: "Export List",

    // Common Invalid Message
    email_not_available: "This email id already exists!",
    email_available: "Email is available!",
    invalid_email: "Invalid email",
    invalid_value: "Invalid value",
    invalid_url: "Invalid url",
    invalid_facebook_url: "Invalid facebook url",
    invalid_linkedin_url: "Invalid linkedin url",
    invalid_twitter_url: "Invalid twitter url",
    invalid_instagram_url: "Invalid instagram url",
    invalid_whatsapp_no: "Invalid whatsapp number",
    invalid_number: "Invalid number",
    invalid_text_ampersand_not_allowed: "& not allowed",
    invalid_import_info:
      "Errors in any information will be ignored (the wrong data will not be inserted).",
    invalid_date_format: "Use YYYY-MM-DD format",

    button_task_status: "Task Status",
    button_upgrade: "Plans",
    button_change: "Change",
    button_save: "Save",
    button_download: "Download",
    button_add: "Add",
    button_update: "Update",
    button_close: "Close",
    button_close_and_save: "Save & Close",
    button_remove: "Remove",
    button_login: "Login",
    button_signup: "Signup",
    button_logout: "Logout",
    button_save_next: "Save & Next",
    button_upload_new_image: "Upload New Image",
    button_upload_new_file: "Upload New File",
    button_crop_save: "Crop & Save",
    button_search: "Search",
    button_add_user: "Add User",
    button_eventbrite_sync: "Eventbrite Sync",
    button_choose_event: "Choose event",
    button_csv_xml_import: "Import",
    button_csv_export: "Export",
    button_user_registration_policy: "User Registration Policy",
    button_check_in: "Check-in",
    button_checked_in: "Checked-in",
    button_mark_approved: "Mark Approved",
    button_send_welcome_email: "Send Welcome Mail",
    button_send_shortlist_email: "Send Shortlisted Mail",
    button_allow_app_access: "Allow App Access",
    button_ok: "Ok",
    button_cancel: "Cancel",
    button_basic_details: "Basic Details",
    button_other_details: "Other Details",
    button_retry: "Retry",
    button_send_to_selected: "Send to Selected",
    button_choose_custom: "Choose Custom Users",
    button_send_push: "Send Push",
    button_send: "Send",
    button_request_reset_password: "Request to Reset Password",
    button_change_password: "Change Password",
    button_yes: "Yes",
    button_no: "No",
    button_upgrade_plan: "Upgrade",
    button_contact_us: "Contact us",
    button_proceed: "Proceed",
    button_visit: "Visit",
    button_copy: "Copy",
    button_open: "Open",
    button_select: "Select",
    button_selected: "Selected",
    button_preview: "Preview",
    button_response: "Response",
    button_new_ticket: "New Ticket",
    button_new_plan: "New Plan",
    button_create_new: "Create New",
    button_view: "View",
    button_edit: "Edit",
    button_copy_url: "Copy Url",
    button_copied: "Copied",
    button_create_discount: "Create discount",
    button_ticket_order: "Ticket Order",
    button_get_invoice: "Get Invoice",
    button_create_dynamic_form: "Create Form",
    button_edit_dynamic_form: "Edit Form",
    button_clone_event: "Clone this Event",
    button_new_event: "New Event",
    button_manage_event: "Manage Event",
    button_reset_password: "Reset Password",
    button_manage_user_group: "Manage User Group",
    button_manage_category: "Manage Group",
    button_add_category: "Add Group",
    button_ticket_assoc_link_dynamic_form:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket Association"
        : "Plan Association",
    button_ticket_assoc_update: "Associate Ticket(s)",
    button_add_pg_info: "Add Info",
    button_update_pg_card: "Update Card",
    button_update_pg_merchant: "Update Merchant",
    button_delete: "Delete",
    button_maked_paid: "Mark Paid",
    button_add_new: "Add New",
    button_add_new_lesson: "Add New Lesson",
    button_add_new_chapter: "Add New Chapter",
    button_expand: "Expand",
    button_edit_content: "Edit Content",
    button_add_remove_content: "Add/Remove Content",
    button_add_another: "Add Another",
    button_check_availability: "Check Availability",
    button_new_session:
      DEVELOPMENT_TYPE === "eventify" ? "New Session" : "Live Class",
    button_view_manage_users: "View/Manage users",
    event_chooser_changefrominside_title_string: "Choose to change the event",
    button_save_changes: "Save Changes",
    button_continue_editing: "Continue Editing",
    button_print: "Print",
    button_search_keyword: "Search Keyword",
    button_my_account: "My Account",
    button_reupload: "Re-upload",
    button_manage_tags: "Manage Tags",
    button_qr_download: "Download QR",
    button_copy_qa_url: "Copy Live QA Url",
    button_copy_poll_url: "Copy Live Poll Url",
    button_connection_save: "Check Connection & Save",
    button_raise_ticket: "Raise a Ticket",
    button_select_users: "Select Users",
    button_refund: "Refund",
    button_processing: "Processing...",
    button_order_email: "Order Email",

    // Loader Text
    preparingSchedules: "Preparing Schedules",
    preparingSpeakers: "Preparing Speakers",
    preparingExhibitors: "Preparing Exhibitors",
    preparingSponsors: "Preparing Sponsors",
    preparingMaps: "Preparing Maps",
    preparingSocial: "Preparing Social",
    preparingMessages: "Preparing Messages",
    preparingWebview: "Preparing Web-view",
    preparingSurvey: "Preparing Survey",
    preparingCommunity: "Preparing Community",
    preparingAttendees: "Preparing Attendees",
    preparingAdvertisements: "Preparing Advertisements",
    preparingUsers: "Preparing Users",
    preparingCheckoutForm: "Preparing CheckoutForm",
    preparingPromoDiscount: "Preparing Promo Discount",
    preparingPolls: "Preparing Polls",
    preparingLiveQa: "Preparing Live Q&A",
    preparingrating: "Preparing Rating",
    preparingoutreach: "Preparing Outreaches",

    // Event Manage Modal
    event_chooser_title_string: "Choose any event to go inside",
    event_chooser_add_event_title: "Add Event",
    event_chooser_add_event_message: "Do you want to create a New event?",
    event_chooser_create_title_string: "Choose an option to create a New Event",

    event_delete_title: "Purge and Delete Event",
    event_delete_subtitle:
      "This action will delete all the data related to this event; you will not have access to it anymore. Continue?",
    event_delete_error1: "You don't have permission to delete this event.",

    // Login & Logout & Reset Password
    choose_template: "Choose a Template",
    choose_template_subheading:
      "With Eventify, it's extremely simple to put information right in your audience's hands, it all starts here with our app builder.",
    pre_filled_demo_event: "Pre-Filled Demo Event",
    start_with_scratch: "Start From Scratch",
    login_page_paragraph:
      DEVELOPMENT_TYPE === "eventify"
        ? "Start creating beautiful event apps with our easy-to-use event app builder. Build customized apps and instantly publish them with no design or coding skills required."
        : "Start creating course/live classes with our easy to use app builder. Build customized and instantly publish apps in with no design skill or coding required.",
    login_to_plateform:
      DEVELOPMENT_TYPE === "eventify"
        ? "Login to Eventify"
        : "Login to Koachify",
    login_form_label_email: "Email",
    login_form_ph_email: "Enter address",
    login_form_label_password: "Password",
    login_form_ph_password: "Your password",
    login_form_validation_email_required: "Please enter your email address!",
    login_form_validation_password_required: "Please enter your password!",
    login_user_not_registered: "Your account is not registered with us!",
    login_user_session_expired: "This account access session has expired.",
    invalid_email_password: "Incorrect email or password!",
    invalid_user: "Invalid User!",

    already_have_account_text: "Already have an account?",
    login_here: "Log in here",
    dont_have_account_text: "Don't have an account?",
    create_here: "Create here",
    forgot_password_text: "Forgot your password?",
    reset_here: "Reset here",
    reset_password: "Reset Password",

    reset_password_form_label_email: "Email",
    reset_password_form_ph_email: "Enter address",
    reset_password_form_validation_email_required:
      "Please enter your email address!",
    reset_password_form_validation_email_invalid: "Please enter a valid email!",
    reset_password_form_error_messages1:
      "The supplied email was not found in the system!",
    reset_password_form_success_message_part1: "We have sent you an email at",
    reset_password_form_success_message_part2:
      "with a confirmation code and reset link.",
    reset_password_form_label_confirmation_code: "Confirmation Code",
    reset_password_form_ph_confirmation_code: "Enter code",
    reset_password_form_label_new_password: "New Password",
    reset_password_form_ph_new_password: "Your new password",
    reset_password_form_validation_password_required:
      "Please enter your password!",
    reset_password_form_validation_confirmation_code_required:
      "Please enter the Confirmation Code you received!",
    reset_password_success: "Password reset Successfully!",
    reset_password_failed_error:
      "The supplied email and/or confirmation code were not found in the system.",

    signup_to_plateform:
      DEVELOPMENT_TYPE === "eventify"
        ? "Sign up to Eventify"
        : "Sign up to Koachify",
    signup_form_label_fname: "First Name",
    signup_form_ph_fname: "Enter the first name",
    signup_form_label_lname: "Last Name",
    signup_form_ph_lname: "Enter the last name",
    signup_form_label_email: "Email",
    signup_form_ph_email: "Enter your email",
    signup_form_label_password: "Password",
    signup_form_ph_password: "Enter password",
    signup_validate_password_min: "Password must have a min. of 6 characters",
    signup_validate_subdomain_specialchar:
      "Domain name can not contain special characters",
    signup_success_subdomain_available: "Sub-domain available",
    signup_error_subdomain_not_available:
      "This sub-domain name already exists. Please try another name.",
    signup_error_email_already_registered: "Email already registered.",

    logout_want_to_logout: "Do you really want to Logout?",

    // Mobile Error
    event_not_available_on_mobile:
      "Event editor is not available for Mobile Devices, please use Desktop/Tablet/Laptop to access it.",

    // Settings Section
    setting_submenu_title1: "Password Setting",
    setting_submenu_description1: "Update password",
    setting_submenu_title2: "Email Template",
    setting_submenu_description2: "Update your email templates",
    setting_submenu_title3: "Store Details",
    setting_submenu_description3: "Submit your app store details",
    setting_submenu_title4: "Email Log",
    setting_submenu_description4: "View your Email Log",
    setting_submenu_title5:
      DEVELOPMENT_TYPE === "eventify" ? "Event Settings" : "Platform Settings",
    setting_submenu_description5:
      DEVELOPMENT_TYPE === "eventify"
        ? "Manage all your event-related settings here"
        : "Manage your platform related all setting here",
    setting_submenu_title6: "APIs Doc",
    setting_submenu_description6: "View the API doc",
    setting_submenu_title7: "Billing Details",
    setting_submenu_description7: "View Billing details",
    setting_submenu_title8: "Report Issue",
    setting_submenu_description8: "View Issue",
    setting_submenu_title9: "Usage History",
    setting_submenu_description9: "View Usage History",
    setting_submenu_language_title: "Language",
    setting_submenu_language_description: "Set Event language",
    language_upload_text: "Click to upload or drag and drop",
    language_tooltip_text:
      "You can download the language file as CSV and upload it after editing the language file.",
    language_download_text: "Download English CSV",
    language_manual_text:
      " You can update the strings manually according to your language preference.",
    language_bulk_text: "Want to bulk edit the strings?",
    language_import_text: "Import CSV File",
    setting_submenu_integration_title: "Integrations",
    setting_submenu_integration_description6: "Integrations",

    password_setting_form_label_old_password: "Old Password",
    password_setting_form_ph_old_password: "Enter old password",
    password_setting_form_label_new_password: "New Password",
    password_setting_form_ph_new_password: "Enter a new password",
    password_setting_form_label_repeat_password: "Repeat Password",
    password_setting_form_ph_repeat_password: "Repeat new password",
    password_setting_form_validation_old_password_required:
      "Please enter the old password!",
    password_setting_form_validation_new_password_required:
      "Please enter a new password!",
    password_setting_form_validation_repeat_password_required:
      "Please repeat the new password!",
    password_setting_form_validation_repeat_old_password_not_match:
      "New Password and Repeat Password doesn't match!",
    password_setting_text_update_password_for: "Update Password for",
    password_setting_form_old_password_error: "The old password is incorrect",
    password_setting_form_success: "Password changed successfully!",

    event_setting_event_timezone_group: "Timezone Setup",
    event_setting_alert_timezone_update_success:
      "Timezone updated successfully!",
    event_setting_sorting_group_header: "Sorting",
    event_setting_speaker_sorting_group:
      DEVELOPMENT_TYPE === "eventify"
        ? "Speaker Sorting Setup"
        : "Instructor Sorting Setup",
    event_setting_speaker_sorting_group_subtitle:
      DEVELOPMENT_TYPE === "eventify"
        ? "Switching it on will sort the speakers A-Z by name"
        : "Do you want to sort instructors A-Z by name?",
    event_setting_alert_speaker_sort_randomly:
      "Speaker list sort with asc name removed.",
    event_setting_alert_speaker_sort_az:
      "Speaker list sort with asc name added",
    event_setting_sponsor_sorting_group: "Sponsor Sorting Setup",
    event_setting_sponsor_sorting_group_subtitle:
      "Switching it on will sort the sponsors A-Z by name",
    event_setting_alert_sponsor_sort_randomly:
      "Sponsor list sort with asc name removed.",
    event_setting_alert_sponsor_sort_az:
      "Sponsor list sort with asc name added",
    event_setting_exhibitor_sorting_group: "Exhibitor Sorting Setup",
    event_setting_exhibitor_sorting_group_subtitle:
      "Switching it on will sort the exhibitors A-Z by name",
    event_setting_alert_exhibitor_sort_randomly:
      "Exhibitor list sort with asc name removed.",
    event_setting_alert_exhibitor_sort_az:
      "Exhibitor list sort with asc name added",

    setting_email_template_heading: "Email Templates",
    setting_email_template_text_edit_with_gjs: "Edit template",
    setting_email_template_resetbtn_text: "RESET",
    setting_email_template_th_name: "Email Name",
    setting_email_template_th_trigger: "Email Triggered",
    setting_email_template_th_acion: "Action",
    setting_email_template_tab1: "Welcome",
    setting_email_template_trigger1: "On account creation",
    setting_email_template_information1:
      "Welcome mail is used to let users know that they have signed up successfully for the event. This email will contain their passcode and other instructions with app download links.",
    setting_email_template_tab2: "Ticket Order",
    setting_email_template_trigger2: "On new ticket purchase",
    setting_email_template_information2:
      "Ticket order mail is used to let the guest know that his/her ticket is successfully purchased. Now he/she can assign anyone to log in and access the app. This email will contain order details, invoice, and other instructions with app download links.",
    setting_email_template_tab3: "Ticket Assign",
    setting_email_template_trigger3: "When a ticket is assigned to a user",
    setting_email_template_information3:
      "Ticket assign mail is used to let the user know that he/she is assigned to a ticket for this event. Now he/she can access the app. This email will contain their passcode and other instructions with app download links.",
    setting_email_template_tab4: "Open Registration",
    setting_email_template_trigger4: "On user open registration",
    setting_email_template_information4:
      "Open registration mail is used to let the user know that he/she has successfully registered for the event. Now he/she can access the app. This email will contain instructions with app download links.",
    setting_email_template_tab5: "Setting",
    setting_email_template_tab6: "Ticket Order Pending",
    setting_email_template_trigger6: "When ticket payment is pending",
    setting_email_template_information6:
      "Ticket order pending mail is used to let the guest know that his/her ticket has been placed, but payment has not yet been made. This email will contain payment link, order details, invoice and other instructions with app download links.",
    setting_email_template_tab7: "User Registration",
    setting_email_template_trigger7: "On user registration",
    setting_email_template_information7:
      "User registration mail is used to let the user know that they have registered successfully to the platform. This email will contain instructions with app download links.",
    setting_email_template_tab8: "Course Order",
    setting_email_template_trigger8: "On course purchase",
    setting_email_template_information8:
      "Course order mail is used to let the user know that his/her course has been successfully purchased. Now he/she can access that course. This email will contain order details, invoice, and other instructions with app download links.",
    setting_email_template_tab9: "Live Class appointment",
    setting_email_template_trigger9: "On live class appointment",
    setting_email_template_information9:
      "Live class appointment mail is used to let the user know that his/her live class appointment is done successfully. Now he/she can access that live class. This email will contain order details, invoice, and other instructions with app download links.",
    setting_email_template_tab10: "Plan Order",
    setting_email_template_trigger10: "On plan purchase",
    setting_email_template_information10:
      "Plan order mail is used to let the user know that his/her plan is purchased successfully. Now he/she can access that plan. This email will contain order details, invoice, and other instructions with app download links.",
    setting_email_template_tab11: "Password reset",
    setting_email_template_trigger11: "On password reset request",
    setting_email_template_information11:
      "Password reset mail is used to send an email on a password reset request. This email will contain a password reset link, confirmation code, and other instructions with app download links.",
    setting_email_template_tab12: "Push Email",
    setting_email_template_trigger12: "On sending push email notification",
    setting_email_template_information12:
      "Push mail is used to send any event-related notification to the users. This email will contain instructions with app download links.",
    setting_email_template_tab13: "Abstract Ticket",
    setting_email_template_trigger13: "On abstract shortlisted selection",
    setting_email_template_information13:
      "Abstract ticket mail is used to send an abstract ticket link to the shortlisted guest to purchase and join the event. This email will contain a purchase ticket link and other instructions with app download links.",
    setting_email_template_tab14: "Abstract Re-submission",
    setting_email_template_trigger14: "For incomplete abstract submission",
    setting_email_template_information14:
      "Abstract re-submission mail is used to let the user know that his/her submitted abstract for the event is incomplete. This email will contain abstract re-submission link and other instructions with app download links.",
    setting_email_template_tab15: "Reviewer",
    setting_email_template_trigger15:
      "When anyone is added as abstract reviewer",
    setting_email_template_information15:
      "Reviewer mail is used to let the guest know that he/she is appointed as an abstract reviewer for this event. This email will contain the login credentials.",
    setting_email_template_tab16: "Abstract Verify",
    setting_email_template_trigger16: "On abstract verification",
    setting_email_template_information16:
      "Abstract verify mail is used to let the user know that his/her abstract is verified for this event. This email will contain verification code and other instructions with app download links.",
    setting_email_template_tab17: "Abstract User Shortlist",
    setting_email_template_trigger17:
      "When an abstract user is shortlisted and registered",
    setting_email_template_information17:
      "Abstract user shortlisting mail is used to let the user know that his/her abstract is shortlisted and the registration is done to join this event. This email will contain passcode and other instructions with app download links.",
    setting_email_template_tab18: "User on Waitlist",
    setting_email_template_trigger18: "When a user is on the waitlist",
    setting_email_template_information18:
      "Waitlist mail is used to let the user know that they have signed up successfully for the event, but the account is not confirmed by the admin and they are on the waitlist. This email will contain instructions with app download links",
    setting_email_template_tab19: "User Confirmation",
    setting_email_template_trigger19: "When a user is confirmed",
    setting_email_template_information19:
      "Confirmed user mail is used to let the user know that his/her account is confirmed by the admin. Now he/she can access their account. This email will contain their passcode and other instructions with app download links.",
    setting_email_template_tab20: "Support",
    setting_email_template_trigger20: "On support reply",
    setting_email_template_information20:
      "Support reply user mail is used to send the reply to any query asked by the user. This email will contain the query reply and other instructions with app download links.",
    setting_email_template_tab21: "Export",
    setting_email_template_trigger21: "On user QR scan list export",
    setting_email_template_information21:
      "Export mail is used to send all the QR-related information scanned by the user in Excel format. This email will contain the Excel file and other instructions with app download links.",
    setting_email_template_note1:
      "The texts inside each set of curly braces { } in the email templates represent VARIABLES. Kindly do not edit/delete them while customising the templates.",
    setting_email_template_note2:
      "Please do not edit/remove the text inside any curly braces { }. Doing so will result in the loss of data.",
    setting_email_template_note3:
      "Please customise the email body in the format specified in the templates. If you already have an HTML copy of your email(s), paste it in the email body section.",
    setting_email_template_note4:
      "Please save the template inside the popup before exiting.",
    setting_email_template_btn_testemail: "Send Test Email",
    setting_email_template_testemail_header: "Test Welcome Email",
    setting_email_template_testemail_success: "Email Sent Successfully",
    setting_email_template_testemail_validate:
      "Please add all details to test email",

    setting_email_template_reset_confirm_title: "Reset Email",
    setting_email_template_reset_confirm_subtitle:
      "Are you sure you want to reset? Resetting will bring the default template back. Continue?",
    setting_email_template_reset_success: "Template Reset Successfully",

    template_setting_form_label_smtp_setting_note1:
      "Email will be sent out via no-reply@eventify.io",
    template_setting_form_label_smtp_setting_note2:
      "Please use an outgoing email gateway service like Mailgun or Sendinblue or similar",
    template_setting_form_label_smtp_setting_note3:
      "We don't recommend using inboxes like Hotmail, Google mail as they have limitations on sending out emails",
    template_setting_form_label_smtp_setting_note4:
      "Open receipts cannot be tracked using own SMTP gateway",
    template_setting_form_label_smtp_type: "SMTP Setting",
    template_setting_form_label_smtp_type_option1: "Eventify",
    template_setting_form_label_smtp_type_option2: "Own",
    template_setting_form_label_host: "SMTP Host Name",
    template_setting_form_ph_host: "Enter host name",
    template_setting_form_label_port: "Port Number",
    template_setting_form_ph_port: "Enter port number",
    template_setting_form_label_user: "Username",
    template_setting_form_ph_user: "Enter username",
    template_setting_form_label_password: "Password",
    template_setting_form_ph_password: "Enter password",
    template_setting_form_label_fromemail: "From Email",
    template_setting_form_ph_fromemail: "Enter email from which email will go",
    template_setting_form_label_subject: "Email Subject",
    template_setting_form_ph_subject: "Enter the email subject",
    template_setting_form_label_email_content: "Email Content",
    template_setting_form_ph_email_content: "Enter email content",
    template_setting_form_validation_required: "Required",
    template_added_message: "Template added successfully!",
    template_updated_message: "Template updated successfully!",
    template_smtp_setting_success: "SMTP setting saved successfully!",
    template_smtp_setting_credential_error:
      "The given SMTP credential is not valid!",

    setting_email_template_update_modal_title: "Email Content",
    setting_email_template_update_confirm_subtitle:
      "Make sure you have saved the changes!",

    setting_apidoc_text_user_regi: "User Registration Api",
    setting_apidoc_text_user_regi_definition:
      "This method creates an attendee for your event, who can later access your event's web portal and app.",
    setting_apidoc_text_user_regi_header: "Method headers",
    setting_apidoc_text_user_regi_payloads: "Method payloads",
    setting_apidoc_text_user_regi_payload_username: "Full name of the attendee",
    setting_apidoc_text_user_regi_payload_fname: "First name of the attendee",
    setting_apidoc_text_user_regi_payload_lname: "Last name of the attendee",
    setting_apidoc_text_user_regi_payload_email: "Email of the attendee",
    setting_apidoc_text_user_regi_payload_eventid:
      "This is your event id, it's required with each of your attendees",
    setting_apidoc_text_user_regi_payload_categoryid:
      "This is the category id of the attendee",
    setting_apidoc_text_user_regi_payload_comesfrom:
      "This will be the source of the attendee",

    appstore_setting_form_info_text: "This is only one time submit form",
    appstore_setting_form_label_display_name_in_appstore:
      "Display Name in Store",
    appstore_setting_form_ph_display_name_in_appstore:
      "Enter display name in store",
    appstore_setting_form_label_display_name_ondownloded_app:
      "Display Name on Downloaded App",
    appstore_setting_form_ph_display_name_ondownloded_app:
      "Enter the display name on the downloaded app",
    appstore_setting_form_label_appstore_short_description:
      "App Store Short Description",
    appstore_setting_form_ph_appstore_short_description:
      "Enter app store short description",
    appstore_setting_form_label_appstore_description: "App Store Description",
    appstore_setting_form_ph_appstore_description:
      "Enter app store description",
    appstore_setting_form_label_privacy_policy_url: "Privacy & Policy Url",
    appstore_setting_form_ph_privacy_policy_url: "Enter privacy & policy URL",
    appstore_setting_form_label_terms_conditions_url: "Terms & Conditions URL",
    appstore_setting_form_ph_terms_conditions_url:
      "Enter terms & conditions URL",
    appstore_setting_form_label_support_email: "Support Email",
    appstore_setting_form_ph_support_email: "Enter support email",
    appstore_setting_form_label_support_url: "Support URL",
    appstore_setting_form_ph_support_url: "Enter the support URL",
    appstore_setting_form_label_website_url: "Website URL",
    appstore_setting_form_ph_website_url: "Enter the website URL",
    appstore_setting_form_label_keywords: "Keywords",
    appstore_setting_form_ph_keywords: "Enter keywords",
    appstore_setting_form_label_category: "Category",
    appstore_setting_form_ph_category: "Select app category",
    appstore_setting_form_label_logo: "Logo",
    appstore_setting_form_label_cover_image: "Cover Image",
    appstore_setting_text_logo_note1: "Minimum 256px wide by 256px tall",
    appstore_setting_form_label_images: "Other Images",
    appstore_setting_text_warning_add_keywords:
      "Add comma separated values ex: business, tech event, technology",
    appstore_setting_note_cover_image:
      "Image for custom event search screen background in the app. This image is optional, we can use the logo as well.",
    appstore_setting_form_success: "App Store details saved successfully",

    // Account Settings
    accountsetting_header_title: "My Account",
    accountsetting_header_subtitle: "My account settings",
    accountsetting_submenu_title1: "Billing Details",
    accountsetting_submenu_description1: "View Billing details",
    accountsetting_submenu_title2: "Usage History",
    accountsetting_submenu_description2: "View Usage History",
    accountsetting_submenu_title3: "Report Issue",
    accountsetting_submenu_description3: "View Report Issue",
    accountsetting_billingdetails_headerleft:
      "Need to add more users? Contact Eventify to Top-up your Plan",
    accountsetting_billingdetails_headerleftuserlimitexceeded:
      "User limit exceeded",
    accountsetting_billingdetails_headerright_contactbuttion:
      "Contact Eventify",
    accountsetting_billingdetails_contacteventify_modaltitle:
      "Contact Eventify",
    accountsetting_billingdetails_contacteventify_modalclose: "Close",
    accountsetting_billingdetails_contacteventify_modalsave: "Save",
    accountsetting_report_issue_send: "Send",
    accountsetting_billingdetails_subheader_headingtext:
      "Billing Account Details",
    accountsetting_billingdetails_contacteventify_modalbodytext:
      "Your request to update the Top-up Plan has been successfully sent to Eventify. Our Team will contact you shortly or you can also email us at silas@eventify.com",
    accountsetting_billingdetails_subheader_acc_active: "Account Active Since:",
    accountsetting_billingdetails_subheader_nametext: "Name:",
    accountsetting_billingdetails_subheader_acc_validity:
      "Account validity till:",
    accountsetting_billingdetails_subheader_total_user_limit: "User Credits:",
    accountsetting_billingdetails_billed_to: "Billed To:",
    accountsetting_billingdetails_subheader_total_used: "Used:",
    accountsetting_billingdetails_subheader_box1_name: "Name:",
    accountsetting_billingdetails_subheader_box1_email: "Email:",
    accountsetting_billingdetails_subheader_box1_vatnumber: "Vat Number:",
    accountsetting_billingdetails_subheader_box1_plantype: "Plan Type:",
    accountsetting_billingdetails_subheader_box1_company: "Company:",
    accountsetting_billingdetails_subheader_emaiid: "Email Address:",
    accountsetting_billingdetails_subheader_address: "Address:",
    accountsetting_billingdetails_subheader_available_limit: "Remaining:",
    accountsetting_billingdetails_subheader_mau_details:
      "Monthly Active User (MAU) tracks the number of unique users who visits the platform each month",
    accountsetting_billingdetails_subheader_active_since: "Plan Validity From:",
    accountsetting_billingdetails_subheader_validtill: "Plan Validity Till:",
    accountsetting_billingdetails_subheader_editbilling_account:
      "Edit Billing Account",
    accountsetting_billingdetails_table_buttonpay: "Pay",
    accountsetting_billingdetails_payment:
      "Please wait! The payment is processing",
    accountsetting_billingdetails_table_buttonview: "View",
    accountsetting_billingdetails_table_buttondownload: "Download",
    accountsetting_billing_details_paymenthistory: "Billing & payment history",
    accountsetting_billing_details_addpayment: "Add Payment",
    accountsetting_billing_details_table_th1: "Type",
    accountsetting_billing_details_table_th2: "Issue Date",
    accountsetting_billing_details_table_th3: "Amount",
    accountsetting_billing_details_table_th4: "User Limit",
    accountsetting_billing_details_table_th5: "Status",
    accountsetting_billing_details_table_th6: "Action",
    accountsetting_billing_details_table_viewbillmodalhead: "View Details",
    accountsetting_billing_details_table_viewbillmodalhead_date: "Date",
    accountsetting_billing_details_table_viewbillmodalhead_billedto:
      "BILLED TO:",
    accountsetting_billing_details_table_viewbillmodaldiscountedprice:
      "Discount",
    accountsetting_billing_details_table_viewbillmodalhead_th1:
      "Items & Description",
    accountsetting_billing_details_table_viewbillmodalhead_th2: "Quantity",
    accountsetting_billing_details_table_viewbillmodalhead_th5: "Price",
    accountsetting_billing_details_table_viewbillmodalhead_th3: "Discount(%)",
    accountsetting_billing_details_table_viewbillmodalhead_th4:
      "Total Price(USD)",
    accountsetting_billing_details_table_viewbillmodalhead_teksaddress1:
      "Teks Mobile Australia Pty Ltd.",
    accountsetting_billing_details_table_viewbillmodalhead_teksaddress2:
      "1/10-14 Boyle St, Sutherland,",
    accountsetting_billing_details_table_viewbillmodalhead_teksaddress3:
      "NSW 2232, Australia",
    accountsetting_billing_details_table_viewbillmodalhead_to: "To",
    accountsetting_billing_details_view_vat: "Vat Number:",
    accountsetting_billing_details_validitytill: "Account Validity Until:",
    accountsetting_billing_details_usercredit: "User Credit:",
    accountsetting_billing_details_table_viewbillmodalhead_preparedon:
      "Prepared on:",
    accountsetting_billing_details_issued_on: "Issued on:",
    accountsetting_billing_details_table_viewbillmodalhead_preparedby:
      "Prepared by:",
    accountsetting_billing_details_table_viewbillmodalhead_silasname:
      "Silas Haton",
    accountsetting_billing_details_table_viewbillmodalhead_silasemail:
      "silas@eventify.io",
    accountsetting_billing_details_table_viewbillmodalhead_eventifyemail:
      "hello@eventify.io",
    accountsetting_billing_details_table_viewmodal_tq:
      "Thank you for the business.",
    accountsetting_billing_details_table_viewmodal_tq1:
      "If you have any questions or need assistance ,please contact our team",
    accountsetting_billing_details_table_viewmodal_eventifysite:
      "www.eventify.io",
    accountsetting_billing_details_table_viewmodal_eventifyphoneno:
      "+44 20 8089 7390",
    accountsetting_billing_details_table_viewbillmodalhead_thankyou:
      "Thank You",
    accountsetting_billing_details_table_viewbillmodalhead_openlink:
      "Open Link For Payment-",
    accountsetting_billing_details_table_viewbillmodalhead_payhere: "Pay Here",
    accountsetting_billing_details_table_viewbillmodalhead_quote_cancelled:
      "The quote has been cancelled!",
    accountsetting_billing_details_table_viewbillmodalhead_quote_payment_received:
      "The payment has been received. Thanks!",
    accountsetting_billing_details_table_viewbillmodalhead_terms:
      "Terms and Conditions",
    accountsetting_billing_details_table_viewbillmodalhead_grandtotal:
      "Grand Total:",
    accountsetting_usagehistory_headertitle: "Usage History",
    accountsetting_usagehistory_headerdesc: "View usage details for - ",
    accountsetting_usagehistory_subheader_usercredits: "User credits",
    accountsetting_usagehistory_subheader_validuntill: "Valid until",
    accountsetting_usagehistory_subheader_credits: "Credits",
    accountsetting_usagehistory_subheader_used: "Used",
    accountsetting_usagehistory_subheader_remaining: "Remaining",
    accountsetting_usagehistory_view_download:
      "View & download the usage history of users",
    accountsetting_usagehistory_download_statement: "Download Full Statement",
    accountsetting_usagehistory_table_th1: "Billing cycle",
    accountsetting_usagehistory_table_th2: "Account Usage",
    accountsetting_usagehistory_table_th3: "Action",
    accountsetting_usagehistory_table_btndetails: "View Details",
    accountsetting_usagehistory_modalheader: "View Usage History",
    accountsetting_usagehistory_modalfilterwithevent: "Sort by event",
    accountsetting_usagehistory_modaltable_th1: "Username",
    accountsetting_usagehistory_modaltable_th2: "Activate Date",
    accountsetting_usagehistory_modaltable_th3: "Event Name",
    accountsetting_usagehistory_modaltable_th4: "Email",
    accountsetting_usagehistory_paymentfailed:
      "Something Went Wrong! Couldn't Proceed Payment! Contact Admin",

    // Report Issue
    accountsetting_reportissue_headertitle: "Feedbacks",
    accountsetting_reportissue_headerdesc:
      "Having an issue? Please send us your valuable feedback",
    accountsetting_tab_title1: "Open Issue",
    accountsetting_tab_title2: "Closed Issue",
    accountsetting_report_loading_desc: "Preparing reports",
    accountsetting_postfeedback: "Post your feedback",
    accountsetting_fieldsubject: "Subject",
    accountsetting_placeholdersubject: "Subject for the report",
    accountsetting_descfield: "Description",
    accountsetting_reportissue_th0: "Ticket id",
    accountsetting_reportissue_th1: "Summary",
    accountsetting_reportissue_th2: "Created on",
    accountsetting_reportissue_th3: "Status",
    accountsetting_reportissue_th4: "Action",
    accountsetting_reportissue_th5: "Last Replied",
    accountsetting_reportissue_th6: "Subject",
    accountsetting_reportissue_th7: "Last Replied On",
    accountsetting_reportissue_waitingforsuperadminreply: "(Waiting for reply)",
    accountsetting_reportissue_attachments: "Attachments",
    accountsetting_reportissue_replyfromeventify: "Reply From Eventify",
    accountsetting_reportissue_reopen: "Reopen",
    accountsetting_addreport_labelevent: "Events",
    accountsetting_addreport_labelplatform: " Platform",
    accountsetting_addreport_uploadfile: "Upload Files",
    accountsetting_addreport_max5files: "(Max. 5 files)",
    accountsetting_addreport_addedsuccess: "Report added successfully",
    accountsetting_addreport_noofopenissues: "No of open issues:",
    accountsetting_addreport_noofcloseissue: "No of closed issues:",
    accountsetting_reportissuemodal_eventname: "Event Name:",
    accountsetting_reportissuemodal_subject: "Subject:",
    accountsetting_reportissuemodal_issuereportedon: "Issue reported on:",
    accountsetting_reportissuemodal_issuereportedby: "Issue reported by:",
    accountsetting_reportissuemodal_closeissue_btn: "Close Issue",
    accountsetting_reportissuemodal_uploadfiles: "Upload Files",
    accountsetting_reportissuemodal_max5files: "(Max. 5 files)",
    accountsetting_reportissuemodal_sendclose_btn: "Send and Close",
    accountsetting_reportissuemodal_nodesc_error: "Please add description",
    accountsetting_reportissuemodal_sent_success: "Successfully Sent",
    accountsetting_reportissuemodal_sent_n_close_success:
      "Successfully Sent and Closed",
    accountsetting_reportissuemodal_upto5files_error: "Can upload upto 5 files",

    // Language Settings
    language_setting_heading: "Language Settings",
    language_setting_edit: "Edit Strings",
    language_setting_form_select_language: "Select Language",
    language_setting_form_add_language: "Add Language",
    language_setting_add_new_language: "Add New Language",
    language_setting_add_new_form_language: "Language",
    language_setting_add_new_form_language_title: "Enter Language",
    language_setting_add_new_form_language_error: "Language Required",
    language_setting_isenabled: "Enable",
    language_setting_isdisabled: "Disable",
    language_setting_isenbled_message:
      "This will enable the selected language.",
    language_setting_isdisabled_message:
      "This will disable the selected language.",
    language_updated_message: "Language updated successfully",
    language_added_message: "Language added successfully",
    language_setting_form_select_language_error: "Please Select Language",
    language_already_exist: "Language already exist",

    // userlimitexceed
    userlimit_exceed_head: "Your Active Users Limit Has Exceeded.",
    userlimit_exceed_userslimit: "Users Limit:",
    userlimit_totalactiveusers: "Total Active Users",
    userlimit_exceedby: "Exceeded by:",
    userlimit_topupplan: "Top up the plan to give access to new users:",
    userlimit_exceededuser: "users",
    userlimit_exceededbtnback: "Go Back",
    userlimit_exceededbtnrequest: "Request Topup",

    // Mobile Preview
    event_basic_info: "Event Basic Info",
    eventgroup: "Event Groupid",
    eventcode: "Eventcode",
    eventid: "Eventid",
    preview: "Preview",
    preview_on_your_phone: "Preview On Your Phone",
    preview_scan_qr_code:
      "Scan the QR code with your phone camera to download the app in your phone",
    preview_scan_for_ios: "Scan for iOS",
    preview_scan_for_android: "Scan for Android",

    // Save the work section
    save_work_form_ph_email: "Enter Email ID",
    save_work_form_validation_email_required: "Please input Email Id!",

    // New Event Section
    new_event_title_create_new_event: "Create New Event",
    new_event_text_sure_want_to_create_event:
      "This will switch you to the new event. Continue?",

    clone_event_title_clone_this_event: "Clone This Event",
    clone_event_text_sure_want_to_clone_event: "Do you want to continue?",

    // Basic Settings (some are in under ticket settings)
    basic_setting_user_registration_group: "User Registration Setup",
    basic_setting_dynamic_form_group: "Dynamic Form Setup",
    basic_setting_sociallogin_group: "Social Login Setup",
    basic_setting_sociallogin_group_text_social_login: "Social Login",
    bacis_setting_alert_sociallogin_deactivated:
      "Social login option deactivated",
    basic_setting_alert_sociallogin_activated: "Social login option activated",
    basic_setting_applayout_group_header: "App Layout",
    basic_setting_gallery_pic_upload_group: "Gallery Image Setup",
    basic_setting_gallery_pic_upload_group_text_uploadby:
      "Switching it on will allow users to upload images to Gallery",
    basic_setting_alert_gallery_pic_upload_deactivated:
      "Now users can not upload images in the gallery!",
    basic_setting_alert_gallery_pic_upload_activated:
      "Now users can upload images in the gallery!",
    basic_setting_app_bottom_menu_group: "App Bottom Menu Setup",
    basic_setting_app_bottom_menu_group_text_activate_or_not:
      "Switching it on will show the bottom menu in the app",
    basic_setting_alert_app_bottom_menu_deactivated:
      "App bottom menu will not be visible!",
    basic_setting_alert_app_bottom_menu_activated:
      "App bottom menu will be visible!",
    basic_setting_other_group_header: "Others",
    basic_setting_scheduleview_heading: "Schedule View Setup",
    basic_setting_scheduleview_subHeading:
      "Switching it on will set the schedule list in a grid view in the apps (by default it displays in a calender view)",
    basic_setting_alert_scheduleview_grid:
      "Schedule changed to Grid view successfully",
    basic_setting_alert_scheduleview_calendar:
      "Schedule changed to Calendar view successfully",
    basic_setting_speakerview_heading: "Speaker List View Setup",
    basic_setting_speakerview_subheading:
      "Switching it on will set the speakers in a list view in the apps (by default it displays in a grid view)",
    basic_setting_alert_speakerview_list:
      "Speaker changed to list view successffully",
    basic_setting_alert_speakerview_grid:
      "Speaker changed to grid view successfully",

    basic_setting_profile_share_group_header: "Profile Sharing",
    basic_setting_speaker_profile_share_heading: "Speaker Profile Share Setup",
    basic_setting_speaker_profile_share_subheading:
      "Switching it on will allow a speaker to share their profile to others",
    basic_setting_alert_speaker_profile_share_on:
      "Speaker profile share option enabled successfully",
    basic_setting_alert_speaker_profile_share_off:
      "Speaker profile share option disabled successfully",

    basic_setting_ticketing_group_header: "Ticketing",
    basic_setting_file_group_header: "File Download",
    basic_setting_userfile_download_title: "User File Download",
    basic_setting_userfile_download_description:
      "Switching it on will allow the user to download & access the user files outside the app",
    basic_setting_speakerfile_download_title: "Speaker File Download",
    basic_setting_speakerfile_download_description:
      "Switching it on will allow the user to download & access the speaker files outside the app",
    basic_setting_sponsorfile_download_title: "Sponsor File Download",
    basic_setting_sponsorfile_download_description:
      "Switching it on will allow the user to download & access the sponsor files outside the app",
    basic_setting_exhibitorfile_download_title: "Exhibitor File Download",
    basic_setting_exhibitorfile_download_description:
      "Switching it on will allow the user to download & access the exhibitor files outside the app",
    basic_setting_sessionfile_download_title: "Session File Download",
    basic_setting_sessionfile_download_description:
      "Switching it on will allow the user to download & access the session files outside the app",
    basic_setting_notification_group: "Ticket Purchase Notification",
    basic_setting_notification_group_activate_or_not:
      "Switching it on will set up a notification email for you (admin) to receive, when a ticket is purchased",
    basic_setting_alert_notification_on_purchase_deactivated:
      "You (admin) will not receive any notification on ticket purchase!",
    basic_setting_alert_notification_on_purchase_activated:
      "You (admin) will receive notification on every ticket purchase!",
    basic_setting_user_group_header: "User Login",
    basic_setting_autologin_group: "Auto Login Setup",
    basic_setting_autologin_group_text_activate_or_not:
      "Switching it on will allow a user to auto login to app without password",
    basic_setting_alert_autologin_deactivated: "Auto login option deactivated!",
    basic_setting_alert_autologin_activated: "Auto login option activated!",
    basic_setting_login_mandatory_group: "Login Mandatory Setup",
    basic_setting_login_mandatory_text_activate_or_not:
      "Switching it on will make it mandatory for a user to login",
    basic_setting_login_mandatory_validation_not_allow:
      "You cannot enable the login mandatory option as you have User Management disabled or the event policy type is set to ‘Without registration’.",
    basic_setting_alert_login_mandatory_deactivated:
      "Login mandatory option deactivated!",
    basic_setting_alert_login_mandatory_activated:
      "Login mandatory option activated!",
    basic_setting_alert_waitlist_option_activated: "Waitlist option activated!",
    basic_setting_alert_waitlist_mode_deactivated:
      "Waitlist option deactivated!",
    basic_setting_multiple_login_group: "Multiple Login Setup",
    basic_setting_multiple_login_text_activate_or_not:
      "Switching it on will allow a user to login on multiple devices",
    basic_setting_alert_multiple_login_deactivated:
      "Multiple login option deactivated!",
    basic_setting_alert_multiple_login_activated:
      "Multiple login option activated!",
    basic_setting_notification_blocker_group: "Notification Blocker Setup",
    basic_setting_notification_blocker_text_activate_or_not:
      "Notification blocker",
    basic_setting_alert_notification_blocker_deactivated:
      "Notification blocker option deactivated!",
    basic_setting_alert_notification_blocker_activated:
      "Notification blocker option activated!",
    basic_setting_overview_screen_switcher_group: "Quick Links Setup",
    basic_setting_overview_screen_switcher_text_activate_or_not:
      "Switching it on will allow quick link access on home screen",
    basic_setting_alert_overview_screen_switcher_deactivated:
      "Overview screen switcher option deactivated!",
    basic_setting_alert_overview_screen_switcher_activated:
      "Overview screen switcher option activated!",
    basic_setting_eventcode_login_group: "Event Code Login Setup",
    basic_setting_eventcode_login_text_activate_or_not:
      "Switching it on will allow a user to login with event code",
    basic_setting_alert_eventcode_login_deactivated:
      "Event code login option deactivated!",
    basic_setting_alert_eventcode_login_activated:
      "Event code login option activated!",
    basic_setting_access_whitelabel_app_group:
      "Show White Labeled App's Event on Eventify App Setup",
    basic_setting_whitelabel_app_text_access_or_not:
      "Switching it on will display this event alongside other events on Eventify's app's search",
    basic_setting_alert_whitelabel_app_permission_given:
      "Permission for listing this event inside the Eventify app is activated!",
    basic_setting_alert_whitelabel_app_permission_taken:
      "Permission for listing this event inside Eventify app is deactivated!",
    basic_setting_waitlist_heading: "WaitList Mode",
    basic_setting_waitlist_subHeading:
      "Switching it on will turn ON the waitlist mode to enable waiting list before confirmation for users",

    // Plans & Publish
    publish_text_current_active_plan: "YOU ARE CURRENTLY ON THIS PLAN",
    publish_text_next_step: "Next Steps",
    publish_text_how_can_we_help_you: "How can we help you?",
    publish_text_how_can_we_help_you_sub_title:
      "Need help setting up your event app? We are here to help.",
    publish_text_starter_pack: "Starter Pack",
    publish_text_not_sure_about_eventify: "Not sure about Eventify?",
    publish_text_not_give_it_a_try: "Give it a try and text with others",
    publish_text_starter_pack_content1: "Event details & description",
    publish_text_starter_pack_details1:
      "Add event dates, description and location",
    publish_text_starter_pack_content2: "App and Web branding",
    publish_text_starter_pack_details2:
      "Upload event icon, logo and theme colour",
    publish_text_starter_pack_content3: "Modules For App and Web",
    publish_text_starter_pack_details3:
      "Add features to your event app and website",
    publish_text_starter_pack_content4: "Add event information",
    publish_text_starter_pack_details4:
      "Fill in updated event-related information",
    publish_text_starter_pack_content5: "Pro website themes",
    publish_text_starter_pack_details5: "Pick from wide range of web themes",
    publish_text_starter_pack_content6: "$1 Event Ticketing",
    publish_text_starter_pack_details6:
      "List event tickets at a flat rate of $1/ticket",
    publish_text_starter_pack_content7: "Import Attendee list",
    publish_text_starter_pack_details7:
      "Add/Import user list & specify user roles",
    publish_text_starter_pack_content8: "Live Polls and Q&A",
    publish_text_starter_pack_details8:
      "Set up live polling, live Q&A, session ratings",
    publish_text_starter_pack_content9: "Real-time push notifications",
    publish_text_starter_pack_details9:
      "Send instant push notifications & emails",
    publish_text_starter_pack_content10: "Insightful event analytics",
    publish_text_starter_pack_details10:
      "Track real-time app users, installs & more",

    publish_text_business_pro: "Business Pro",
    publish_text_rs249_per_event: "$249 per event per venue",
    publish_text_rs249_per_event_sub_title:
      "Pay once per event. Optimised for audiences of 2500 or less.",
    publish_text_business_pro_content1: "Event Publishing Toolkit",
    publish_text_business_pro_details1: "Admin panel all features",
    publish_text_business_pro_content2: "Tag based Networking",
    publish_text_business_pro_details2:
      "Match making of attendees based on common interests",
    publish_text_business_pro_content3: "Branded Eventify iOS/Android apps",
    publish_text_business_pro_details3:
      "Showcase your event on the Eventify app",
    publish_text_business_pro_content4: "Magic Links Sign-in",
    publish_text_business_pro_details4: "Password-less sign in for attendees.",
    publish_text_business_pro_content5: "Content syncing",
    publish_text_business_pro_details5: "Attendees can use the app offline",
    publish_text_business_pro_content6: "Instant updates",
    publish_text_business_pro_details6:
      "Change anything on admin and it will appear on the app live",
    publish_text_business_pro_content7: "Engagement via Push Notifications",
    publish_text_business_pro_details7:
      "Engage attendees with push notifications",
    publish_text_business_pro_content8: "Engagement Insights & Analytics",
    publish_text_business_pro_details8:
      "See how your attendees are using the app",
    publish_text_business_pro_content9: "Regular Email support",
    publish_text_business_pro_details9: "Contact support anytime",
    publish_text_business_pro_content10: "Up to 2500 users",
    publish_text_business_pro_details10: "For small events upto 2500 users.",

    publish_text_enterprise_pro: "Enterprise Pro",
    publish_text_rs599_per_event: "$599 per event per venue",
    publish_text_rs599_per_event_sub_title:
      "Pay once per event. Optimised for large audiences.",
    publish_text_enterprise_pro_content1: "All in the Business Pro, and below",
    publish_text_enterprise_pro_details1: "",
    publish_text_enterprise_pro_content2: "White-labeled apps",
    publish_text_enterprise_pro_details2: "Have your own branding and own apps",
    publish_text_enterprise_pro_content3: "Custom branded iOS / Android apps",
    publish_text_enterprise_pro_details3:
      "Apps are launched with your brand name on the store",
    publish_text_enterprise_pro_content4: "Dedicated Account Manager",
    publish_text_enterprise_pro_details4:
      "Our account manager will setup the entire event for you.",
    publish_text_enterprise_pro_content5: "Unlimited users",
    publish_text_enterprise_pro_details5: "For large events",
    publish_text_enterprise_pro_content6: "Priority Email Support",
    publish_text_enterprise_pro_details6:
      "Priority support by dedicated account manager",
    publish_text_enterprise_pro_content7: "Multiple Events possible",
    publish_text_enterprise_pro_details7: "Multiple events under same app",
    publish_text_enterprise_pro_content8: "Custom 3rd Party Analytics",
    publish_text_enterprise_pro_details8:
      "Google Analytics, Flurry, or any 3rd Party of your choice",
    publish_text_enterprise_pro_content9: "Discounts on bulk events",
    publish_text_enterprise_pro_details9:
      "Ask for more discount for multiple events",

    publish_text_checkout: "Checkout",

    publish_stripe_error_expired_card: "The card has expired!",
    publish_stripe_error_card_declined: "The card has been declined!",
    publish_stripe_error_incorrect_cvc:
      "The card’s security code is incorrect!",
    publish_stripe_error_incorrect_number: "The card number is incorrect!",
    publish_stripe_error_invalid_expiry_month:
      "The card’s expiration month is incorrect!",
    publish_stripe_error_invalid_expiry_year:
      "The card’s expiration year is incorrect!",
    publish_stripe_error_invalid_number: "The card number is invalid!",
    publish_stripe_error_processing_error:
      "An error occurred while processing the card!",
    publish_stripe_error_sepa_unsupported_account:
      "Your account does not support SEPA payments!",
    publish_stripe_error_invalid_card_type: "The provided card is invalid!",

    publish_checkout_form_label_email: "Email",
    publish_checkout_form_label_card_details: "Card Details",

    publish_stripe_payment_success: "Congratulations, Payment was Successful!",
    publish_event_dashboard_text_things_to_do:
      "Things to do before publish your app!",
    publish_event_dashboard_text_content_sub_title:
      "Add records in all active contents!",

    // General
    general_building_with_eventify:
      DEVELOPMENT_TYPE === "eventify"
        ? "Building with Eventify"
        : "Building with Kochify",
    general_building_with_eventify_subtitle1:
      DEVELOPMENT_TYPE === "eventify"
        ? "With Eventify, it's extremely simple to put information right in your audience's hands, and it all starts here with our app builder."
        : "With Kochify, it's extremely simple to put information right in your audience's hands, and it all starts here with our app builder.",
    general_building_with_eventify_subtitle2:
      "With a few short steps, you'll have a complete app that can be published and ready to use.",
    general_name_of_your_event:
      DEVELOPMENT_TYPE === "eventify"
        ? "Name Of Your Event"
        : "Name of Your Platform",
    general_name_of_your_event_subtitle1:
      DEVELOPMENT_TYPE === "eventify"
        ? "Type in the official name of the event. It will be used as the name of the app."
        : "Type in the official name of the platform. It will be used as the name of the app.",
    general_event_name_description:
      DEVELOPMENT_TYPE === "eventify"
        ? "Event Name & Description"
        : "Platform Name & Description",
    general_event_name_description_subtitle1:
      DEVELOPMENT_TYPE === "eventify"
        ? "Is it a conference? A meeting? A workshop? Any other B2B event? Give your event a proper name and add a brief, easily understandable description for it. Make it easy for viewers to understand what your event is all about and decide whether to register accordingly."
        : "Give your platform a proper name, and add a brief, easily understandable description for it. Make it easy for viewers to understand what your platform is all about, and decide whether to register accordingly.",
    general_select_your_event_duration: "Select Your Event’s Duration",
    general_select_your_event_duration_subtitle1:
      "Click on the dates to specify your event dates. It will be displayed in the Event Overview. From small-scale, single day business meets, to B2B conferences and trade shows stretching up to 5 days, you can create an app for everything on Eventify.",
    general_privacy: "Privacy",
    general_privacy_subtitle1:
      "Do you want your event to show up when people are browsing? If yes, set your event as ‘public’. Conversely, mark your event as ‘private’, if people have to provide a password to sign in on the app. On Eventify, you have the final say on the privacy of your event.",
    general_timezone: "Timezone",
    general_timezone_subtitle1:
      "So, where is your next event taking place? Select the appropriate time zone from the dropdown list. Check the local time as per your timezone selection right there.",
    general_listing_privacy: "Listing Privacy",
    general_listing_privacy_subtitle1:
      "You get to decide whether to display your event listing on Eventify to everyone, or go with a private listing. If you want the listing to be active, simply select the 'Listing' option. If not, just click on 'Unlist'.",
    general_seocode_url: "Seocode URL",
    general_seocode_url_subtitle1:
      "Wish to customise the URL of the event website you create - in order to maximise organic traffic? On Eventify, you get to do just that. Simply click on the edit icon, and insert the URL that will optimise your website's SEO.",

    general_form_general_section: "General Information",
    general_form_privacy_seo_section: "Privacy & SEO Code URL",
    general_form_time_section: "Time & Duration",
    general_form_event_tags_section: "Event Tags",
    general_form_event_tags_subtext:
      DEVELOPMENT_TYPE === "eventify"
        ? "This allows users to easily find other users having similar interests."
        : "This allows users to easily find other users/courses having similar interests/tags.",
    general_form_label_event_name:
      DEVELOPMENT_TYPE === "eventify" ? "Event Name" : "Platform Name",
    general_form_label_event_validity:
      DEVELOPMENT_TYPE === "eventify" ? "Event Validity" : "Platform Validity",
    general_form_label_event_name_placeholder: "E.g google I/O 2017",
    general_form_label_event_description:
      DEVELOPMENT_TYPE === "eventify"
        ? "Event Description"
        : "Platform Description",
    general_form_label_event_description_placeholder:
      DEVELOPMENT_TYPE === "eventify"
        ? "Enter event description"
        : "Enter platform description",
    general_form_label_event_venue: "Venue",
    general_form_label_event_venue_placeholder: "Enter event Venue",
    general_form_label_seocode_url: "Seocode Url",
    general_form_label_seocode_url_note1:
      DEVELOPMENT_TYPE === "eventify"
        ? "Changing the url here may affect your ticket link"
        : "Changing the url here may effect your plan link",
    general_form_label_event_seocode_not_available: "Seo is not available!",
    general_form_label_event_duration: "Duration",
    general_form_label_event_duration_notes:
      "You can’t update the dates once your event has started.",
    general_form_label_event_timezone: "Timezone",
    general_form_label_event_timezone_model_header: "Change Timezone",
    general_form_label_event_timezone_select_timezone: "Select Timezone",
    general_form_label_event_timezone_time_message:
      "The current time as per timezone is",
    general_form_label_global_timezone: "Global Timezone",
    general_form_label_event_converted_timezone_on_app:
      "My Event is Global, convert timezone on app",
    general_form_label_event_day: "Days",
    general_form_label_event_publish:
      DEVELOPMENT_TYPE === "eventify"
        ? "Publish your event"
        : "Publish your plan",
    general_form_label_event_privacy: "App Privacy",
    general_form_label_event_privacy_option_public: "Public",
    general_form_label_event_privacy_option_private: "Private",
    general_form_label_listing_privacy: "Listing Privacy",
    general_form_label_event_listing_option1: "Listed",
    general_form_label_event_listing_option2: "Un-listed",
    general_form_label_event_name_error1:
      DEVELOPMENT_TYPE === "eventify"
        ? "Event name is required"
        : "Platform name is required",
    general_form_label_event_venue_error1: "Venue is required",
    general_form_label_event_seocode_error1: "Seocode is required",

    // Features
    features_text_modules: "Modules",
    features_text_contents: "Contents",
    features_users_modules_confirmation_title_alert: "Alert",
    // Abstract is removed for now from eventify message
    features_users_modules_confirmation_text_continue:
      DEVELOPMENT_TYPE === "eventify"
        ? "If you remove Users, then Ticket, Poll & Live QA, Gamification, Help & Support, Community, Social, Messages, Survey, Attendee and Bottom Menu Scanner will also be automatically removed."
        : "If you remove Users, then Ticket, Activity and Messages will also be automatically removed.",
    features_users_feature_confirmation_text_continue:
      "If you remove Message, then Attendee will also be automatically removed.",
    features_text_add_user_first: "Add users module first!",
    feature_confirmAlert_removingSponsor_title:
      "Are you sure you want to disable sponsor?",
    feature_confirmAlert_removingSponsor_message:
      "Disabling sponsor will disable all banners related to the sponsors",
    feature_confirmAlert_addSponsor_title: "Add Sponsor",
    feature_confirmAlert_addSponsor_message:
      "Adding sponsor will bring back all related banners",
    feature_confirmAlert_removingExhibitor_title:
      "Are you sure you want to disable exhibitor?",
    feature_confirmAlert_removingExhibitor_message:
      "Disabling exhibitor will disable all banners related to the exhibitors",
    feature_confirmAlert_addExhibitor_title: "Add Exhibitor",
    feature_confirmAlert_addExhibitor_message:
      "Adding exhibitor will bring back all related banners",

    // ========= Branding =========
    branding_app_branding_tab: "App Branding",
    branding_web_branding_tab: "Web Branding",
    branding_app_menu_tab: "App Menu",
    branding_splash_tab: "Splash Screen",
    branding_event_icon:
      DEVELOPMENT_TYPE === "eventify" ? "Event logo" : "Icon",
    branding_event_icon_info:
      "The icon should be in png format. Minimum 256px wide by 256px tall",
    branding_event_cover:
      DEVELOPMENT_TYPE === "eventify" ? "Brand cover" : "Cover",
    branding_event_cover_info:
      "The image should be in png format. Minimum 1920px wide by 1080px tall",
    branding_upload_icon_notes1: "The icon should be in jpeg format",
    branding_upload_icon_notes2: "Minimum 256px wide by 256px tall",
    branding_upload_icon_notes3: "1920 px wide and 1080 px tall recommended",
    branding_upload_icon_notes4: "Adjust the image position while uploading",
    branding_color_theme: "Color Theme",
    branding_color_theme_info:
      "Select a color from the palette or enter your own",
    branding_color_theme_subtitle1:
      "Based on your logo, we have extracted the prominent color palette. Select a color from the palette or enter your own.",
    branding_app_side_menu: "App Side Menu",
    branding_app_side_menu_info: "Rearrange the icon in order",
    branding_app_side_menu_subtitle:
      "Hold and drag to rearrange the icon in order",
    branding_app_bottom_menu: "Bottom Menu",
    branding_app_bottom_menu_subtitle:
      "Select bottom menu items from drop down.",

    // Splash
    branding_splash_ios_title: "iOS Splash Screen",
    branding_splash_ios_subtitle:
      "Please upload the splash screen as per given sizes.",
    branding_splash_android_title: " Android Splash Screen",
    branding_splash_android_subtitle:
      "Please upload the splash screen as per given sizes.",

    // Website
    // ========= Wizard =========
    website_wizard_tab_1: "Overview",
    website_wizard_tab_2: "Install URL",
    website_wizard_tab_3: "Theme",
    website_wizard_tab_4: "Publish",

    website_submenu_title1: "Dashboard",
    website_submenu_description1: "Dashboard",
    website_submenu_title2: "Theme",
    website_submenu_description2: "Manage Theme",
    website_submenu_title3: "Settings",
    website_submenu_description3: "Manage Theme Settings",
    website_submenu_title4: "Wizard",
    website_submenu_description4: "Publish your Website",
    website_submenu_title5: "Domains",
    website_submenu_description5: "Manage domains",
    website_submenu_title6: "Upgrade",
    website_submenu_description6: "Manage Plans",
    website_submenu_title7: "Pages",
    website_submenu_description7: "Manage Pages",
    website_submenu_title8: "Menu",
    website_submenu_description8: "Manage Menu",
    website_submenu_title9: "SEO",
    website_submenu_description9: "Manage SEO",

    website_dashboard_text_your_event_live: "Your Event Website is NOW LIVE!",
    website_dashboard_text_your_event_live_sub_title:
      "Share it with your target attendees to maximise its reach.",
    website_dashboard_text_website_live_now: "Event Website...NOW LIVE!",
    website_dashboard_text_things_to_do_for_website:
      "Things to do for building event website",
    website_dashboard_text_things_to_do_1: "Multiple Website Themes",
    website_dashboard_text_things_to_do_1_sub_title:
      "Preview and select a web theme to get started.",
    website_dashboard_text_things_to_do_2: "Website Settings",
    website_dashboard_text_things_to_do_2_sub_title:
      "Fill up the fields under Settings.",

    website_theme_text_template: "Template",
    website_theme_text_template_sub_title:
      "Would you like to select this template? Continue",
    website_theme_selected_new_success: "Selected template added successfully!",
    website_theme_updated_new_success:
      "Selected template updated successfully!",
    website_theme_selected_depolying_error:
      "Something went wrong while deploying!",
    website_theme_text_template_preview: "Template Preview",

    website_setting_text_website_available_address:
      "Website is available at this address",
    website_setting_form_label_title: "Title",
    website_setting_form_ph_title: "ex: techshow2019",
    website_setting_text_warning_not_allow_special_char:
      "Title can not have special characters",
    website_setting_form_label_domain_name: "Domain Name",
    website_setting_form_ph_domain_name: "ex: techshow",
    website_setting_form_label_website_url: "Website Url",
    website_setting_text_domain_available: "Domain available",
    website_setting_text_domain_not_available: "Domain not available",
    website_setting_form_label_meta_keywords: "Meta Keywords",
    website_setting_form_ph_meta_keywords: "Add meta keywords for website",
    website_setting_text_warning_add_meta_key:
      "Add comma separated values ex: business,tech event,technology",
    website_setting_form_label_meta_description: "Meta Description",
    website_setting_form_ph_meta_description: "Type meta description",
    website_setting_form_label_want_email_on_contact_query:
      "Do you want to get email when receive any contact query?",
    website_setting_form_validation_required: "Required",
    website_setting_form_validation_title_not_allow_special_char:
      "Title cannot contain special characters",
    website_setting_form_validation_domain_not_allow_special_char:
      "Domain cannot contain special characters",
    website_setting_form_validation_domain_not_available:
      "Domain is not available, please modify the domain",
    website_setting_text_deploying_process_creating_template:
      "Creating Template..",
    website_setting_text_deploying_process_preparing_template:
      "Preparing Template..",
    website_setting_text_deploying_process_deploying_template:
      "Deploying Template..",
    website_setting_text_deploying_process_almost_done: "Almost Done..",
    website_setting_text_deploying_process_finish: "Finishing..",
    website_setting_text_setting_update_success:
      "Website setting update successfully.",
    website_setting_text_select_template_befor_setting_error:
      "Select a template first, in order to be able to change the website setting.",

    website_contact_form_text_website_contact_response:
      "Website Contact Responses",
    website_contact_form_teable_th_responses: "Responses",
    menu_website_first_heading: "Header Preview",
    menu_website_logo_title: "yogovana",
    menu_website_heading_controls: "Header Controls",
    menu_website_heading_controls_fixed_top: "Fixed at Top",
    menu_website_heading_controls_header_height: "Header Height (px)",
    menu_website_heading_controls_background_color: "Background Color",
    menu_website_heading_controls_text_color: "Text Color",
    menu_website_heading_links: "Header Links",
    menu_website_footer_preview: "Footer Preview",
    website_pages_heading: "Pages",
    website_pages_subheading: "Total 7 Pages",
    seo_website_header: "Site Map",
    seo_website_sitemap_header: "Xml Site Map",
    seo_website_sitemap_view: "View Site Map",
    seo_website_homepage: "Homepage SEO",
    seo_homepage_pagetitle: "Page Title",
    seo_homepage_pagedescription: "Page Description",
    seo_homepage_seokeywords: "Seo Keywords (Use Comma)",
    seo_website_coursepage: "Course Page SEO",
    website_settings: "Website Settings",
    website_settings_sitename: "Site Name",
    website_settings_sitefavicon: "Site Favicon[16x16 or 32x32]",
    website_settings_headerlogo: "Header Logo",
    website_settings_footerlogo: "Footer Logo",
    website_settings_changetemplate: "Change Template",
    new_page_title: "Title of New Page",
    new_page_title_placeholder: "Enter Title",
    new_page_url: "Url of New Page(Use / before giving url)",
    new_page_url_placeholder: "Enter Url",
    showsuccess_modal_savemessage: "Title and URL Saved Successfully",
    site_favicon: "Site Favicon[16x16 or 32x32]",

    // Content
    // -------------Common------------ //
    content_community_users_update_button: "Save",
    content_common_text_delete_associated_user_confirm:
      "Also, if you want to delete the associated users, please select the checkbox & continue",
    content_common_text_delete_associated_user: "Delete all associated users?",
    content_common_text_delete_associated_user_note:
      "Note: If the associated users are deleted, they will lose access to the whole event.",
    content_image_upload_error: "There was an error uploading image!",
    content_something_wrong: "Something is wrong",
    content_delete: "Delete",
    content_ok: "OK",
    content_cancel: "CANCEL",
    content_image_dlt_successfully: "Image deleted successfully!",

    // -------------Schedule------------ //
    schedule_text_addtracks: "Add Tracks",
    schedule_addtrack: "Add Track",
    schedule_notrack: "No Track",
    schedule_add_modal_title:
      DEVELOPMENT_TYPE === "eventify" ? "Add Track Session" : "Add Live Class",
    schedule_edit_modal_title:
      DEVELOPMENT_TYPE === "eventify"
        ? "Edit Track Session"
        : "Edit Live Class",
    schedule_track_form_label_name: "Track Name",
    schedule_track_form_ph_name: "Enter track name",

    schedule_form_liveclass_banner: "Live Class Banner",
    schedule_form_label_sessiondate: "Session Date",
    schedule_form_label_track: "Choose Track",
    schedule_form_ph_track: "Select track",
    schedule_form_label_title:
      DEVELOPMENT_TYPE === "eventify" ? "Session Title" : "Class Title",
    schedule_form_ph_title:
      DEVELOPMENT_TYPE === "eventify"
        ? "Enter session title"
        : "Enter class title",
    schedule_label_location: "Session Location",
    schedule_placeholder_location: "Enter session location",
    schedule_label_starttime: "Start Time",
    schedule_placeholder_starttime: "Choose start time",
    schedule_label_endtime: "End Time",
    schedule_placeholder_endtime: "Choose end time",
    schedule_form_label_checkintype: "Checkin Type",
    schedule_form_checkintype_option1: "No check-in needed",
    schedule_form_checkintype_option2: "Self check-in",
    schedule_form_checkintype_option3: "Scan qr",
    schedule_form_checkintype_option4: "Show qr",
    schedule_form_checkintype_option5: "Scan QR check-in",
    schedule_form_label_sendpush: "Send Push Before Session Start",
    schedule_form_ph_sendpush: "Select time",
    schedule_form_label_color: "Session color",
    schedule_form_label_tags: "Session Tags",
    schedule_form_ph_color: "Choose session color",
    schedule_form_label_tags: "Session Tags",
    schedule_form_label_pushmessage: "Push Message",
    schedule_form_ph_pushmessage: "Enter push message",
    schedule_form_label_speaker:
      DEVELOPMENT_TYPE === "eventify" ? "Choose Speaker" : "Choose Instructor",
    schedule_form_ph_speaker:
      DEVELOPMENT_TYPE === "eventify" ? "Select speaker" : "Select instructor",
    schedule_form_text_speaker_related:
      DEVELOPMENT_TYPE === "eventify"
        ? "Note - No speakers are available. You can add the speakers later and map them."
        : "Note - No instructor available, you can add the instructor later and map them..",
    schedule_form_label_description: "Description",
    schedule_form_ph_description: "Enter session description",
    schedule_form_text_additional_settings: "Additional Settings",
    schedule_form_label_capacity: "Capacity",
    schedule_form_label_unlimited: "Unlimited",
    schedule_form_ph_capacity:
      DEVELOPMENT_TYPE === "eventify"
        ? "Enter session capacity"
        : "Enter class capacity",
    schedule_form_label_session_type: "Session Type",
    schedule_form_label_session_type_option1:
      DEVELOPMENT_TYPE === "eventify"
        ? "General & Public ( Visible to every attendee on the platform )"
        : "General & Public ( Visible to every attendee on the platform )",
    schedule_form_label_session_type_option2:
      DEVELOPMENT_TYPE === "eventify"
        ? "General & Private ( Visible to attendees added by host manually )"
        : "General & Private ( Visible to attendees added by host manually )",
    schedule_form_label_session_type_option3:
      DEVELOPMENT_TYPE === "eventify"
        ? "With Ticket & Public ( Visible to all, but only available to who has a valid ticket )"
        : "With Ticket & Public ( Visible to all, but only available to who has a valid ticket )",
    schedule_form_label_session_type_option4:
      DEVELOPMENT_TYPE === "eventify"
        ? "With Ticket & Private ( Visible to only valid ticket holder attendee )"
        : "With Ticket & Private ( Visible to only valid ticket holder attendee )",
    schedule_form_label_fee:
      DEVELOPMENT_TYPE === "eventify" ? "Session Fee" : "Class Fee",
    schedule_form_ph_fee:
      DEVELOPMENT_TYPE === "eventify" ? "Enter session fee" : "Enter class fee",
    schedule_form_label_allowreassign: "Allow Reassign",
    schedule_form_label_allowreassign_text:
      DEVELOPMENT_TYPE === "eventify"
        ? "By allowing this, the user can change his session at any time"
        : "By allowing this user can change his class at any time",
    schedule_form_label_association: "Ticket Association",
    schedule_form_ph_association: "Select Tickets",
    schedule_form_label_rsvp:
      "RSVP (Users must RSVP to the session before they can access)?",
    schedule_form_note_loggedinuser:
      DEVELOPMENT_TYPE === "eventify"
        ? "Note: Only logged in users will be able to view / participate in all session videos."
        : "Note: Only logged in users will be able to view / participate in all class videos.",
    schedule_form_label_videomeet: "Eventify video meet?",
    schedule_form_label_main_video:
      DEVELOPMENT_TYPE === "eventify"
        ? "Session Youtube Live URL / Zoom ID"
        : "Class Youtube Live URL / Zoom ID",
    schedule_form_ph_main_video:
      "Enter session Youtube live video url or zoom id",
    schedule_form_label_restricttime: "Restrict Start Time",
    schedule_form_label_othervideo_links: "Other Video Links",
    schedule_form_ph_othervideo_links: "Enter another video",
    schedule_form_label_file_upload: "File Upload",
    schedule_form_validation_end_time_greater_start_time:
      "End time should be greater than start time",
    schedule_form_add_success: "Session added successfully!",
    schedule_form_update_success: "Session updated successfully!",

    schedule_code: "Code",
    schedule_embed_code: "Embed Code",
    schedule_label_name: "Name",
    schedule_total: "Total:",

    schedule_sessionqr_download_title: "Download",
    schedule_sessionqr_download_subtitle: "Would you like to download?",

    schedule_validation_track_required: "Please choose/add a Track!",
    schedule_validation_ticketadditional:
      "Select at least one ticket for 'With Ticket' type session / select 'General' type session!",
    schedule_validation_validfee: "Please select a valid fee!",
    schedule_validation_push_message_required: "Please add a push message!",
    schedule_track_added: "Track added successfully!",
    schedule_track_updated: "Track updated successfully!",
    schedule_capacity_exceed:
      "This session capacity is full, please increase the session capacity",
    schedule_rsvp_capacity_exceed:
      "This session RSVP users' capacity is full, please increase the session capacity",
    schedule_delete_message:
      "This will permanently delete the session. Continue?",
    schedule_delete_failed: "Delete failed due to error!",
    schedule_successfully_deleted: "Session deleted successfully!",

    schedule_import_header: "Import Schedule",
    schedule_import_download_template_subtitle:
      "Download and complete the provided template. Upload the completed template when you're ready",
    schedule_import_validation1: "Could not parse the file.",
    schedule_import_validation2:
      "The CSV / XLS file format is non-compatible or the data is not well formatted. Please refer to the template",
    schedule_import_validation3:
      "The CSV / XLS file is empty, Please add some data",
    schedule_import_validation4: "Import was failed, try again!",
    schedule_import_validation5: "Import data is invalid!",
    schedule_import_date_invalid: "Date is not between the event date",
    schedule_import_track_notrack_validation:
      "For same session date you can add either notrack or normal track.",
    schedule_import_note_date_format: "Use date format YYYY-MM-DD",
    schedule_import_note_time_format: "Use time format HH:MM",
    schedule_import_note_notrack1:
      "If you want no track for a particular data, use the key 'notrack' under track column.",
    schedule_import_note_notrack2:
      "If you want no track for a particular date and that date already have tracks, then change to no track first, then import you data.",
    schedule_import_note_color:
      "Please select the session color from the given options: #C2FFC4,#FDAFBD,#90E6F3,#F0D9BC,#FDC4F8,#C5CEFC,#D8C5FC,#FBCBB2,#E0E0E0,#F2F2F2.",
    schedule_import_note_tags:
      "Please use session tags from General > Event Tags. If you are using multiple tags, separate them with a comma.",
    schedule_import_note_speakers:
      "Only matched (comma separated) speakers from your speaker list, will be associated with the session.",
    schedule_import_note_sentpush_time:
      "Please add any value from the given options (minutes): 5,10,15,20,25,30 for sending push befor the session time.",
    schedule_import_text_action_on_uploaded_data:
      "Duplicate Data(By Date, Track, Title) in Schedule will be",
    schedule_import_success: "Schedule imported successfully!",
    schedule_import_starttime_greater_than_endtime_error_string:
      "Endtime is less than StartTime",

    schedule_button_deleteall: "Reset",
    schedule_button_deleteall_sessions: "Delete Sessions only",
    schedule_button_deleteall_tracks: "Delete Tracks with Sessions",
    schedule_button_dropdown_title_import_edit: "Quick Actions",
    schedule_button_dropdown_import: "Import Schedules from excel",
    schedule_button_dropdown_bulk_edit: "Edit Schedules in bulk",
    session_title_delete: "Delete All Sessions",
    session_text_are_you_sure_delete:
      "Are you sure you want to delete? This will delete all the sessions.",
    session_message_deleted: "Sessions deleted successfully!",

    track_title_delete: "Delete All Tracks & Sessions",
    track_text_are_you_sure_delete:
      "Are you sure you want to delete? This will delete all the tracks with related sessions.",
    track_message_deleted: "Tracks & Sessions deleted successfully!",

    schedule_track_required_confirm_title: "Track required",
    schedule_track_required_confirm_subtitle:
      "Would you like keep track mandatory. Continue?",
    schedule_no_track_confirm_title: "No track",
    schedule_no_track_confirm_subtitle:
      "Would you like to remove track? It will delete all tracks from the selected date. Continue?",

    schedule_modal_bulkedit_title: "Schedule Bulk Edit",
    schedule_modal_bulkedit_sessiontype_opt_public: "General & Public",
    schedule_modal_bulkedit_sessiontype_opt_private: "General & Private",
    schedule_modal_bulkedit_success_track:
      "Successfully created new tracks! Processing schedules.",
    schedule_modal_bulkedit_error_track:
      "Sorry, new tracks could not be created.",
    schedule_modal_bulkedit_success_1: "Successfully Updated Schedules!",
    schedule_modal_bulkedit_success_11:
      "Successfully Updated Schedules and Speakers!",
    schedule_modal_bulkedit_success_10:
      "Updated Schedules but could not update Speakers.",
    schedule_modal_bulkedit_success_00: "Sorry, could not Update Schedules.",
    schedule_modal_bulkedit_success_create: "Successfully Created Schedules!",
    schedule_modal_bulkedit_error_create: "Sorry, could not Create Schedules.",
    schedule_modal_bulkedit_success_11_create:
      "Successfully Updated Schedules and Speakers and Createed new Schedules.",
    schedule_modal_bulkedit_error_11_create:
      "Updated Schedules and Speakers but could not Create new Sessions.",

    // -------------Exhibitor------------ //
    content_exhi_text_delete_exh:
      "This will permanently delete the Exhibitor. Continue?",
    content_exhi_text_delete_exh_and_addBanner:
      "Note: Deleting the exhibitor will delete all associated advertisement banners",
    content_exhi_error_Associated_user:
      "Something is wrong with the associated users",
    content_exhi_deleted_successfully: "Exhibitor deleted successfully",

    // -------------Sponsor------------ //
    content_spon_text_delete_spo:
      "This will permanently delete the Sponsor. Continue?",
    content_exhi_text_delete_sponsor_and_addBanner:
      "Note: Deleting the sponsor will delete all associated advertisement banners",

    // -----------Gallery-------------//
    content_preparing_gallery: "Preparing Gallery",
    content_gallery_dlt_message:
      "This will permanently delete the Image. Continue?",

    // -------------Speaker------------ //
    content_spea_text_delete_spe:
      "This will permanently delete the Speaker. Continue?",

    // -------------Event Guide------------ //
    eventguide_modal_text_header: "Event Guide",
    content_text_preparing_eventguide: "Preparing Event Guide...",
    eventguide_list_text_category: "Category",
    eventguide_list_text_title: "Title",
    eventguide_list_text_type: "Type",
    eventguide_list_text_action: "Action",
    eventguide_title_text_add: "Add Event Guide",
    eventguide_title_text_edit: "Edit Event Guide",
    eventguide_form_label_category: "Category",
    eventguide_form_ph_category: "Enter or select category",
    eventguide_form_label_title: "Title",
    eventguide_form_ph_title: "Enter title",
    eventguide_form_label_type: "Type",
    eventguide_form_ph_type: "Select content type",
    eventguide_form_label_content: "Content",
    eventguide_form_php_content: "Enter content here",
    eventguide_form_label_weblink: "Web Link",
    eventguide_form_ph_weblink: "Enter website link",
    eventguide_form_updated_success: "Event Guide updated successfully!",
    eventguide_icon: "Guide Icon",
    select_guide_icon_text: "or Select from Library",

    content_chooser_delete_eventguide_title: "Delete Event Guide",
    content_chooser_delete_eventguide_message:
      "This will permanently delete the Event Guide. Continue?",
    content_eventguide_form_success: "Event Guide deleted successfully...",

    // ------------ Maps ------------------- //
    content_text_preparing_map: "Preparing Maps...",
    content_map_list_name: "Name",
    content_map_list_action: "Action",
    content_map_list_type: "Type",
    content_map_interactive: "Interactive Map",
    content_map_location: "Location Map",
    content_map_change_map: "Change Map",
    content_map_change_map_background: "Change Map Background",
    content_map_add_booth: "Add Booth",

    // ------------ Support Chat ------------------- //
    content_text_plotting_chat: "Preparing Support Chats...",
    content_text_loading_chats: "Loading Support Chats...",
    yesterday: "Yesterday",
    chat_thread_nocontent_header: "No Conversation!",
    chat_thread_nocontent_subheader:
      "Messages will appear once they are sent by users.",
    support_chat_file_limit: "File uploaded cannot exceed the limit of ",
    validation_file_type_invalid: "Invalid file type",
    supportchat_tooptip_message_text: "Messages",
    supportchat_tooptip_scrolldown_text: "Scroll Down",
    email_is_not_registered: "This email is not registered",
    support_edit_user_btn: "Edit User",

    // -------------Community------------ //
    content_community_table_th_tagname: "Community Name",
    content_community_table_th_tagtype: "Community Type",
    content_community_table_th_postcount: "Posts",
    content_community_table_th_commentcount: "Comments",
    content_community_table_th_action: "Actions",
    content_community_text_delete_subtitle:
      "This will permanently delete the community and related posts. Continue?",
    content_community_delete_success: "Community deleted successfully!",
    content_community_form_title_add: "Add Community",
    content_community_form_title_edit: "Update Community",
    content_community_form_label_icon: "Icon",
    content_community_form_label_icon_size_text:
      "Drag and drop to upload. Recommended icon size 84x84 px.",
    content_community_form_label_name: "Community Name",
    content_community_form_ph_name: "Enter community name",
    content_community_form_label_desc: "Description",
    content_community_form_ph_desc: "Enter about community",
    content_community_form_label_type: "Community Type",
    content_community_form_ph_type: "Select community type",
    content_community_form_label_type_option1: "Post",
    content_community_form_label_type_option2: "Group",
    content_community_form_label_post_permission: "Only admin can post/comment",
    content_community_form_label_category: "Community Category",
    content_community_form_category_option1: "Public",
    content_community_form_category_option2: "Private",
    content_community_form_save_success: "Community saved successfully!",
    content_community_form_save_image_error:
      "There was an error uploading image!",
    content_community_validation_for_atleast_one_selection: "No User Selected!",

    content_community_manage_members_accpected: "Accepted",
    content_community_manage_members_requested: "Requested",
    content_community_manage_members_removed: "Removed",
    content_community_manage_members_left: "Left",
    content_community_manage_members_rejected: "Rejected",
    content_community_total_members: "Total members:",

    // -------------Advertisement------------ //
    advt_modal_th_name: "Name",
    advt_modal_th_screen: "Display Screen",
    advt_modal_th_action: "Action",
    advt_modal_title_add: "Add Advertisement",
    advt_modal_title_edit: "Edit Advertisement",
    advt_form_label_name: "Advertisement Name (for internal use)",
    advt_form_ph_name: "Enter advertisement Name",
    advt_form_label_screen: "Display Screen",
    advt_form_screen_option1: "Overview Inline",
    advt_form_screen_option2: "Side Menu",
    advt_form_screen_option3: "Splash Screen",
    advt_form_screen_option4: "Home Screen Popup",
    advt_form_label_advt_display: "Display Advertisement",
    advt_form_advt_display_option1: "always",
    advt_form_advt_display_option2: "once",
    advt_form_label_banner: "Banner",
    advt_form_label_external_link: "External Link",
    advt_form_ph_external_link: "External Link",
    advt_form_label_internal_link: "Internal Link",
    advt_form_ph_internal_link: "Select internal link",
    advt_form_label_linked_user: "Link to Particular",
    advt_form_ph_linked_user: "Select from list",
    advt_form_label_frequency: "Frequency (in sec)",
    advt_form_ph_frequency: "Enter frequency time",
    advt_form_validation_link_required:
      "External link or Internal link required",
    advt_form_validation_link_invalid: "Invalid external link url",
    advt_form_validation_min_frequency: "Frequency must be greater than 0",
    advt_form_banner_fail_alert: "Banner not uploaded, try again!",
    advt_form_success_alert: "Advertisement updated successfully!",
    advt_delete_confirmation_text:
      "This will permanently delete the Advertisement. Continue?",
    advt_delete_success_alert: "Advertisement deleted successfully!",
    advt_banner_disabled: "Banner is disabled",

    // User
    // -------------Wizard------------ //
    user_reg_wizard_tab_1: "Organization Details",
    user_reg_wizard_tab_2:
      DEVELOPMENT_TYPE === "eventify" ? "Create Ticket" : "Create Plan",
    user_reg_wizard_tab_3: "Checkout Forms",
    user_reg_wizard_tab_4: "Session",
    user_reg_wizard_tab_5: "Publish",

    user_tab_basic_details: "Basic Details",
    user_tab_other_details: "Other Details",
    user_tab_access_permission: "Access Permission",
    user_tab_access_private_docs: "Private Docs",
    user_tab_access_badges: "Badge",
    user_table_list_name: "Name",
    user_table_list_checked_in_status: "Check-in Status",
    user_table_list_added_on_date: "Added on",
    user_table_list_mark_approved: "Mark Approved",
    user_table_list_reset_password: "Reset Password",
    user_table_list_action: "Action",
    user_table_list_groups: "Groups",
    user_waitlist_type_all: "All",
    user_waitlist_type_confirmed: "Confirmed",
    user_waitlist_type_waiting: "Waitlist",
    user_waitlist_type_inactive: "Inactive",
    user_counting_per_page: "startnum - endnum out of totalnum users",
    user_option_select_all: "Select All",
    user_export_option_csv: "Export excel",
    user_export_option_pdf: "Export pdf",
    user_export_text_export_user: "Export User",
    user_export_text_export_user_csv:
      "Do you want to download the Excel file for the users? To proceed, click the download button. Depending on the number of users, it might take a little longer. ",
    user_export_text_export_user_csv_downloading:
      "Preparing the data... Excel file will be available soon.",
    user_export_text_export_user_pdf:
      "Do you want to download the Excel file for the users? Select the options you want to print on each tag.",
    user_export_pdf_form_landscape: "Landscape Tag",
    user_export_pdf_form_portrait: "Portrait Tag",
    user_export_pdf_form_fname: "Firstname",
    user_export_pdf_form_lname: "Lastname",
    user_filterby_option_checkindin: "Checked-In",
    user_option_send_welcome_email_selected:
      "Send welcome email to selected confirmed users",
    user_option_send_waitlist_email_selected:
      "Send waitlist email to selected waitlisted users",
    user_option_move_user_to_waitlist_selected:
      "Move selected users to wait list",
    user_option_move_user_to_inactive_selected:
      "Move selected users to inactive list",
    user_option_move_user_to_confirmed_selected:
      "Move selected users to confirmed list",
    user_option_move_user_to_waitlist_with_email_selected:
      "Move selected users to wait list and send email",
    user_option_move_user_to_confirmed_with_email_selected:
      "Move selected users to confirmed list and send email",
    user_option_delete_selected: "Delete selected users",
    user_option_checkin_selected: "Check-in selected users",
    user_option_checkout_selected: "Check-out selected users",
    user_action_validation_you_cannot_delete_yourself:
      "You cannot delete yourself, deselect yourself.",
    user_action_validation_you_cannot_delete_superadmin:
      "You cannot delete super admin, unselect #superdamin.",
    user_action_validation_you_cannot_waitlist_inactive_yourself:
      "You cannot put yourself on waitlist/inactive list, deselect yourself.",
    user_action_validation_you_cannot_waitlist_inactive_superadmin:
      "You cannot put super admin on waitlist/inactive list, deselect #superdamin.",
    user_action_validation_you_cannot_waitlist_yourself:
      "You cannot put yourself on waitlist, deselect yourself.",
    user_title_delete_users: "Delete Users",
    user_text_are_you_sure_delete:
      "Are you sure you want to delete #total user(s)?",
    user_title_checkin_users: "Check-in Users",
    user_text_are_you_sure_checkin:
      "Are you sure you want to check-in #total users?",
    user_title_checkout_users: "Check-out Users",
    user_text_are_you_sure_checkout:
      "Are you sure you want to check-out #total users?",
    user_text_are_you_sure_delete_all_other:
      "Are you sure you want to delete all other users?",
    user_text_permanently_delete_user:
      "This will permanently delete the user. Continue?",
    user_text_select_all_usera: "Select all #total users",
    user_text_clear_all_selected_users: "Clear all selected users",
    total_loggedin_usercount: "Total Logged in User Count:",
    user_text_total_selected_user: "Total #total user(s) are selected",
    user_text_all_users_selected: "All #total users are selected",
    user_message_user_deleted: "Users deleted successfully!",
    user_message_user_access_allowed: "Access allowed successfully!",
    user_message_user_marked_checked_in: "User(s) marked as checked-in!",
    user_message_user_marked_checked_out: "User(s) marked as checked-out!",
    user_message_user_marked_approved: "User marked as approved!",
    user_message_welcome_email_sent: "Welcome email sent successfully!",
    user_message_welcome_email_error1: "User is not in active mode!",
    user_message_welcome_email_error2: "Your plan validity is not started yet!",
    user_validation_message_welcome_email_sent:
      "No user status found as confirmded from selected users.",
    user_validation_message_waitlist_email_sent:
      "No user status was found as waiting from selected users.",
    user_title_move_user_to_confirmed: "Move selected users to confirmed list",
    user_subtitle_move_user_to_confirmed:
      "Do you want to move selected users to confirmed list?",
    user_message_move_user_to_confirmed_success:
      "Selected users moved to confirmed list successfully!",
    user_title_move_user_to_waitlist: "Move selected users to waiting list",
    user_subtitle_move_user_to_waitlist:
      "Do you want to move selected users to waiting list?",
    user_message_move_user_to_waitlist_success:
      "Selected users moved to the waiting list successfully!",
    user_title_move_user_to_inactive: "Move selected users to inactive list",
    user_subtitle_move_user_to_inactive:
      "Do you want to move the selected users to inactive list?",
    user_message_move_user_to_inactive_success:
      "Selected users moved to inactive list successfully!",
    user_message_user_imageupload_error: "Image not uploaded successfully!",
    user_message_user_added: "User added successfully!",
    user_message_user_updated: "User updated successfully!",
    user_note_create_dynamic_form:
      "Please create the dynamic form under 'Tickets->Settings'",
    user_validation_required: "Required",
    user_validation_name_cannot_contain_special_char:
      "Name can not contain special characters",
    user_validation_invalid_email: "Invalid email",
    user_validation_invalid_facebook_link:
      "Enter valid url e.g https://facebook.com/",
    user_validation_invalid_twitter_link:
      "Enter valid url e.g https://twitter.com/",
    user_validation_invalid_linkedin_link:
      "Enter valid url e.g https://linkedin.com/",
    user_validation_invalid_instagram_link:
      "Enter valid url e.g https://instagram.com/",
    user_validation_invalid_website_link:
      "Enter a valid url that starts with https://",
    user_form_label_passcode: "Passcode",
    user_form_text_see_passcode: "See Passcode",
    user_form_text_no_passcode: "No Passcode",
    user_form_label_profile: "Profile Image",
    user_form_label_profile_cover: "Profile Cover Image",
    user_form_label_name: "Name",
    user_form_label_email: "Email",
    user_form_label_firstname: "First Name",
    user_form_label_lastname: "Last Name",
    user_form_label_primary_category: "User Primary Group",
    user_form_label_ph_primary_category: "Select user primary group",
    user_form_label_other_category: "User Other Group",
    user_form_label_ph_other_category: "Select user other group",
    user_form_label_category: "User Group",
    user_form_label_category_placeholder: "Select user group",
    user_form_text_category_info:
      "You may choose multiple categories. The first tag will be displayed on the apps.",
    user_form_label_password: "Admin Panel Access Password",
    user_form_label_password_placeholder:
      "Enter the password for admin panel access",
    user_form_label_interest: "Interests",
    user_form_label_addedon: "Added On",
    user_form_label_added_by: "Added By",
    user_form_label_added_by_option1: "Admin",
    user_form_label_added_by_option2: "Ticket",
    user_form_label_added_by_option3: "Open Registration",
    user_form_label_added_by_option4: "Abstract",
    user_form_label_added_by_option5: "Api",
    user_form_label_userwaitlistmode_option1:
      "Check this if you want to move the user to the waitlist list",
    user_form_label_userwaitlistmode_option2:
      "Uncheck this if you want to move the user in confirm list",
    user_form_label_user_status: "User Status",
    user_form_label_user_status_option1: "Confirmed",
    user_form_label_user_status_option2: "Waitlist",
    user_form_label_user_status_option3: "Inactive",
    user_form_label_send_email: "Would you like to send email?",
    user_form_label_create_speaker: "Add as a speaker too?",
    user_form_text_user_push_subscribed: "Push Subscribed",
    user_form_label_speaker: "Speaker",
    user_form_label_speaker_placeholder: "Search and select speaker",
    user_form_label_sponsor: "Sponsor",
    user_form_label_sponsor_placeholder: "Search and select sponsor",
    user_form_label_exhibitor: "Exhibitor",
    user_form_label_exhibitor_placeholder: "Search and select exhibitor",
    user_import_header: "Import Users",
    user_import_validation1: "Could not parse the file.",
    user_import_validation2:
      "The CSV / XLS file contains 1 or more invalid email ids",
    user_import_validation3:
      "The CSV / XLS file contains 1 or more duplicate entries",
    user_import_validation4:
      "The CSV / XLS file format is non-compatible or the data is not well formatted. Please refer to the template",
    user_import_validation5: "Import was failed, try again!",
    user_import_validation6:
      "The CSV / XLS file is empty, Please add some data",
    user_import_validation7: "Invalid profile URL",
    user_import_validation8: "Invalid user category",
    user_import_validation9:
      "Your email id cannot be changed to any other category except admin.",
    user_import_validation10: "Invalid user status",
    user_import_error_rows_message:
      "Below rows have some data errors, you can check it on mouse hover over the exclamation(!) icon",
    user_message_user_imported: "User imported successfully!",
    user_users_left: "users left",
    user_refresh_dashboard: "Click me, If import taking time.",
    user_table_list_rowno: "1",
    user_table_list_first_name: "Firstname",
    user_table_list_last_name: "Lastname",
    user_table_list_email: "Email",
    user_table_list_userstatus: "Userstatus",
    user_table_list_category: "Category",
    user_table_list_gdpr: "GDPR_Networking",
    user_table_list_photo: "Photo",
    user_message_processing_data: "Processing Data",
    user_import_text_action_on_uploaded_data:
      "Attendee Duplicate Data (by email) will be",
    user_import_text_action_on_uploaded_data_option1: "Overwrite",
    user_import_text_action_on_uploaded_data_option2: "Skip",
    user_import_text_action_on_uploaded_data_option1_skip:
      "Don't Override Blank Fields",
    user_import_text_click_drag_drop_1: "Click here or drag & drop",
    user_import_text_click_drag_drop_2: "to upload completed template.",
    user_import_download_template: "Download Template",
    user_import_download_template_subtitle1:
      "Download and complete the provided template. Upload the completed template when you're ready to send email invitations to users. (use user categories except Admin)",
    user_import_sample_csv: "Sample CSV",
    user_import_sample_xls: "Sample XLS",
    user_import_note1:
      "You can assign more than one category to the user (sponsor,attendee).",
    user_import_note2: "Duplicate data will be deleted.",
    user_import_note3:
      "Errors in any information will be ignored (not created).",
    user_import_note4:
      "If you choose the overwrite option and any attendee will registered with ticket that attendee will be skipped.",
    user_import_note5:
      "You can add the user status (confirmed, waitlist, inactive). Default status will be 'confirmed'",
    user_import_note6:
      "Any extra field compare to smaple file will be ignored.",
    user_eventbritr_title: "Select Event from Eventbrite",
    user_message_please_wait_fetching_events: "Please wait... Fetching events",
    user_form_label_select_events: "Select Events",
    user_form_label_select_events_placeholder:
      "Select event to fetch attendees",
    user_message_syncing_your_eventbrite_attendees:
      "We are syncing your Eventbrite attendees with us!",

    user_manage_user_category_text_error_any_form_sbumit_category_not_ctreated:
      "User groups are not added for this event!",
    user_manage_category_text_manage_group: "Manage Groups",
    user_manage_user_category_text_manage_users: "Manage User Group",
    user_manage_user_category_text_manage_users_sub_tittle:
      "You can manage the user groups here.",
    user_manage_user_category_table_list_categories: "Groups",
    user_manage_user_category_table_list_action: "Action",
    user_manage_user_category_title_delete_category: "Delete Group",
    user_manage_user_category_text_are_you_sure_delete:
      "This will delete the related app users category and related tickets category associated with this group. Are you sure you want to continue?",
    user_manage_user_category_message_category_deleted:
      "Users group deleted successfully",
    user_manage_user_category_form_label_category_name: "Group Name",
    user_manage_user_category_form_ph_category_name: "Enter group name",
    user_manage_user_category_form_success_add: "Group added Successfully!",
    user_manage_user_category_form_success_update:
      "Group updated Successfully!",
    user_manage_user_category_form_error_name_exist:
      "The group already created for this event!",
    user_appuser_group_validation_min1_required:
      "At least one group is required. Assign another group, before removing from this group.",
    user_appuser_group_success_update: "Appuser Group updated Successfully!",

    user_event_policy_text_set_event_policy_type: "Set event policy type",
    user_event_policy_form_label_policy_type: "Policy type",
    user_event_policy_form_ph_policy_type: "Select policy type",
    user_event_policy_form_label_policy_type_option1:
      "External registration link",
    user_event_policy_form_label_policy_type_option2: "Without registration",
    user_event_policy_form_label_policy_type_option3: "With registration",
    user_event_policy_form_label_policy_type_option4: "Ticket",
    user_event_policy_form_label_external_url: "External url",
    user_event_policy_form_ph_external_url: "Enter external url",

    user_event_policy_form_text_note: "Policy types Descriptions",
    user_event_policy_form_note_external_link:
      "You can add your external link for user registration",
    user_event_policy_form_note_without_reg:
      "User will be registered with default email and username when app opens",
    user_event_policy_form_note_with_reg:
      "You can create the form and make it available for user registration",
    user_event_policy_form_note_ticket: "You can register user via ticket",

    user_event_policy_form_validation_required: "Required",
    user_event_policy_form_validation_invalid_url: "Invalid external url",
    user_event_policy_form_policy_updated_success:
      "Event policy updated successfully!",
    user_event_policy_form_policy_added_success:
      "Event policy added successfully!",

    user_registration_policy_text_registration_page_created:
      "Your event's user registration page has been created!",
    user_registration_policy_text_registration_page_created_sub_title:
      "Promote your event and share this URL with your connections!",

    user_password_length_validation:
      "The password must be at least 6 characters long.",
    user_password_reset_success: "The password is updated for this admin.",
    user_in_waitlist_string: "Is User Waitlisted",

    // Tickets
    ticket_submenu_title1: "Dashboard",
    ticket_submenu_description1: "Dashboard",
    ticket_submenu_title2:
      DEVELOPMENT_TYPE === "eventify" ? "Manage Tickets" : "Manage Plans",
    ticket_submenu_description2:
      DEVELOPMENT_TYPE === "eventify" ? "Manage Tickets" : "Manage Plans",
    ticket_submenu_title3: "Promo-Discount",
    ticket_submenu_description3: "Promo & Discount",
    ticket_submenu_title4: "Sales Report",
    ticket_submenu_description4: "Sales Report",
    ticket_submenu_title5: "Payment Gateway",
    ticket_submenu_description5: "Connect Payment Gateway",
    ticket_submenu_title6: "Settings",
    ticket_submenu_description6: "Additional Settings",
    ticket_submenu_title7: "Checkout Form",
    ticket_submenu_description7:
      "Depending on these Checkout Forms, the user’s profile fields will be shown",
    ticket_submenu_title8: "Users",
    ticket_submenu_description8: "Manage and import users",

    ticket_submenu_title9: "Wizard",
    ticket_submenu_description9: "Wizard",

    ticket_submenu_title11: "Badge Design",
    ticket_submenu_description11:
      "Design and customize printable name badges for your event.",

    tickets_submenu_sections_user: "User",
    tickets_submenu_sections_ticket:
      DEVELOPMENT_TYPE === "eventify" ? "Ticket" : "Plan",

    wizard_publish_error_text:
      DEVELOPMENT_TYPE === "eventify"
        ? "You have not created any ticket(s) or the Ticket settings are empty."
        : "You have not created any plan(s) or plan settings is empty.",
    wizard_text_ticket_is_off_title:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket sale is not live"
        : "Plan sale is not live",
    wizard_text_ticket_is_off_subtitle: "Turn the button on, to go live",
    wizard_session_skip: "Skip",
    wizard_session_enable: "Enable Session",
    wizard_session_heading_text:
      "Do you need users to register for sessions explicitly?",
    wizard_session_subheading_text1:
      "For example, if you have a session which is associated with a paid ticket, you can create them now.",
    wizard_session_subheading_text2:
      "Skip if your event doesn't have this requirement",

    tickets_dashboard_text_ticket_page_created:
      "Your event ticket page has been created!",
    tickets_dashboard_text_ticket_page_created_sub_title:
      "Promote your event and share this URL with your connections!",
    tickets_dashboard_text_ticket_is_live_title:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket sale is live"
        : "Plan sale is live",
    tickets_dashboard_text_ticket_is_live_subtitle:
      DEVELOPMENT_TYPE === "eventify"
        ? "Turn off the button to hide ticket sale"
        : "Turn off button to hide plan sale",
    tickets_dashboard_text_things_to_do_for_ticket_sell:
      "Things to do before you start selling",
    tickets_dashboard_text_add_a_ticket:
      DEVELOPMENT_TYPE === "eventify" ? "Add A Ticket" : "Add A Plan",
    tickets_dashboard_text_add_a_ticket_sub_title:
      DEVELOPMENT_TYPE === "eventify"
        ? "You need to add at least 1 ticket for your conference"
        : "You need to add at least 1 plan of your platform",
    tickets_dashboard_text_connect_with_stripe: "Connect the Payment Gateway",
    tickets_dashboard_text_connect_with_stripe_sub_title:
      DEVELOPMENT_TYPE === "eventify"
        ? "Your payment gateway account has to be connected with Eventify to process payments"
        : "Your payment gateway account has to be connected with Koachify to process payments",
    tickets_dashboard_text_complete_setting:
      DEVELOPMENT_TYPE === "eventify"
        ? "Mandatory Completion of Ticket Settings"
        : "Completing Plan Settings is Mandatory",
    tickets_dashboard_text_complete_setting_sub_title:
      "Don't miss out on anything. Provide all the information under Settings to proceed",

    tickets_ticket_title: "Manage Tickets",
    tickets_ticket_modal_title_view_ticket: "View Ticket",
    tickets_ticket_sort_option1: "Manual",
    tickets_ticket_sort_option2: "Top Sold",
    tickets_ticket_sort_option3: "Ending Soon",
    tickets_ticket_note1:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket portal will display tickets as per sorting selected here."
        : "Plan portal will display plans as per sorting selected here.",
    tickets_ticket_table_list_ticket_name:
      DEVELOPMENT_TYPE === "eventify" ? "Ticket Name" : "Plan Name",
    tickets_ticket_table_list_total: "Total",
    tickets_ticket_table_list_sold: "Sold",
    tickets_ticket_table_list_available: "Available",
    tickets_ticket_table_list_price: "Price",
    tickets_ticket_table_list_action: "Action",
    tickets_ticket_text_no_ticket_found:
      DEVELOPMENT_TYPE === "eventify" ? "No Tickets Found!" : "No Plans Found!",
    tickets_ticket_text_no_tickets:
      DEVELOPMENT_TYPE === "eventify" ? "No Tickets" : "No Plans",
    tickets_ticket_text_create_ultimate_ticket:
      DEVELOPMENT_TYPE === "eventify"
        ? "Let's create the ultimate ticketing experience."
        : "Let's create the ultimate plans experience.",
    tickets_ticket_text_ticket_not_available_for_sale:
      "This ticket is not available for sale, please connect with the payment gateway to make it available.",
    tickets_ticket_text_ticket_not_available_for_offline_payment:
      "This ticket is not available with an offline payment option, please add your credit card info under the payment gateway menu to make it available.",
    tickets_ticket_title_delete_ticket:
      DEVELOPMENT_TYPE === "eventify" ? "Delete Ticket" : "Delete Plan",
    tickets_ticket_text_sure_want_to_delete:
      DEVELOPMENT_TYPE === "eventify"
        ? "This will permanently delete the ticket. Continue?"
        : "This will permanently delete the plan. Continue?",
    tickets_ticket_title_update_ticket:
      DEVELOPMENT_TYPE === "eventify" ? "Update Ticket" : "Update Plan",
    tickets_ticket_text_sure_want_to_update_with_form_change:
      DEVELOPMENT_TYPE === "eventify"
        ? "Every user assigned to this ticket will see the same form. Making form changes might result in data loss. Continue?"
        : "Every user assigned to this plan will see the same form. Making form changes might result in data loss. Continue?",
    tickets_ticket_text_delete_ticket_success:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket deleted successfully!"
        : "Plan deleted successfully!",
    tickets_ticket_text_delete_ticket_error:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket did not get deleted!"
        : "Plan did not get deleted!",
    tickets_add_ticket_option1: "Attendee",
    tickets_add_ticket_option2: "Exhibitor",
    tickets_add_ticket_option3: "Sponsor",
    tickets_add_ticket_option4: "Speaker",
    tickets_add_ticket_option5: "Addon",
    tickets_ticket_title_add_ticket:
      DEVELOPMENT_TYPE === "eventify" ? "Add a new ticket" : "Add a new plan",
    tickets_ticket_title_edit_ticket:
      DEVELOPMENT_TYPE === "eventify" ? "Edit ticket" : "Edit plan",
    tickets_ticket_form_label_ticket_code: "Ticket Code",
    tickets_ticket_form_label_checkout_name: "Checkout Form Name",
    tickets_ticket_form_ph_checkout_name: "Select checkout form",
    tickets_ticket_form_label_exhibitor_checkout_name:
      "Exhibitor Checkout Form Name",
    tickets_ticket_form_ph_exhibitor_checkout_name:
      "Select exhibitor checkout form",
    tickets_ticket_form_label_sponsor_checkout_name:
      "Sponsor Checkout Form Name",
    tickets_ticket_form_ph_sponsor_checkout_name:
      "Select sponsor checkout form",
    tickets_ticket_form_label_ticket_name:
      DEVELOPMENT_TYPE === "eventify" ? "Ticket Name" : "Plan Name",
    tickets_ticket_form_ph_ticket_name:
      DEVELOPMENT_TYPE === "eventify" ? "Enter ticket name" : "Enter plan name",
    tickets_ticket_form_label_ticket_tag: "Ticket Tag",
    tickets_ticket_form_ph_ticket_tag: "Enter ticket tag",
    tickets_ticket_form_label_color: "Ticket color",
    tickets_ticket_form_ph_color: "Choose ticket color",
    tickets_ticket_form_label_child_attendee_ticket:
      "Ticket For Associated Attendee",
    tickets_ticket_form_ph_child_attendee_ticket:
      "Select a ticket for the associated attendee",
    tickets_ticket_form_label_exhibitor_no_child_attendee_ticket:
      "How Many Attendees Are Allowed With An Exhibitor?",
    tickets_ticket_form_ph_exhibitor_no_child_attendee_ticket:
      "Enter the no. of attendees allowed with an exhibitor",
    tickets_ticket_form_label_sponsor_no_child_attendee_ticket:
      "How Many Attendees Are Allowed With A Sponsor?",
    tickets_ticket_form_ph_sponsor_no_child_attendee_ticket:
      "Enter the no. of attendees allowed with a sponsor",
    tickets_ticket_form_label_ticket_quantity: "Quantity",
    tickets_ticket_form_ph_ticket_quantity: "Quantity",
    tickets_ticket_form_label_min_booking: "Min per Booking",
    tickets_ticket_form_ph_min_booking: "Min Booking",
    tickets_ticket_form_label_max_booking: "Max per Booking",
    tickets_ticket_form_ph_max_booking: "Max Booking",
    tickets_ticket_form_label_ticket_type:
      DEVELOPMENT_TYPE === "eventify" ? "Ticket Type" : "Plan Type",
    tickets_ticket_form_ph_ticket_type: "Select Type",
    tickets_ticket_form_label_ticket_price:
      DEVELOPMENT_TYPE === "eventify" ? "Ticket Price" : "Plan Price",
    tickets_ticket_form_ph_price_currency: "Currency",
    tickets_ticket_form_ph_price: "Price",
    tickets_ticket_form_label_is_payment_offline:
      "Allow offline payment option?",
    tickets_ticket_form_label_tax_name: "Tax Name",
    tickets_ticket_form_ph_tax_name: "Enter tax name",
    tickets_ticket_form_label_tax_percentage: "Tax Percentage",
    tickets_ticket_form_ph_tax_percentage: "Enter tax",
    tickets_ticket_form_text_feepayment_absorb: "Absorb",
    tickets_ticket_form_text_feepayment_passon: "Pass On",
    tickets_ticket_form_text_payment_breakdown: "Payment Breakdown",
    tickets_ticket_form_text_money_to_you: "Money To You",
    tickets_ticket_form_text_ticket_price:
      DEVELOPMENT_TYPE === "eventify" ? "Ticket Price" : "Plan Price",
    tickets_ticket_form_text_eventify_fee:
      DEVELOPMENT_TYPE === "eventify" ? "Eventify Fee" : "Koachify Fee",
    tickets_ticket_form_text_payment_getway_fee: "Payment Gateway Fee",
    tickets_ticket_form_text_client_pay: "Client Pay",
    tickets_ticket_form_text_set_your_tax_nav:
      DEVELOPMENT_TYPE === "eventify"
        ? "Tax is not set for your event. Go to 'User Registration->Settings' to set up your tax."
        : "Tax is not set for your platform. Go to 'User Registration->Setting' to set-up your tax.",
    tickets_ticket_form_table_list_eventify_fee:
      DEVELOPMENT_TYPE === "eventify" ? "Eventify Fee" : "Koachify Fee",
    tickets_ticket_form_table_list_stripe_fee: "Payment Gateway Fee",
    tickets_ticket_form_table_list_tax: "Tax",
    tickets_ticket_form_table_list_your_proceeds: "Your Proceeds",
    tickets_ticket_form_table_list_client_pays: "Client Pays",
    tickets_ticket_form_label_sale_start_from: "Ticket Sale Starts From",
    tickets_ticket_form_label_sale_ends_at: "Ticket Sale Ends On",
    tickets_ticket_form_label_plandays: "Plan Days",
    tickets_ticket_form_ph_plandays: "Enter plan days",
    tickets_ticket_form_label_allow_all_access:
      "Allow all course and live sessions",
    tickets_ticket_form_label_ticket_description:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket Description"
        : "Plan Description",
    tickets_ticket_form_label_ticket_description_extra_text:
      "Up to 50 characters",
    tickets_ticket_form_ph_ticket_description:
      DEVELOPMENT_TYPE === "eventify"
        ? "Enter ticket description"
        : "Enter plan description",
    tickets_ticket_form_label_ticket_status: "Status",
    tickets_ticket_form_label_ticket_status_option1: "Enabled",
    tickets_ticket_form_label_ticket_status_option2: "Disabled",
    tickets_ticket_form_label_ticket_status_option3: "Hidden",
    tickets_dashboard_trackingpixel_caution_text:
      "Add tracking codes for all tickets here. To track individual, add code from manage tickets.",
    tickets_ticket_form_trackingpixel_caution_text:
      "Add tracking codes to individual tickets here. To track all, add code from ticket's dashboard.",
    tickets_ticket_form_label_trackingpixel_header:
      "Add code before </head> tag",
    tickets_ticket_form_label_trackingpixel_footer:
      "Add code before </body> tag",
    tickets_ticket_form_ph_trackingpixel: "Add you custom codes here",
    tickets_trackingpixel_cautionary_text:
      "Note: Eventify doesn't validate custom codes for you, so be sure to check your code before publishing. Make sure your custom code won't create any security vulnerabilities. Unsecured code could expose sensitive customer information!",
    tickets_ticket_form_validation_required: "Required",
    tickets_ticket_form_validation_min_booking_should_less_than_quantity:
      "Min. booking should be less than available quantity",
    tickets_ticket_form_validation_max_booking_should_less_than_quantity:
      "Max. booking should be less than available quantity",
    tickets_ticket_form_validation_max_booking_always_greater_equal_min_booking:
      "Max. booking should be greater than or equal to min. booking quantity",
    tickets_ticket_form_validation_ticket_price_should_greater_than_1:
      "Price should be greater than 1",
    tickets_ticket_form_validation_ticket_planday_should_greater_than_1:
      "Plan day should be greater than 1",
    tickets_ticket_form_validation_ticket_description_only_50_char:
      "Up to 50 characters allowed",
    tickets_ticket_form_validation_no_attendee_ticket_min_1:
      "Attendee should be greater than 1.",
    tickets_ticket_form_validation_quantity_should_be_greater_than_sold_quantity:
      "Quantity must be greater than the Sold Quantity.",
    tickets_ticket_form_validation_ticket_allready_exists:
      DEVELOPMENT_TYPE === "eventify"
        ? "Same Ticket Name already exists."
        : "Same plan name already exists.",
    tickets_ticket_form_validation_invalid_start_date:
      "Invalid start date, Please select the date once again.",
    tickets_ticket_form_validation_invalid_end_date:
      "Invalid end date, Please select the date once again",
    tickets_ticket_form_validation_end_date_should_greater_equal_than_start_date:
      "End date time should be greater than the start date time.",
    tickets_ticket_form_validation_end_datetime_cannot_greater_than_child_end_datetime:
      "End Date-Time can not be greater than associated ticket’s end Date-Time",
    tickets_ticket_form_validation_stripe_support_currency:
      "You are connected with Stripe payment gateway and it does not support ZAR currency.",
    tickets_ticket_form_validation_payfast_support_currency:
      "You are connected with Payfast payment gateway and it supports only ZAR currency.",
    tickets_ticket_form_validation_not_enable_zar_tickets_stripe:
      DEVELOPMENT_TYPE === "eventify"
        ? "You can not enable/hide ZAR currency ticket if you have connected with Stripe."
        : "You can not enabled/hide ZAR currency plan if you have connected with Stripe.",
    tickets_ticket_form_validation_not_enable_othetcurrency_tickets_payfast:
      DEVELOPMENT_TYPE === "eventify"
        ? "You can not enable/hide other than ZAR currency ticket if you have connected with Payfast."
        : "You can not enabled/hide other than ZAR currency plan if you have connected with Payfast.",
    tickets_ticket_form_validation_not_disable_associated_ticket:
      "Ticket is already associated with other ticket(s), unlink or disable them first",
    tickets_ticket_form_ticket_updated_success:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket updated successfully!"
        : "Plan updated successfully!",
    tickets_ticket_form_ticket_added_success:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket added successfully!"
        : "Plan added successfully!",

    tickets_ticket_modal_title_view_associated_session: "Associated Sessions",
    tickets_ticket_modal_text_no_associated_session:
      "No session associated with this ticket",
    tickets_ticket_associated_modal_text_session_list: "Session(s) List",
    tickets_ticket_associated_modal_text_selected_session_list:
      "Selected Session(s) List",
    tickets_ticket_associated_modal_text_session_name: "Session name",
    tickets_ticket_associated_session_confirmation_title:
      "Update Associated Session",
    tickets_ticket_associated_session_confirmation_subtitle:
      "Would you like to change the ticket access permission for the sessions?",
    tickets_ticket_associated_session_update_success:
      "Associated session for this ticket is updated successfully!",

    tickets_coupon_text_promo_discount: "Promo Discount",
    tickets_coupon_table_list_code: "Code",
    tickets_coupon_table_list_discount: "Discount",
    tickets_coupon_table_list_used_number: "No. of Use",
    tickets_coupon_table_list_use_limit: "Use limit",
    tickets_coupon_table_list_status: "Status",
    tickets_coupon_table_list_action: "Action",
    tickets_coupon_title_delete_coupon: "Delete Coupon",
    tickets_coupon_text_sure_want_to_delete:
      "This will permanently delete the Coupon. Continue?",
    tickets_coupon_text_delete_coupon_success: "Coupon deleted successfully!",
    tickets_coupon_title_add_coupon: "Create a discount",
    tickets_coupon_title_edit_coupon: "Edit discount",
    tickets_coupon_form_label_code_name: "Code Name",
    tickets_coupon_form_ph_code_name: "Enter coupon code",
    tickets_coupon_form_label_discount_for: "Discount For",
    tickets_coupon_form_ph_discount_for: "Select Discount",
    tickets_coupon_form_label_usage_limit: "Usage Limit",
    tickets_coupon_form_ph_usage_limit: "Enter Usage Limit",
    tickets_coupon_form_label_code_type: "Code Type",
    tickets_coupon_form_ph_code_type: "Select Code",
    tickets_coupon_form_label_code_type_option1: "Percentage",
    tickets_coupon_form_label_code_type_option2: "Amount",
    tickets_coupon_form_label_amount_off: "Amount Off",
    tickets_coupon_form_ph_amount_off: "Enter Amount off",
    tickets_coupon_form_label_discount_start_from: "Discount Starts from",
    tickets_coupon_form_label_discount_ends_at: "Discount Ends at",
    tickets_coupon_form_label_status: "Status",
    tickets_coupon_form_label_status_option1: "Enabled",
    tickets_coupon_form_label_status_option2: "Disabled",
    tickets_coupon_form_validation_required: "Required",
    tickets_coupon_form_validation_usases_limit: "Usage limit is invalid!",
    tickets_coupon_form_validation_end_date_should_greater_equal_than_start_date:
      "End date time should be greater than the start date time.",
    tickets_coupon_form_validation_coupon_already_exists:
      "Same Coupon Code already exists.",
    tickets_coupon_form_validation_coupon_usage_limit_cannot_reduce_than_already_used_coupon:
      "Can not reduce usage limit of the coupon code to less than",
    tickets_coupon_form_coupon_updated_success: "Coupon updated successfully!",
    tickets_coupon_form_coupon_added_success: "Coupon added successfully!",

    tickets_salesreport_modal_title_order_purchase: "Order Ticket",
    tickets_salesreport_modal_title_order_details: "Ticket Order Details",
    tickets_salesreport_text_total_sales: "Total sales",
    tickets_salesreport_text_course_sold: "Course Sold",
    tickets_salesreport_text_session_sold: "Session Sold",
    tickets_salesreport_text_paid_tickets_sold: "Paid tickets sold",
    tickets_salesreport_text_free_tickets_sold: "Free tickets sold",
    tickets_salesreport_text_paid_tickets_remaining: "Paid tickets remaining",
    tickets_salesreport_text_free_tickets_remaining: "Free tickets remaining",
    tickets_salesreport_search_placeholder: "Search by OrderRef, email",
    tickets_salesreport_table_list_order_ref: "OrderRef",
    tickets_salesreport_table_list_email: "Email",
    tickets_salesreport_table_list_tickets: "Tickets",
    tickets_salesreport_table_list_ticket_name: "Course/Session Name",
    tickets_salesreport_table_list_purchase_date: "Purchase Date",
    tickets_salesreport_table_list_order_total: "Order Total",
    tickets_salesreport_table_list_discount: "Discount",
    tickets_salesreport_table_list_purchase_total: "Purchase Total",
    tickets_salesreport_table_list_action: "Action",
    tickets_salesreport_export_text_export_record: "Export Record",
    tickets_salesreport_export_text_export_sales_csv:
      "Do you want to download the Excel file for the sales report? To proceed, click the download button. Depending on the number of records, it might take a little longer. You can also select export data over a date range:",
    tickets_salesreport_export_text_export_sales_csv_downloading:
      "Preparing the data... Excel file will be available soon.",
    tickets_salesreport_title_payment_accepted: "Accept Payment",
    tickets_salesreport_text_sure_want_to_accept_payment:
      "This will mark as full payment received and allow buyers to assign attendees with purchased tickets. Continue?",
    tickets_salesreport_payment_accepted_success:
      "Payment accepted successfully!",
    tickets_salesreport_payment_accepted_error_eventid_required:
      "Eventid required!",
    tickets_salesreport_payment_accepted_error_orderid_required:
      "Orderid required!",
    tickets_salesreport_payment_accepted_error_invalid_orderid:
      "Invalid orderid!",
    tickets_salesreport_payment_accepted_error_order_already_confirmed:
      "This transaction oreder is already confirmed!",
    tickets_salesreport_payment_accepted_error_other_permission:
      "This order self user have other's permiossion!",
    tickets_salesreport_payment_accepted_error_email_not_associated_with_event:
      "Buyer emailid is not associated with this event!",
    tickets_salesreport_payment_accepted_error_assigned_attendee_have_other_access_permission:
      "#emails these user(s) already have others access permission, Try another email!",
    tickets_salesreport_payment_accepted_error_assigned_attendee_already_assigned_with_current_ticket:
      "#emails these email(s) already assigned!",
    tickets_salesreport_payment_accepted_error_already_assigned:
      "This order user is already assigned to this ticket!",
    tickets_salesreport_title_resend_order_email: "Resend Order Email",
    tickets_salesreport_text_sure_want_to_resend_order_email:
      "Are you sure want to resend order invoice email to buyer?",
    tickets_salesreport_resend_order_email_success:
      "Order email resend successfully!",
    tickets_salesreport_refund_modal_title: "Reund Tickets",
    tickets_salesreport_refund_price_breakdown_title: "Price Breakdown",
    tickets_salesreport_refund_price_breakdown_text:
      "Ticket Price - Discount + Tax",
    tickets_salesreport_refund_price_fee_text_absorb:
      "Fee - (This fee will be cost to host)",
    tickets_salesreport_refund_price_fee_text_passon:
      "Fee - (This fee will be cost to buyer)",
    tickets_salesreport_refund_confirmation_title: "Refund Order",
    tickets_salesreport_refund_confirmation_subtitle:
      "Would you like to refund selected ticket? ",
    tickets_salesreport_refund_success: "Order refunded successfully!",

    tickets_payout_tab1: "Stripe",
    tickets_payout_tab2: "Payfast",
    tickets_stripe_text_stripe_connect: "Connect Stripe",
    tickets_credit_card_text_header: "Add your credit card",
    tickets_stripe_text_ticket_processing_fee:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket processing Fee"
        : "Plan/Course processing Fee",
    tickets_stripe_text_seamless_checkout_experiance:
      "Seamless checkout experience",
    tickets_stripe_text_you_must_have_stripe_account:
      "You must have a Stripe account to accept credit or debit card payments",
    tickets_stripe_allow_to_integrate_validation1:
      DEVELOPMENT_TYPE === "eventify"
        ? "You have created paid ticket(s) in ZAR currency, which is not supported by Stripe Payment Gateway. Delete/Disable that ticket."
        : "You have created paid plan/course(s) in ZAR currency, which is not supported by Stripe Payment Gateway. Delete/Disable that plan/course.",
    tickets_stripe_allow_to_integrate_validation2:
      "You have already connected with another payment gateway, you can not connect more than one payment gateway at the same time.",
    tickets_stripe_allow_to_integrate_validation3:
      "You have already connected with another payment gateway and you have added your credit card info.",
    tickets_client_credit_card_text1:
      "Add your credit card info to allow offline payments for buyers",

    tickets_payfast_text_connect: "Provide required info to use Payfast",
    tickets_payfast_text_note1:
      "Provide the correct merchant id and merchant key for Payfast.",
    tickets_payfast_text_note2:
      "Provide your card info from which Eventify can charge you.",
    tickets_payfast_modal_add_title: "Add required info",
    tickets_payfast_modal_update_title: "Update required info",
    tickets_payfast_form_label_card_no: "Card number",
    tickets_payfast_form_label_expiry_date: "Expiration date",
    tickets_payfast_form_label_cvv: "CVV",
    tickets_payfast_form_label_clientemail: "Email",
    tickets_payfast_form_ph_clientemail:
      "Enter your email which will be used in the payment gateway",
    tickets_payfast_form_label_merchant_id: "Merchant Id",
    tickets_payfast_form_ph_merchant_id: "Enter merchant id",
    tickets_payfast_form_label_merchant_key: "Merchant Key",
    tickets_payfast_form_ph_merchant_key: "Enter merchant key",
    tickets_payfast_form_validaton_invalid_email: "Invalid email",
    tickets_payfast_form_success:
      "Your Payfast payment gateway is integrated successfully!",
    tickets_payfast_form_error:
      "Something went wrong while integrating your card!",
    tickets_payfast_form_merchant_update_success:
      "Merchant info updated successfully!",
    tickets_payfast_form_card_update_success:
      "New card info updated successfully!",
    tickets_payfast_allow_to_integrate_validation1:
      "You have created paid ticket(s) in currencies other than ZAR currency, which are not supported by Payfast Payment Gateway. Delete/Disable those tickets(s).",
    tickets_payfast_allow_to_integrate_validation2:
      "You have already connected with another payment gateway, you can not connect more than one payment gateway at the same time.",
    tickets_payfast_form_card_deleted_error:
      "Something went wrong while disconnecting the card with Stripe!",
    tickets_payfast_form_card_deleted_success:
      "Payfast payment gateway disconnected successfully!",
    billing_payfast_form_btn_cancel: "Cancel",
    billing_payfast_form_btn_pay: "Pay",
    billing_payfast_form_text_powerd_by: "Powered By",

    tickets_setting_form_text_sample_template: "Sample template",
    tickets_setting_form_text_copy_template: "Copy template",
    tickets_setting_note1:
      "Making changes in settings will disable your tickets. You will have to enable tickets from the dashboard again.",
    tickets_setting_form_organization_group: "Organization Details",
    tickets_setting_form_label_company_name: "Company Name",
    tickets_setting_form_ph_company_name: "Enter company name",
    tickets_setting_form_label_company_address: "Company Address",
    tickets_setting_form_ph_company_address: "Enter company address",
    tickets_setting_form_label_support_email: "Support Email",
    tickets_setting_form_ph_support_email: "Enter support email",
    tickets_setting_form_label_tax_name: "Tax Name",
    tickets_setting_form_ph_tax_name: "Enter tax name",
    tickets_setting_form_label_cin: "Company Number (i.e VAT/GST/CIN)",
    tickets_setting_form_ph_cin: "Enter your vat/gst/cin no.",
    tickets_setting_form_label_tax_percentage: "Tax Percentage",
    tickets_setting_form_ph_tax_percentage: "Enter tax",
    tickets_setting_form_terms_conditions_group:
      "Terms & Conditions of the Event",
    tickets_setting_form_label_refund_policy: "Refund Policy",
    tickets_setting_form_ph_refund_policy: "Select refund policy",
    tickets_setting_form_label_listing_privacy: "Listing Privacy",
    tickets_setting_form_ph_listing_privacy: "Select Listing Privacy",
    tickets_setting_form_label_privacy_policy: "Privacy Policy",
    tickets_setting_form_ph_privacy_policy: "Enter the Privacy Policy",
    tickets_setting_form_label_terms_conditions: "Terms & Conditions",
    tickets_setting_form_ph_terms_conditions: "Enter the Terms & Conditions",
    tickets_setting_form_label_eventify_terms_conditions:
      DEVELOPMENT_TYPE === "eventify"
        ? "Eventify Terms & Conditions"
        : "Kocahify Terms & Conditions",
    tickets_setting_form_organization_corner_group: "Organization Corner",
    tickets_setting_form_label_thankyou_page_type: "Thank You Page Type",
    tickets_setting_form_text_thankyou_option1: "Text",
    tickets_setting_form_text_thankyou_option2: "External Link",
    tickets_setting_form_label_thankyou_link: "External Thank You Page Link",
    tickets_setting_form_ph_thankyou_link: "Enter external thank you page link",
    tickets_setting_form_label_congratulation_message: "Thank You Message",
    tickets_setting_form_ph_congratulation_message: "Enter thank you message",
    tickets_setting_text_read_eventify_terms_conditions:
      DEVELOPMENT_TYPE === "eventify"
        ? "Read Eventify Terms & Conditions"
        : "Read Koachify Terms & Conditions",
    tickets_setting_text_tax_will_apply_on_all_tickets:
      "Tax will be applied on all tickets",
    tickets_setting_form_validation_required: "Required",
    tickets_setting_form_validation_invalid_email: "Invalid email",
    tickets_setting_form_validation_only_positive_number:
      "Enter a positive number only",
    tickets_setting_form_validation_tax_should_be_less_equal_30:
      "Tax value can not be greater than 30%",
    tickets_setting_form_validation_tax_should_not_be_less_equal_1:
      "Tax value can not be less than 1%",
    tickets_setting_form_setting_updated_success:
      "Setting updated successfully!",
    tickets_setting_form_setting_added_success: "Settings added successfully!",

    tickets_checkout_form_add_option1: "Attendee",
    tickets_checkout_form_add_option2: "Exhibitor",
    tickets_checkout_form_add_option3: "Sponsor",
    tickets_checkout_form_add_option4: "Survey",
    tickets_checkout_form_table_list_formno: "Form Number",
    tickets_checkout_form_table_list_form_name: "Form Name",
    tickets_checkout_form_table_list_form_version: "Form Version",
    tickets_checkout_form_table_list_form_type: "Form Type",
    tickets_checkout_form_table_list_action: "Action",

    // Dynamic form
    dynamic_form_text_create_form: "Create Form",
    dynamic_form_text_update_form: "Update Form",
    dynamic_form_subtext_create_update_form:
      "Here you can Drag & Drop the options from the Toolbox, to include the options in your form or delete any option if it's not relevant to your event",
    dynamic_form_text_toolbox: "Form Components",
    dynamic_form_text_default_fields: "Default Fields",
    dynamic_form_text_contact_fields: "Contact Fields",
    dynamic_form_text_contact_fields_info:
      "Contact fields data will be visible to all attendees if networking is on",
    dynamic_form_text_additional_fields: "Additional Fields",
    dynamic_form_text_additional_fields_info:
      "Additional fields data will only be visible to the Host.",
    dynamic_form_text_drop_a_item_here: "Drop an item here",
    dynamic_form_validation_label_max_length_required:
      "Label or max length of input can not be blank!",
    dynamic_form_validation_variable_required: "Variable can not be blank!",
    dynamic_form_validation_variable_already_used:
      "Variable name is already used by another field!",
    dynamic_form_validation_label_of_datepicker_rating_required:
      "Label of date-picker/rating can not be blank!",
    dynamic_form_validation_label_of_hyperlink_required:
      "Label of hyperlink can not be blank!",
    dynamic_form_validation_invalid_url_link: "Invalid URL link!",
    dynamic_form_validation_label_of_checkbox_radio_dropdown_required:
      "Label of checkboxes/radio buttons/dropdown can not be blank!",
    dynamic_form_validation_provide_proper_option_value:
      "Provide all options properly or remove blank option row!",
    dynamic_form_validation_label_required: "Label can not be blank!",
    dynamic_form_validation_paragraph_required: "Paragraph can not be blank!",
    dynamic_form_validation_name_email_field_not_required:
      "Name or Email field not required!",
    dynamic_form_validation_all_field_should_unique: "Keep all fields unique!",
    dynamic_form_created_success: "New form created successfully!",
    dynamic_form_update_confirm_title: "Update Form",
    dynamic_form_note1:
      "Changing or deleting any field's variable name will result in loss of corresponding data.",
    dynamic_form_note2: "Email will not visible to other attendees.",
    dynamic_form_validation_max_uploader_required:
      "Max uploader input can not be blank or zero!",
    dynamic_form_validation_label_of_group_required:
      "Label of the group can not be blank!",
    dynamic_form_validation_maxgroupentries_required:
      "At least 1 group entry is required!",

    checkout_default_update_title: "Set Default",
    checkout_default_update_subtitle:
      "Would you like to set this form as the default form?",
    checkout_default_update_success: "Form successfully set as default!",

    checkout_title_update_ticket_associated_form:
      DEVELOPMENT_TYPE === "eventify"
        ? "Update Ticket Form"
        : "Update Plan Form",
    checkout_text_sure_want_to_update_with_form_change:
      "Making changes to the ticket's form might cause loss of individual user data. Continue?",
    checkout_form_text_ticket_list:
      DEVELOPMENT_TYPE === "eventify" ? "Ticket List" : "Plan List",
    checkout_form_text_selected_ticket_list:
      DEVELOPMENT_TYPE === "eventify"
        ? "Selected Ticket(s) List"
        : "Selected Plan(s) List",
    checkout_form_ticket_association_success:
      DEVELOPMENT_TYPE === "eventify"
        ? "Ticket(s) are successfully linked with the Form"
        : "Plan(s) are successfully linked with the Form",

    user_resistration_menus_no_ticket_content_title:
      DEVELOPMENT_TYPE === "eventify" ? "No Ticket(s)" : "No Plan(s)",
    user_resistration_menus_no_ticket_content_subtitle:
      "Please add one to make it appear in the list",

    // Outreach
    outreach_search_ph: "Search by title & text",
    outreach_send_push_notification: "Send Push Notification",
    outreach_notification_tab1: "All Notifications",
    outreach_notification_tab2: "Scheduled Notification",
    outreach_send_push_and_email_notification: "Send Push Notification & Email",
    outreach_send_push_notification_subtitle1:
      "Are you sure you want to send Push Notifications to the selected users?",
    outreach_send_push_notification_subtitle2:
      "Are you sure you want to schedule the Push Notifications to the selected users?",
    outreach_send_push_notification_subtitle_allusers:
      "Are you sure want to send Push Notifications to all?",
    outreach_send_push_and_emails_notification_subtitle1:
      "Are you sure you want to send Push Notifications & Email to the selected users?",
    outreach_push_notification: "Push Notification",
    outreach_push_notification_subtitle1:
      "List of push notifications sent to your audience.",
    outreach_send_push_notification_subtitle3:
      "Send push notification to your audience in a matter of minutes.",
    // outreach_send_push_notification_subtitle3: "Start sending push notifications to your audience in a matter of minutes. Be notified when it happens.",
    outreach_view_push_notification_title: "View Push Notification",
    outreach_message_error_add_time_date:
      "Add Time And Date to Schedule a Notification",
    outreach_message_error_add_future_date:
      "Please add a future date time to schedule a notification",
    outreach_message_notification_sent: "Notification sent successfully!",
    outreach_message_notification_sscheduled_success:
      "Notification scheduled successfully!",
    outreach_message_notification_no_recipients:
      "No recipients added for this push!",
    outreach_text_char_left: "character(s) left",
    outreach_text_max_char_limit_reached: "Max character limit reached",
    outreach_send_option: "Notification Type",
    outreach_send_option_option1: "Push Notification",
    outreach_send_option_option2: "Email & Push Notification",
    outreach_form_label_image: "Image",
    outreach_form_ph_image:
      "Drag and drop or Click here to upload an image. Image size must be 200x200 px.",
    outreach_form_label_title: "Notification Title",
    outreach_form_ph_title: "Enter notification title",
    outreach_form_label_content: "Content",
    outreach_form_label_content_placeholder: "Enter your message here...",
    outreach_form_label_target: "Target",
    outreach_form_label_option_1: "All confirmed",
    outreach_admin_s: "Admin(s)",
    outreach_exhibitor_s: "Exhibitor(s)",
    outreach_sponsor_s: "Sponsor(s)",
    outreach_speaker_s: "Speaker(s)",
    outreach_attendees_s: "Attendee(s)",
    outreach_form_target_option_custom: "Specific User",
    outreach_form_target_text_custom_selected: "#total user(s) selected",
    outreach_form_label_redirect: "On Click Redirect to",
    outreach_form_label_internal: "Internal",
    outreach_form_ph_internal: "Type, search, and select",
    outreach_form_labelinfo_internal:
      "Here you can link the notification with any screen of speaker / sponsor / exhibitor / survey / session / community / poll / news",
    outreach_form_label_external: "External Url",
    outreach_form_ph_external: "https://.....",
    outreach_form_label_sending_type: "Sending Method",
    outreach_form_label_sending_type_option1: "Now",
    outreach_form_label_sending_type_option2: "Schedule",
    outreach_form_label_shcedule_date: "Date & Time",
    outreach_form_note1:
      "Schedule notification will be delivered as per the event timezone",
    outreach_validation_notification_required:
      "Notification message can not be empty",
    outreach_validation_reached_max_limit:
      "You have reached the max limit for characters",
    outreach_table_list_posts: "Posts",
    outreach_table_list_recipients: "Recipients / Total",
    outreach_table_list_linked_with: "Redirection",
    outreach_table_list_status: "Status",
    outreach_table_list_read_count: "Total Read",
    outreach_table_list_read_rate: "Read Rate",
    outreach_table_list_schedule_time: "Scheduled Time",
    outreach_delete_item_title: "Delete Notification",
    outreach_delete_item_subtitle:
      "Are you sure you want to delete the push notifications?",
    outreach_delete_item_success: "Notification deleted successfully",
    outreach_text_no_notification_added: "No notification(s) added.",
    outreach_text_add_to_appear: "Please add one to make it appear in the list",
    outreach_text_users_read: "users read",
    outreach_title_choose_user_to_sent_push:
      "Choose Users to Send Push Notifications to",
    outreach_table_list_action: "Action",
    outreach_table_list_name: "Name",
    outreach_table_list_category: "Category",
    outreach_table_reset_btn_text: "Reset Notification(s)",
    outreach_table_reset_alert_text:
      "Are you sure you want to reset the push notifications? Resetting notifications will remove all the push notifications that the host has sent already and it cannot be reversed.",
    outreach_reset_push_notification_success:
      "The notification schedule for sending push has been reset sucessfully",
    outreach_reset_push_notification_error: "No notification(s) found to reset",
    outreach_cancel_schedule_push_text_no_action: "No Action",
    outreach_cancel_schedule_push_title: "Cancel Schedule",
    outreach_cancel_schedule_push_subtitle:
      "Are you sure you want to cancel the schedule notification?",
    outreach_cancel_schedule_push_success:
      "Scheduled Outreach Notification Cancelled Successfully!",
    outreach_cancel_schedule_push_error:
      "Failed to cancel outreach notification!",

    outreach_no_data_found: "No Statistics found!",

    /**** Gamification ****/
    gamification_submenu_title1: "Manage Challenges",
    gamification_submenu_description1: "Manage Challenges",
    gamification_submenu_title2: "Leaderboard",
    gamification_submenu_description2: "Leaderboard",
    gamification_submenu_title3: "Rewards Settings",
    gamification_submenu_description3: "Rewards Settings",

    gamification_submenu_title4: "Upload Image",
    gamification_submenu_title5: "Choose Template",

    gamification_text_preparing_analytics: "Preparing Gamification...",
    gamification_chooser_toogle_challenge_title:
      "Activate / Deactivate Challenge?",
    gamification_chooser_toogle_challenge_message:
      "Do you want to change the state of the challenge?",
    gamification_toggle_form_success: "Challenge state updated successfully",

    gamification_list_challengetitle: "Challenge Title",
    gamification_list_Type: "Type",
    gamification_list_description: "Description",
    gamification_list_showpopup: "Popup",
    gamification_list_points: "Points",
    gamification_list_action: "Action",

    gamification_challenge_note1:
      "Only the Single challenge will be listed in the challenge list for App & Web.",
    gamification_challenge_note2: `(ii) For recurring challenges, only reward type 'Points' are applicable. If you want to choose “Award”, then that challenge needs to move under the single challenge by choosing "Is recurring" - "No".`,
    gamification_active_inactive_text: "Active/Inactive",

    gamification_rewardsettings_title: "Overview Text",
    gamification_rewardsettings_desc: "Rules Notes",
    gamification_rewardsettings_template: "Template",

    na: "NA",
    gamification_not_applicable: "Not applicable",

    gamification_leaderboard_table_reset_btn_text: "Reset Point(s)",
    gamification_leaderboard_reset_notification_error:
      "No point(s) found to reset",

    gamification_leaderboard_table_reset_alert_text:
      "Are you sure you want to reset the Points? Resetting points will remove all the user's points",

    gamification_leaderboard_reset_points__success:
      "Successfully reset all the points",

    gamification_leaderboard_table_th_position: "Position",
    gamification_leaderboard_table_th_name: "Name",
    gamification_leaderboard_table_th_points: "Points",
    gamification_leaderboard_table_th_action: "Action",

    gamification_leaderboard_action_addpoint: "Extra points",
    gamification_extrapoints_modal_header: "Add extra points",
    gamification_extrapoints_modal_add_bonus_label: "Points to assign",
    gamification_extrapoints_modal_add_bonus_ph: "Enter points",
    gamification_extrapoints_modal_validation_extrapoints:
      "Points has to be greater than 0",
    gamification_extrapoints_modal_or_select_challenge:
      "Or, select a challenge to assign calculated points",
    gamification_extrapoints_modal_select_challenge: "Select a challenge",
    gamification_extrapoints_modal_select_challenge_validation:
      "Either enter points manually or select one challenge",
    gamification_extrapoints_modal_select_challenge_ph:
      "-- Select from dropdown --",
    gamification_extrapoints_modal_no_challenge_only_bonus:
      "No challenge - Add points",
    gamification_extrapoints_modal_explainatory_note:
      "Choose how to add these points",
    gamification_extrapoints_modal_radio_add_as_bonus:
      "Add these points as extra",
    gamification_extrapoints_modal_radio_override:
      "Override existing points with these points",
    gamification_extrapoints_modal_error_response:
      "Sorry, something went wrong. Check the data you are submitting.",
    gamification_extrapoints_modal_success_response:
      "Successfully assigned points to selected users.",
    gamification_extrapoints_modal_success_add:
      "Successfully assigned points. Could not override.",
    gamification_extrapoints_modal_success_override:
      "Points override successfull. Could not assign to new users",
    gamification_extrapoints_modal_desc_add:
      "All the selected user will get these points as extra bonus.",
    gamification_extrapoints_modal_desc_challenge_add:
      "These bonus points will be added as surplus with individual users' existing points for the selected challenge.",
    gamification_extrapoints_modal_desc_challenge_override:
      "These bonus points will override individual users' existing points for the selected challenge.",

    /*****  Analytics *****/

    analytics_submenu_title1: "Dashboard",
    analytics_submenu_description1: "Dashboard",
    analytics_submenu_title2: "Google Analytics",
    analytics_submenu_description2: "Google Analytics",
    analytics_submenu_title3: "Sessions",
    analytics_submenu_description3: "Sessions",
    analytics_submenu_title4: "Speakers",
    analytics_submenu_description4: "Speakers",
    analytics_submenu_title5: "Attendees Network",
    analytics_submenu_description5: "Attendees Network",
    analytics_submenu_title6: "Attendees Messaging",
    analytics_submenu_description6: "Attendees Messaging",
    analytics_submenu_title7: "Social Feeds",
    analytics_submenu_description7: "Social Feeds",
    analytics_submenu_title8: "Sponsors Insights",
    analytics_submenu_description8: "Sponsors Insights",
    analytics_submenu_title9: "Exhibitors Insights",
    analytics_submenu_description9: "Exhibitors Insights",
    analytics_submenu_title10: "Advertisement Insights",
    analytics_submenu_description10: "Advertisement Insights",

    analytics_text_preparing_analytics: "Preparing Analytics...",
    analytics_text_plotting_analytics: "Plotting Analytics...",
    analytics_text_almost_done: "Almost Ready...",
    analytics_text_no_hits_recorded_today: "No hit(s) recorded today",
    analytics_text_higher_than_yesterday: "higher than yesterday",
    analytics_text_lower_than_yesterday: "lower than yesterday",
    analytics_text_no_change_from_yesterday: "No change from yesterday",
    analytics_text_no_hits_recorder_this_month: "No hit(s) recorded this month",
    analytics_text_higher_than_last_month: "higher than last month",
    analytics_text_lower_than_last_month: "lower than last month",
    analytics_text_no_change_from_last_month: "No change from last month",
    analytics_text_user_hits: "User Hits",
    analytics_text_no_hits_recorded: "No hit(s) recorded",
    analytics_text_no_install_yesterday: "No installs yesterday",
    analytics_text_no_install_last_month: "No installs last month",
    analytics_text_app_install: "App Installs",
    analytics_text_no_device_installed: "No device(s) installed yet.",
    analytics_text_device_plateform: "Device Platform",
    analytics_text_accepte_vs_total_request: "Accepted vs Total Requests",
    analytics_text_requests: "Requests",
    analytics_text_accepted: "Accepted",
    analytics_text_conversations: "Conversations",
    analytics_text_message_per: "Messages per",
    analytics_text_no_request_recorded_yet: "No requests(s) recorded yet.",
    analytics_text_no_session_recorded_yet: "No session(s) recorded yet.",
    analytics_text_session_details: "Session Details",
    analytics_table_list_screen_name: "Screen Name",
    analytics_table_list_hits: "Hits",
    analytics_text_no_session_recorded_recently:
      "No session(s) recorded recently.",

    analytics_google_setting_form_label_web_ga: "Web Google Analytic Key",
    analytics_google_setting_form_ph_web_ga:
      "Enter your web google analytic key",
    analytics_google_setting_form_label_app_ga: "App Google Analytic Key",
    analytics_google_setting_form_ph_app_ga:
      "Enter your app google analytic key",
    analytics_google_setting_form_validation_required: "Required",
    analytics_google_setting_form_success:
      "Google analytics key saved successfully!",

    analytics_country: "Country",
    analytics_exhibitor: "Exhibitor",
    analytics_unknown: "Unknown",
    analytics_tags: "Tags",
    analytics_keyword: "Keyword",

    // Analytics [Dashboard Insights]
    analytics_dashboard_chart_1st_header: "Engagement",
    analytics_dashboard_chart_1st_subheader:
      "Chart view of how active users have been over the selected date range",
    analytics_dashboard_export_not_loggedin_user_title:
      "Export Not Loggedin Users",
    analytics_dashboard_export_not_loggedin_user_subtitle:
      "Do you want to download the Excel file for the users, who is not loggedin yet? To proceed, click the download button.",

    // Analytics [Exhibitors Insights]
    analytics_exhibitorsinsights_table_header_text1: "Top Countries",
    analytics_exhibitorsinsights_table_subheader_text1:
      "(Countries from which top exhibitors belongs)",

    analytics_exhibitorsinsights_table_header_text2: "Top Category",
    analytics_exhibitorsinsights_table_subheader_text2:
      "(Most used category related to exhibitors)",
    analytics_exhibitorsinsights_table_thead_text1: "Number of times used view",

    analytics_exhibitorsinsights_table_header_text3: "Top exhibitors",
    analytics_exhibitorsinsights_table_subheader_text3:
      "(Exhibitor profiles with most user engagement)",

    analytics_exhibitorsinsights_exhibitorname: "Exhibitor name",
    analytics_exhibitorsinsights_numberofprofileview: "Number of Profile view",
    analytics_exhibitorsinsights_numberoffavorites: "Number of favorites",

    analytics_exhibitorsinsights_chart_header_text1: "Exhibitors Engagement",
    analytics_exhibitorsinsights_chart_subheader_text1:
      "(Chart view of how actively the exhibitor feature has been used over the selected date range)",

    // Analytics [Sponsors Insights]

    analytics_sponsorsinsights_chart_header_text1: "Sponsors Engagement",
    analytics_sponsorsinsights_chart_subheader_text1:
      "(Chart view of how actively the sponsor feature has been used over the selected date range)",

    analytics_sponsorsinsights_table_header_text1: "Most searched keywords",
    analytics_sponsorsinsights_table_subheader_text1:
      "(Most searched keywords related to sponsors)",

    analytics_sponsorsinsights_table_header_text2: "Top sponsors",
    analytics_sponsorsinsights_table_subheader_text2:
      "(Sponsor profiles with most user engagement)",

    analytics_sponsorsinsights_table_thead_text1: "Number of times searched",
    analytics_sponsorsinsights_table_thead_text2: "Number of hits",
    analytics_sponsorsinsights_table_thead_text3: "Sponsor name",
    analytics_sponsorsinsights_table_thead_text4: "Number of Profile view",
    analytics_sponsorsinsights_table_thead_text5: "Number of favorites",

    // Analytics [Social Feeds]

    analytics_socialfeeds_table_header_text1: "Social Feed Engagement",
    analytics_socialfeeds_table_subheader_text1:
      "(top users who were active on social feed app)",

    analytics_socialfeeds_table_thead_text1: "User name",
    analytics_socialfeeds_table_thead_text2: "Number of posts",
    analytics_socialfeeds_table_thead_text3: "Number of Comments",
    analytics_socialfeeds_table_thead_text4: "Number of reactions",
    analytics_socialfeeds_table_thead_text5: "Number of polls",

    analytics_socialfeeds_chart_1st_header: "Social feed Posting Types",
    analytics_socialfeeds_chart_1st_subheader:
      "(Circular Chart for the classification of social feed posts in the event app)",

    // Analytics [Attendees Messaging]

    analytics_attendeesmessaging_table_header_text1: "Messaging Engagement",
    analytics_attendeesmessaging_table_subheader_text1:
      "(Chart view of how attendees communicated over the selected date range)",

    // Analytics [Attendees Network]
    analytics_attendeesnetworking_table_header_text1: "Network Engagement",
    analytics_attendeesnetworking_table_subheader_text1:
      "(Chart view of how active users has been on using the networking feature of the app over the selected date range)",

    analytics_attendeesmessaging_table_header_text2: "Most search keywords",
    analytics_attendeesmessaging_table_subheader_text2:
      "(Most searched keywords related to attendees)",

    analytics_attendeesmessaging_table_header_text3: "Most active networks",
    analytics_attendeesmessaging_table_subheader_text3:
      "(Attendees who made the most networking actions with the other app users)",

    analytics_attendeesmessaging_table_header_text4: "Popular Attendees",
    analytics_attendeesmessaging_table_subheader_text4:
      "(Attendees who received the most networking actions from the other app users)",

    analytics_attendeesmessaging_table_thead_text1: "Keywords",
    analytics_attendeesmessaging_table_thead_text2: "Number of times searched",
    analytics_attendeesmessaging_table_thead_text3: "Number of hits",
    analytics_attendeesmessaging_table_thead_text4: "Attendee name",
    analytics_attendeesmessaging_table_thead_text5: "Number of Profile view",
    analytics_attendeesmessaging_table_thead_text6: "Number of Messages",

    // Analytics [Speakers]

    analytics_speakers_table_header_text1: "Speakers Engagement",
    analytics_speakers_table_subheader_text1:
      "Chart view of how actively speakers feature has been used over the selected date range",

    analytics_speakers_table_header_text2: "Most searched keywords",
    analytics_speakers_table_subheader_text2:
      "(most searched keywords related to speakers)",

    analytics_speakers_table_thead_text1: "Keywords",
    analytics_speakers_table_thead_text2: "Number of time searched",
    analytics_speakers_table_thead_text3: "Number of hits",

    analytics_speakers_chart_1st_header: "Top speakers",
    analytics_speakers_chart_1st_subheader:
      "Speaker profiles with most user engagement",

    analytics_speakersinsights_table_thead_text5: "Speaker name",
    analytics_speakersinsights_table_thead_text6: "Number of Profile view",

    // Analytics [Sessions]
    analytics_sessions_chart_subheader: "(Today's Data)",

    analytics_sessions_table_header_text1: "Most searched keywords",
    analytics_sessions_table_subheader_text1:
      "(Most searched keywords related to session)",

    analytics_sessions_table_header_text2: "Q&A Insights",
    analytics_sessions_table_subheader_text2:
      "(Most active Q&A for top session)",

    analytics_sessions_table_header_text3: "Top sessions",
    analytics_sessions_table_subheader_text3:
      "(Session with most user engagement)",

    analytics_sessions_table_header_text4: "Session Scanning",
    analytics_sessions_table_subheader_text4:
      "(Session Scanning Analytics / Attendance export)",

    analytics_sessions_table_header_text5: "RSVP Status",
    analytics_sessions_table_subheader_text5: "(RSVP user status per session )",

    analytics_sessions_table_thead_text1: "Keywords",
    analytics_sessions_table_thead_text2: "Number of times searched",
    analytics_sessions_table_thead_text3: "Number of hits",

    analytics_sessions_table_thead_text4: "Session",
    analytics_sessions_table_thead_text5: "Added question",
    analytics_sessions_table_thead_text6: "Answered question",
    analytics_sessions_table_thead_text7: "Liked",
    analytics_sessions_table_thead_text8: "Pinned",

    analytics_sessions_table_thead_text9: "Session name",
    analytics_sessions_table_thead_text10: "Track",
    analytics_sessions_table_thead_text11: "Number of views",
    analytics_sessions_table_thead_text12: "Number of favorites",
    analytics_sessions_table_thead_text13: "Session speakers",

    analytics_sessions_table_thead_text14: "Session name",
    analytics_sessions_table_thead_text15: "Attendee",
    analytics_sessions_table_thead_text16: "Type",
    analytics_sessions_table_thead_text17: "Check-in at",

    analytics_sessions_table_thead_text18: "Session name",
    analytics_sessions_table_thead_text19: "Attendee",
    analytics_sessions_table_thead_text20: "RSVP Time",

    // Analytics [Advertisement]
    analytics_adview_preparing: "Preparing Advertisement View",
    analytics_adclick_preparing: "Preparing Advertisement Click",
    analytics_adview_title: "Advertisement View",
    analytics_adview_description:
      "Total no of users count who viewed at least any of the advertisements",
    analytics_adclick_title: "Advertisement Click",
    analytics_adclick_description:
      "Total no of users count who clicked at least any of the advertisements",
    analytics_ad_no_content: "Not data found",
    analytics_ad_th1: "Image",
    analytics_ad_th2: "Name",
    analytics_ad_th3: "Display Screen",
    analytics_ad_th4: "Total Clicked Count",
    analytics_ad_th5: "Action",
    analytics_ad_th6: "Total Viewed Count",
    analytics_ad_viewuser_th1: "Name",
    analytics_ad_viewuser_th2: "Email",
    analytics_ad_viewuser_th3: "Date & Time",
    analytics_ad_clickedby: "Clicked By",
    analytics_ad_viewedby: "Viewed By",
    analytic_no_advertisement_clicked: "No advertisement Clicked",
    analytic_no_advertisement_viewed: "No advertisement Viewed",

    // Polls & Live QA
    poll_liveqa_submenu_title1: "Live Q&A",
    poll_liveqa_submenu_description1: "Manage Live Q&A",
    poll_liveqa_submenu_title2: "Polls",
    poll_liveqa_submenu_description2: "Manage Polls",
    poll_liveqa_submenu_title3: "Rating",
    poll_liveqa_submenu_description3: "Check Users Rating",

    polls_option_session_ph: "Search and select session",
    polls_qa_no_session_added: "No session added",
    polls_qa_refresh_qa_question: "Refresh Live Q&A Questions",
    polls_qa_broadcast_qa_question: "Go Live",
    polls_qa_export_text_export_live_qa: "Export Live Q&A",
    polls_qa_autopublish_qa: "Auto Publish Q&A",
    polls_qa_mark_imp_selected: "Mark selected as important",
    polls_qa_mark_unimp_selected: "Mark selected as unimportant",
    polls_qa_mark_imp_all: "Mark all as important",
    polls_qa_mark_unimp_all: "Mark all as unimportant",
    polls_qa_mark_unpub_selected: "Unpublish selected",
    polls_qa_mark_unpub_all: "Unpublish all",
    polls_qa_mark_pub_selected: "Publish selected",
    polls_qa_mark_pub_all: "Publish all",
    polls_qa_table_list_qestions: "Questions",
    polls_qa_table_list_replies: "Replies",
    polls_qa_table_list_action: "Action",
    polls_qa_table_poll_result: "Results",
    polls_qa_table_poll_analytics: "Analytics",
    polls_qa_text_selected_qa_marked_imp:
      "Selected Q&A questions are marked as important",
    polls_qa_text_selected_qa_marked_unimp:
      "Selected Q&A questions are marked as unimportant",
    polls_qa_text_all_qa_marked_imp:
      "All Q&A questions are marked as important!",
    polls_qa_text_all_qa_marked_unimp:
      "All Q&A questions are marked as unimportant!",
    polls_qa_text_selected_qa_marked_unpub:
      "Unpublished the selected Q&A questions",
    polls_qa_text_all_qa_marked_unpub: "Unpublished all Q&A questions",
    polls_qa_text_selected_qa_marked_pub:
      "Published the selected Q&A questions",
    polls_qa_text_all_qa_marked_pub: "Published all Q&A questions",
    polls_qa_text_add_qa: "Add Q&A",
    polls_qa_text_live_qa: "Live Q&A",
    polls_qa_text_create_live_qa: "Create Live Q&A",
    polls_qa_message_qa_added_seccess: "Q&A added successfully!",
    polls_qa_form_label_session: "Session",
    polls_qa_form_label_session_placeholder: "Select session",
    polls_qa_form_label_what_you_ask: "What would you like to ask?",
    polls_qa_form_label_what_you_ask_placeholder: "Ask your Q&A question",
    polls_qa_validation_required: "Required",
    polls_qa_validation_add_option_3: "Add option 3 also!",
    polls_qa_text_reply_to: "Reply to",
    polls_qa_text_refresh_live_qa_replies: "Refresh Live QA Replies",
    polls_qa_reply_form_label_reply_placeholder: "Reply to the question",
    polls_qa_reply_validation_blank_space:
      "Reply can not contain only blank spaces",
    polls_qa_message_liveqa_published: "Q&A question is published",
    polls_qa_message_liveqa_unpublished: "Q&A question is unpublished",

    polls_qa_active_polls: "Active Polls",
    polls_qa_archived_polls: "Archived Polls",
    polls_qa_table_list_polls: "Polls",
    polls_qa_text_add_poll: "Add Poll",
    polls_export_text_export_polls: "Export Polls",
    polls_qa_text_create_poll: "Create Poll",
    polls_qa_message_poll_added_seccess: "Poll added successfully!",
    polls_qa_text_poll_added_cannot_edit_archived_only:
      "Poll once created can't be edited. It can be archived.",
    polls_qa_poll_form_label_what_you_ask: "What would you like to ask?",
    polls_qa_poll_form_label_what_you_ask_placeholder: "Ask your poll question",
    polls_qa_poll_form_label_options: "Add Options",
    polls_qa_poll_form_label_options_optional_placeholder: "Optional",
    polls_qa_poll_form_label_checkbox_allow_multiple_options:
      "Allow attendees to select multiple options",
    polls_qa_poll_form_label_checkbox_show_result_after_submission:
      "Show result after submission",
    polls_qa_message_poll_activated_success: "Poll is activated successfully",
    polls_qa_message_poll_activated_error:
      "Something went wrong while activating the poll!",
    polls_qa_message_poll_archived_success: "Poll is archived successfully",
    polls_qa_message_poll_archived_error:
      "Something went wrong while archiving the poll!",
    polls_qa_text_poll_result: "Poll Result",
    polls_qa_text_poll_result_total_count: "Total Count",
    polls_qa_text_poll_result_analytics_title: "Poll Result Analytics",
    polls_qa_text_poll_result_total_users: "Total Users",

    polls_qa_rating_text_reset_session_rating_form:
      "Reset rating form for current session",
    polls_qa_rating_text_reset_session_rating_form_info:
      "Reset the review questions for only the current session",
    polls_qa_rating_reset_session_rating_form_confirmation_title:
      "Reset Rating Form",
    polls_qa_rating_reset_session_rating_form_confirmation_subtitle:
      "Resetting current session form will result in loss of corresponding data.",
    polls_qa_rating_reset_session_rating_form_success:
      "This session's rating form has been reseted successfully!",
    polls_qa_rating_reset_session_rating_form_error_noform:
      "This session doesn't have its own rating form",
    polls_qa_rating_text_update_session_rating_form:
      "Update rating form for current session",
    polls_qa_rating_text_update_session_rating_form_info:
      "Change the review questions for only the current session",
    polls_qa_rating_text_update_global_rating_form: "Update Global",
    polls_qa_rating_text_update_global_rating_form_info:
      "Change the global review questions",
    polls_qa_rating_text_poll_result: "Poll Result",
    polls_qa_rating_text_user_rating: "users rating",
    polls_qa_rating_text_5_star: "5 Stars",
    polls_qa_rating_text_4_star: "4 Stars",
    polls_qa_rating_text_3_star: "3 Stars",
    polls_qa_rating_text_2_star: "2 Stars",
    polls_qa_rating_text_1_star: "1 Star",
    polls_qa_rating_th_comment: "Comment",
    polls_qa_rating_th_commentedby: "Commented By",
    polls_qa_rating_text_choose_session: "Choose a Session to view the ratings",

    polls_qa_survey_table_th_surveyno: "Survey Number",
    polls_qa_survey_table_th_survey_name: "Survey Name",
    polls_qa_survey_table_th_survey_responses: "No. of Responses",
    polls_qa_survey_table_th_survey_preview: "Preview",
    polls_qa_survey_table_th_survey_mandatory: "Mandatory",
    polls_qa_survey_table_th_action: "Action",
    polls_qa_survey_text_ispublished: "Is published",
    polls_qa_survey_text_ismandatory: "Is mandatory",
    polls_qa_survey_alert_published: "Survey form published successfully.",
    polls_qa_survey_alert_unpublished: "Survey form unpublished successfully.",
    polls_qa_survey_alert_mandatory: "Survey form marked as mandatory.",
    polls_qa_survey_alert_not_mandatory: "Survey form is not mandatory.",
    polls_qa_survey_text_delete_subtitle:
      "This will permanently delete the survey form and its responses. Continue?",
    polls_qa_survey_delete_success: "Survey form deleted successfully.",
    survey_tooltip_mandatory:
      "The mandatory survey will open a survey blocker screen in the app. So, the user has to submit the survey to get access to other features of the event.",
    survey_tooltip_preview:
      "Please enable this preview to show the survey in the app / web",

    // Polls & Live QA -> Polls
    polls_qa_broadcast_live_polls: "Live Polls",
    polls_qa_text_live_polls: "Live Polls",
    livepoll_display_info: "Live poll Display info",
    polls_qa_broadcast_live_poll_display_header:
      "Make your session more interactive with a bigger screen view!",
    polls_qa_broadcast_live_poll_display_subheader:
      "To display the Live Poll you can visit the link :",
    polls_qa_broadcast_live_display: "Live display",
    liveqa_display_info: "LiveQA Display info",
    polls_qa_broadcast_live_qa_display_header:
      "Make your session more interactive with a bigger screen view!",
    polls_qa_broadcast_live_qa_display_subheader:
      "To display the LiveQA you can visit the link :",

    // Speaker
    speaker_button_text: "Speaker",
    speaker_import_header: "Import Speakers",
    speaker_import_validation1: "Could not parse the file.",
    speaker_import_validation2:
      "The CSV / XLS file contains 1 or more invalid email ids",
    speaker_import_validation3:
      "The CSV / XLS file contains 1 or more duplicate entries",
    speaker_import_validation4:
      "The CSV / XLS file format is non-compatible or the data is not well formatted. Please refer to the template",
    speaker_import_validation5: "Import failed. Please try again!",
    speaker_message_user_imported: "Speakers imported successfully.",
    speaker_left: "speakers left",
    speaker_table_list_rowno: "1",
    speaker_table_list_fname: "Firstname",
    speaker_table_list_lname: "Lastname",
    speaker_table_list_company: "Company",
    speaker_table_list_position: "Position",
    speaker_table_list_about: "About",
    speaker_table_list_email: "Email",
    speaker_table_list_phone: "Phone",
    speaker_table_list_facebook: "Facebook",
    speaker_table_list_linkedin: "LinkedIn",
    speaker_table_list_twitter: "Twitter",
    speaker_table_list_profile: "Profile",
    speaker_table_list_file1: "File1",
    speaker_table_list_file2: "File2",
    speaker_table_list_file3: "File3",
    speaker_table_list_file4: "File4",
    speaker_table_list_file5: "File5",
    speaker_message_processing_data: "Processing Data",
    speaker_import_text_click_drag_drop_1: "Click here or drag & drop",
    speaker_import_text_click_drag_drop_2: "to upload completed template.",
    speaker_import_download_template: "Download Template",
    speaker_import_download_template_subtitle1:
      "Download and complete the provided template. Upload the completed template when you're ready to send email invitations to speakers.",
    speaker_import_sample_csv: "Sample CSV",
    speaker_import_sample_xls: "Sample XLS",
    speaker_import_note1: "",
    speaker_import_note2: "Duplicate data will be deleted.",
    speaker_import_note3:
      "Errors in any information will be ignored (not created).",
    speaker_message_imported: "Speaker(s) imported successfully!",
    speaker_message_imported_nodata: "No New Data available to update Speaker",

    // Sponsor
    sponsor_button_text: "Sponsor",
    sponsor_import_header: "Import Sponsor",
    sponsor_import_validation1: "Could not parse the file.",
    sponsor_import_validation2:
      "The CSV / XLS file contains 1 or more invalid email ids",
    sponsor_import_validation3:
      "The CSV / XLS file contains 1 or more duplicate entries",
    sponsor_import_validation4:
      "The CSV / XLS file format is non-compatible or the data is not well formatted. Please refer to the template",
    sponsor_import_validation5: "Import failed. Please try again!",
    sponsor_message_user_imported: "Sponsors imported successfully!",
    sponsor_left: "sponsors left",
    sponsor_table_list_rowno: "1",
    sponsor_table_list_name: "Name",
    sponsor_table_list_type: "Type",
    sponsor_table_list_description: "Description",
    sponsor_table_list_logo: "Logo",
    sponsor_table_list_banner: "Banner",
    sponsor_table_list_videourl: "Video Url",
    sponsor_table_list_contactperson: "Contact Person",
    sponsor_table_list_email: "Email",
    sponsor_table_list_phonenumber: "Phone Number",
    sponsor_table_list_website: "Website",
    sponsor_table_list_facebook: "Facebook",
    sponsor_table_list_linkedin: "LinkedIn",
    sponsor_table_list_twitter: "Twitter",
    sponsor_table_list_instagram: "Instagram",
    sponsor_table_list_whatsapp: "WhatsApp",
    sponsor_message_processing_data: "Processing Data",
    sponsor_import_text_click_drag_drop_1: "Click here or drag & drop",
    sponsor_import_text_click_drag_drop_2: "to upload completed template.",
    sponsor_import_download_template: "Download Template",
    sponsor_import_download_template_subtitle1:
      "Download and complete the provided template. Upload the completed template when you're ready to send email invitations to sponsors.",
    sponsor_import_sample_csv: "Sample CSV",
    sponsor_import_sample_xls: "Sample XLS",
    sponsor_import_note1: "",
    sponsor_import_note2: "Duplicate data will be deleted.",
    sponsor_import_note3:
      "Errors in any information will be ignored (not created).",
    sponsor_message_imported: "Sponsor(s) imported successfully!",
    sponsor_message_imported_nodata:
      "Data is not well formatted or no new data is available to update the Sponsor!",

    // Exhibitor
    exhibitor_button_text: "Exhibitor",
    exhibitor_import_header: "Import Exhibitors",
    exhibitor_import_validation1: "Could not parse the file.",
    exhibitor_import_validation2:
      "The CSV / XLS file contains 1 or more invalid email ids",
    exhibitor_import_validation3:
      "The CSV / XLS file contains 1 or more duplicate entries",
    exhibitor_import_validation4:
      "The CSV / XLS file format is non-compatible or the data is not well formatted. Please refer to the template",
    exhibitor_import_validation5: "Import failed. Please try again!",
    exhibitor_message_user_imported: "Exhibitors imported successfully!",
    exhibitor_left: "exhibitors left",
    exhibitor_table_list_rowno: "1",
    exhibitor_table_list_name: "Name",
    exhibitor_table_list_booth: "Booth",
    exhibitor_table_list_description: "About",
    exhibitor_table_list_logo: "Logo",
    exhibitor_table_list_banner: "Banner",
    exhibitor_table_list_contactperson: "Contact Person",
    exhibitor_table_list_phonenumber: "Phone Number",
    exhibitor_table_list_email: "Email",
    exhibitor_table_list_website: "Website",
    exhibitor_table_list_facebook: "Facebook",
    exhibitor_table_list_linkedin: "LinkedIn",
    exhibitor_table_list_twitter: "Twitter",
    exhibitor_table_list_instagram: "Instagram",
    exhibitor_table_list_whatsapp: "WhatsApp",
    exhibitor_message_processing_data: "Processing Data",
    exhibitor_import_text_click_drag_drop_1: "Click here or drag & drop",
    exhibitor_import_text_click_drag_drop_2: "to upload completed template.",
    exhibitor_import_download_template: "Download Template",
    exhibitor_import_download_template_subtitle1:
      "Download and complete the provided template. Upload the completed template when you're ready to send email invitations to the exhibitor.",
    exhibitor_import_sample_csv: "Sample CSV",
    exhibitor_import_sample_xls: "Sample XLS",
    exhibitor_import_note1: "",
    exhibitor_import_note2: "Duplicate data will be deleted.",
    exhibitor_import_note3:
      "Errors in any information will be ignored (not created).",
    exhibitor_message_imported: "Exhibitor(s) imported successfully!",
    exhibitor_message_imported_nodata:
      "No New Data available to update Exhibitor!",

    general_import_validationphone:
      "The CSV / XLS file contains 1 or more invalid phone no",
    general_import_validationdata: "All the mandatory fields are required",

    // Abstract
    tickets_submenu_sections_proposal: "Abstract Management",
    proposal_submenu_title1: "Abstract Wizard",
    proposal_submenu_description1: "Abstract Wizard",
    proposal_submenu_title2: "Dashboard",
    proposal_submenu_description2: "Dashboard",
    proposal_submenu_title3: "Responses",
    proposal_submenu_description3: "Responses",
    proposal_submenu_title4: "Abstract Form",
    proposal_submenu_description4: "Abstract Form",
    proposal_submenu_title5: "Reviewer",
    proposal_submenu_description5: "Reviewer",

    proposal_wizard_tab_1: "Abstract Info",
    proposal_wizard_tab_2: "Design Form",
    proposal_wizard_tab_3: "Add Reviewer",
    proposal_wizard_tab_4: "Review Criteria",
    proposal_wizard_tab_5: "Publish",

    proposal_name: "Abstract Name",
    proposal_description: "Abstract Description",
    proposal_category: "Abstract Category (for internal use)",
    proposal_image_subtitle_info:
      "* Recommended image size - 940 wide x 445 tall",
    proposal_form_button_save: "Save and Add Reviewer",
    proposal_form_button_continue: "Save and Continue",

    proposal_wizard_add_reviewer_heading:
      "Add reviewers to select and rank the submissions",
    proposal_wizard_add_reviewer_button: "Add New reviewer",
    proposal_wizard_reviewerlist: "Reviewer List",
    proposal_wizard_selected_reviewerlist: "Selected Reviewer List",
    proposal_wizard_no_reviewer_content_title: "No Reviewer(s)",
    proposal_wizard_no_reviewer_content_subtitle:
      "Please add one to make it appear in the list",
    proposal_wizard_reviewer_name: "Reviewer Name",
    proposal_wizard_reviewer_distribution_text: "Reviewer Distribution",
    proposal_wizard_reviewer_distribution_circular_text:
      "Circular distribution among reviewers in the sequence of submission",
    proposal_wizard_reviewer_distribution_random_text: "Random distribution",
    proposal_wizard_reviewer_distribution_random_selected_text:
      "Random distribution with max submissions per reviewer",
    proposal_wizard_reviewer_distribution_value_placeholder: "Enter value",
    proposal_wizard_reviewer_distribution_manual_text: "Manual",

    proposal_wizard_reviewer_save_button: "Save & Add Review Criteria",
    proposal_wizard_reviewer_skip_button: "Skip & Proceed",
    proposal_wizard_reviewer_validation: "Please select Reviewer(s)",

    proposal_wizard_review_criteria_heading: "Review Criteria & Points",
    proposal_wizard_review_criteria_subheading:
      "Add some criteria and set points for the reviewers to select and rank the submissions",
    proposal_wizard_review_category_name: "Category Title",
    proposal_wizard_review_category_range: "Point Range",
    proposal_wizard_review_criteria_allow_note: "Allow reviewer to add a note",
    proposal_wizard_review_category_save_button: "Save",

    proposal_wizard_review_publish_heading: "Abstract Link",
    proposal_wizard_review_publish_subheading:
      "Once you publish the Abstract you are ready to share the link to receive invites for the event.",
    proposal_wizard_review_publish_application_duration: "Application Duration",
    proposal_wizard_review_publish_review_duration: "Review Duration",
    proposal_wizard_review_publish_button: "Publish",

    proposal_wizard_before_publish:
      "Before publishing please set the duration of the application to receive & to review",
    proposal_wizard_before_publish_heading: "Set abstract duration and limit",

    dashboard_proposal_name: "Abstract Name",
    dashboard_form_url: "Form URL",
    dashboard_proposal_category: "Category",
    dashboard_form_live_status: "Form Live Status",
    dashboard_no_of_responses: "No. of Responses",
    dashboard_action: "Action",

    dashboard_button_add_reviewer: "Add Reviewer",
    dashboard_button_publish: "Publish Now",
    dashboard_button_unpublish: "Un-Publish Now",

    proposal_text_no_proposals: "No Abstracts",
    proposal_text_no_form: "No Form",

    proposal_form_number_heading: "Form Number",
    proposal_form_name_heading: "Form Name",
    proposal_form_proposal_name_heading: "Abstract Name",
    proposal_form_version_heading: "Version",
    proposal_form_application_duration_heading: "Application Duration",

    proposal_reviewer_name: "Reviewer Name",
    proposal_reviewer_email: "Reviewer Email",
    proposal_reviewer_action: "Action",
    proposal_reviewer_remove_text: "Remove Reviewer",
    proposal_text_no_reviewer_found: "No Reviewer Found",
    proposal_text_no_reviewer: "No Reviewer",

    proposal_for_response_tab_reviewed: "Reviewed",
    proposal_for_response_tab_unreviewed: "Unreviewed",
    proposal_for_response_tab_shorlisted: "Shortlisted",

    proposal_for_response_tab_unreviewed_proposal: "Submitted DateTime",
    proposal_for_response_tab_unreviewed_proposedby: "Submitted By",
    proposal_for_response_tab_unreviewed_category: "Category",
    proposal_for_response_tab_unreviewed_assignedto: "Assigned To",
    proposal_for_response_tab_unreviewed_action: "Action",

    proposal_for_response_tab_reviewed_proposal: "Submitted DateTime",
    proposal_for_response_tab_reviewed_proposedby: "Submitted By",
    proposal_for_response_tab_reviewed_points: "Avg. Review Points",
    proposal_for_response_tab_reviewed_rankedby: "Ranked By",
    proposal_for_response_tab_reviewed_action: "Action",

    proposal_for_response_tab_shorlisted_proposal: "Submitted DateTime",
    proposal_for_response_tab_shorlisted_proposedby: "Submitted By",
    proposal_for_response_tab_shorlisted_points: "Avg. Review Points",
    proposal_for_response_tab_shorlisted_rankedby: "Ranked By",
    proposal_for_response_tab_shorlisted_action: "Action",

    proposal_text_no_unreviewed_found: "No Unreviewed Responses Found",
    proposal_text_no_unreviewed: "No Unreviewed Responses Yet",

    proposal_text_no_reviewed_found: "No Reviewed Responses Found",
    proposal_text_no_reviewed: "No Reviewed Responses Yet",

    proposal_text_no_shorlisted_found: "No Shortlisted Responses Found",
    proposal_text_no_shorlisted: "No Shortlisted Responses Yet",

    proposal_for_response_button_view: "View",
    proposal_for_response_button_change_reviewer: "Change Reviewer",
    proposal_for_response_button_assign_reviewer: "Assign Reviewer",
    proposal_for_response_button_shortlist: "Move to shortlist",
    proposal_for_response_button_send_ticket: "Send Ticket",
    proposal_for_response_button_sent_ticket: "Sent ticket",
    proposal_for_response_button_welcome_email: "Confirm",

    proposal_publish_form_validation_application_end_date_should_greater_equal_than_application_start_date:
      "Application End Date should be equal to or greater than the Start Date.",
    proposal_publish_form_validation_review_end_date_should_greater_equal_than_review_start_date:
      "Review End Date should be equal to or greater than Start Date.",
    proposal_form_published_successfully:
      "Abstract Form Published successfully",
    proposal_reviewer_deleted: "Reviewer deleted successfully",
    reviewer_title_delete_reviewer: "Delete Reviewer",
    reviewer_text_permanently_delete_reviewer:
      "This will permanently delete the reviewer. Continue?",

    proposal_reviewer_add_succesfully: "Reviewer added successfully",
    proposal_review_criteria_add_succesfully:
      "Review Criteria added successfully",
    proposal_info_updated_success: "Abstract info updated successfully!",
    proposal_info_added_success: "Abstract info added successfully!",
    proposal_form_updated_success: "Form updated successfully!",
    proposal_form_button_update: "Update",
    reviewer_form_label_password_placeholder: "Enter the password for reviewer",
    reviewer_change_button: "Change",
    reviewer_change_text: "Change Reviewer",
    proposal_reviewer_change_succesfully: "Reviewer Changed Successfully",
    proposal_shorlisted_succesfully: "Abstract Shortlisted  Successfully",
    proposal_form_unpublished_successfully:
      "Abstract form unpublished successfully",
    view_proposal: "View Abstract",
    view_proposal_tab1: "Abstract Details",
    view_proposal_tab2: "Presentation Attachment",
    view_proposal_tab3: "Rank Abstract",
    rank_proposal: "Rate",

    proposal_send_welcome_mail: "Send Welcome Mail",
    proposal_send_welcome_mail_confirmation:
      "This will create a user as a speaker. Continue?",

    proposal_send_ticket: "Send Ticket",
    proposal_send_ticket_text: "Ticket List",
    proposal_send_ticket_button: "Send",
    proposal_response_send_ticket_successfully: "Ticket Sent Successfully",
    manage_proposal: "Manage Abstract",
    proposal_setting: "Abstract Settings",
    proposal_setting_note_text1: "Abstract can be Rejected by Reviewer",
    proposal_setting_note_text2:
      "Proposals can be re-submitted if the reviewer marks it as incomplete",

    reviewer_distribution_circular:
      "Abstract Responses will be assigned to a reviewer on a round-robin basis",
    reviewer_distribution_random:
      "Abstract Responses will be assigned to each reviewer on maximum submission value",
    reviewer_distribution_manual:
      "Abstract Responses will not be assigned to any reviewer. It will be auto-assigned to admin",

    proposal_review_rank_add_succesfully:
      "Abstract Response received successfully",
    proposal_mark_as_incomplete_btn: "Mark as Incomplete",
    proposal_response_review_date_expired: "Review Date Expired",
    proposal_response_reject: "Abstract response rejected successfully",
    proposal_response_approved: "Abstract response approved successfully",
    proposal_response_resubission:
      "Abstract response reviewed for resubmission",
    proposal_allow_resubmission: "Allow Resubmission",
    assigned_reviewer: "Assigned Reviewer",
    proposal_filter: "All",
    proposal_sort: "Sort by",
    proposal_mark_as_reject: "Reject",
    proposal_mark_as_approve: "Rate",
    proposal_for_response_button_send_welcome_email: "Send Shortlisted Mail",
    proposal_reviewer_change_password: "Change Password",
    proposal_reviewer_pwd_send:
      "Reviewer password changed and credentials sent successfully",
    reviewer_change_and_send_button: "Change and Send",
    proposal_heading: "Abstract",
    proposal_subheading: "Manage, create, and assign abstracts",
    response_heading: "Responses",
    response_subheading: "Review, assign and shortlist received responses",
    reviewer_heading: "Reviewers",
    reviewer_subheading: "Add, remove or manage reviewers",
    proposal_confirm:
      "Confirm the user registration to the event & send the welcome mail",
    proposal_confirm_button: "Send shortlisted mail",
    proposal_disqualified_text: "Disqualified",
    proposal_rate_info_text: "To rate the ranks are required",

    // Course
    course_submenu_title1: "Wizard",
    course_submenu_description1: "Wizard",
    course_submenu_title2: "Manage Courses",
    course_submenu_description2: "Manage courses",
    course_submenu_title3: "Manage Quiz",
    course_submenu_description3: "Manage quiz",

    course_wizard_tab_1: "Course Details",
    course_wizard_tab_2: "Lessons",
    course_wizard_tab_4: "Pricing",
    course_wizard_tab_5: "Publish",

    course_no_course_content_title: "No course added",
    course_no_course_content_subtitle:
      "Please add one to make it appear in the list",
    course_title_manage_course: "Manage course",

    course_form_label_course_cover_image: "Course Cover Image",
    course_form_label_course_cover_video: "Course Cover Video",
    course_form_label_course_name: "Course Name",
    course_form_ph_course_name: "Enter course name",
    course_form_label_course_description: "Course Description",
    course_form_ph_course_description: "Enter course description",
    course_form_label_course_listing: "Course Listing",
    course_form_course_listing_option1: "Listed",
    course_form_course_listing_option2: "Unlisted",
    course_form_label_course_instructor: "Course Instructor",
    course_form_ph_course_instructor: "Select course instructors",
    course_form_label_course_tags: "Related Tags",
    course_form_ph_course_tags: "Select related tags",
    course_form_validation_required: "Required",
    course_form_validation_course_price_invalid:
      "Enter course amount greater than 0",
    course_form_validation_course_already_exist: "This course already exists.",
    course_form_basic_details_save_success: "Course basic details saved",
    course_form_basic_details_save_warning_instructor_not_saved:
      "Course basic details saved, but something went wrong while updating instructor",

    course_chapter_text_no_chapter_added:
      "No chapter added. Add new chapter to display here.",
    course_chapter_form_label_chapter_name: "Chapter Name",
    course_chapter_form_ph_chapter_name: "Enter chapter name",
    course_chapter_form_validation_required: "Required",
    course_chapter_form_validation_chapter_already_exist:
      "This chapter already exist for selected course",
    course_chapter_update_success: "Chapter updated successfully!",
    course_chapter_delete_chapter: "Delete Chapter",
    course_chapter_delete_chapter_confirmation:
      "This will permanently delete the chapter and its contents. Continue?",
    course_chapter_delete_success: "Chapter deleted successfully!",

    course_lesson_text_add_lesson: "Add Lesson",
    course_lesson_text_update_lesson: "Edit Lesson",
    course_lesson_text_private_section: "Private Access",
    course_lesson_form_label_lesson_cover_image:
      "Lesson Image / Video Thumbnail",
    course_lesson_form_course_lesson_videotype_option1: "Upload Video",
    course_lesson_form_course_lesson_videotype_option2: "Video from URL",
    course_lesson_form_label_lesson_cover_video: "Lesson Video",
    course_lesson_form_ph_lesson_cover_video:
      "Click here to select a video file",
    course_lesson_form_label_lesson_cover_audio: "Audio File (Optional)",
    course_lesson_form_ph_lesson_cover_audio:
      "Click here to select a audio file",
    course_lesson_form_label_lesson_cover_link: "Lesson Video Link",
    course_lesson_form_ph_lesson_cover_link: "Enter video link",
    course_lesson_form_label_lesson_name: "Lesson Title",
    course_lesson_form_ph_lesson_name: "Enter lesson title",
    course_lesson_form_label_lesson_duration:
      "Lesson Average Duration (in minutes)",
    course_lesson_form_ph_lesson_duration: "Enter lesson average duration",
    course_lesson_form_label_chapter_name: "Chapter Name",
    course_lesson_form_ph_chapter_name: "Enter chapter name",
    course_lesson_form_label_short_desc: "Short Description",
    course_lesson_form_ph_short_desc: "Enter something about lesson",
    course_lesson_text_lesson_attachment: "Add Lesson Attachments",
    course_lesson_text_lesson_attachment_type1: "Text",
    course_lesson_text_lesson_attachment_type2: "Document",
    course_lesson_text_lesson_attachment_type3: "Video",
    course_lesson_text_lesson_attachment_type4: "Audio",
    course_lesson_text_lesson_attachment_type5: "Links",
    course_lesson_attachment_form_label_content_text: "Text Content",
    course_lesson_attachment_form_label_content_document: "File Attachment",
    course_lesson_attachment_form_text_content_document:
      "Drag & Drop or click here to upload new file",
    course_lesson_attachment_form_label_content_video: "Video Content",
    // course_lesson_attachment_form_label_content_audio:"Audio Content",
    course_lesson_attachment_form_label_content_link: "External URL",
    course_lesson_attachment_form_ph_content_link: "Enter a valid url",
    course_lesson_form_label_quiz: "Import Quiz",
    course_lesson_form_ph_quiz: "Import from quiz",
    course_lesson_form_text_lesson_setting: "Lesson Settings",
    course_lesson_form_label_lesson_preview_lesson: "Is this a preview lesson?",
    course_lesson_form_label_lesson_mandatory_lesson:
      "Is this a mandatory lesson?",
    course_lesson_form_label_lesson_qa_based_lesson:
      "Can users have Q&A based on this lesson?",
    course_lesson_form_validation_lesson_already_exist:
      "This lesson already exist for selected chapter",
    course_lesson_form_validation_lesson_duration_min:
      "Please enter valid positive duration",
    course_lesson_form_update_success: "Lesson updated successfully!",
    course_lesson_form_added_with_chapter_success:
      "New chapter saved with lesson!",
    course_lesson_form_added_under_chapter_success:
      "New lesson added under chapter!",

    course_pricing_form_label_course_price: "Course Pricing",
    course_pricing_form_course_price_option1: "Paid Course",
    course_pricing_form_course_price_option2: "Free Course",
    course_pricing_form_label_course_amount: "Course Price",
    course_pricing_form_ph_course_amount: "Enter course price",
    course_pricing_form_label_additional_plan:
      "Additional Plan (where this course available)",
    course_pricing_form_ph_additional_plan: "Select additional plans",
    course_pricing_form_label_isfeatured: "Is featured course",
    course_pricing_form_update_success: "Course pricing updated successfully!",

    course_publish_text_course_promote_title: "Your course has been published",
    course_publish_text_course_published_subtitle:
      "Promote your course and share this URL with your connections!",
    course_publish_text_public_paid_course: "Public and paid course",
    course_publish_text_public_course: "Public course",
    course_publish_text_course_fee: "Course Fee",
    course_publish_text_total_lessons: "Lessons in this course",
    course_publish_form_label_published: "Publish course",
    course_publish_form_published_success: "Course published successfully!",
    course_publish_form_unpublished_success: "Course unpublished successfully!",

    course_table_list_course_name: "Course Name",
    course_table_list_total_chapters: "Total Chapters",
    course_table_list_total_lessons: "Total Lessons",
    course_table_list_actions: "Actions",

    course_quiz_table_th_quizno: "Quiz Number",
    course_quiz_table_th_quiz_name: "Quiz Name",
    course_quiz_table_th_quiz_version: "Quiz Version",
    course_quiz_table_th_action: "Action",

    // Settings -> Submenu -> Billing Details
    settings_billing_details_header:
      "Check your Active users as per the selected date",
    settings_billing_details_preparing_list: "Preparing Billing History",
    settings_billing_details_table_th1: "Event Name",
    settings_billing_details_table_th2: "Username",
    settings_billing_details_table_th3: "Active date",

    characters_left: " Left",
    max_characters_left: "Max character length is: ",

    // ADVERTISEMENT
    add_recommendedsize: "* Recommended image size -",
    add_wide: "wide x",
    add_tall: "Tall",

    // ATTENDEES
    attendee_networking_option_deactivated:
      "Show networking user count option, deactivated.",
    attendee_networking_option_activated:
      "Show networking user count option, activated.",
    attendee_list_activated: "Show attendees list in sorted option activated.",
    attendee_list_deactivated:
      "Show attendees list in sorted option deactivated.",
    attendee_interest_title: "Show user count?",
    attendee_interest_subtitle:
      "Choose whether to display the number of people using the app.",
    attendee_note:
      "Note : If user count is greater than 1000, the alphabetical order will not reflect in the Apps.",

    // COMMUNITY
    community_image_subtitle_info:
      "* Recommended image size - 84 wide x 84 tall",

    // EXHIBITOR
    exhibitor_addnew: "Add New",
    exhibitor_closebutton: "Close",
    exhibitor_savechanges: "Save Changes",
    exhibitor_validation_required: "Required",
    exhibitor_validation_email_invalid: "Email is invalid",
    exhibitor_validation_phone_invalid: "Phone number is invalid",
    exhibitor_label_name: "Name",
    exhibitor_placeholder_exhibitor_name: "Enter exhibitor name",
    exhibitor_label_booth: "Booth",
    exhibitor_placeholder_booth: "Enter Booth ID",
    exhibitor_banner: "Banner",
    exhibitor_image_subtitle_info:
      "* Recommended image size - 566 wide x 368 tall",
    exhibitor_logo: "Logo",
    exhibitor_image_subtitle_info300:
      " * Recommended image size - 300 wide x 300 tall",
    exhibitor_label_about: "About",
    exhibitor_image_subtitle_info100:
      "* Recommended image size - 100 wide x 100 tall",
    exhibitor_select_from_options: "Select from options",
    exhibitor_label_email: "Email",
    exhibitor_placeholder_email: "Enter Email ID",
    exhibitor_label_phone: "Phone",
    exhibitor_placeholder_phone: "Enter Phone Number",
    exhibitor_label_website: "Website",
    exhibitor_placeholder_website: "Enter Website address",
    exhibitor_label_facebook: "Facebook Profile",
    exhibitor_placeholder_facebook: "Enter Facebook Profile Link",
    exhibitor_label_linkedin: "Linkedin Profile",
    exhibitor_placeholder_linkedin: "Enter LinkedIn Profile Link",
    exhibitor_label_twitter: "Twitter Profile",
    exhibitor_placeholder_twitter: "Enter Twitter Profile Link",
    exhibitor_userlist: "Users List",
    exhibitor_permitteduserlist: "Permitted Users List",
    exhibitor_total: "Total :",
    exhibitor_th_name: "Name",
    exhibitor_th_booth: "# Booth",
    exhibitor_th_email: "Email",
    exhibitor_th_action: "Action",
    exhibitor_duplicate_datatext: "Exhibitor Duplicate Data(By Name) will be",
    exhibitor_overwrite: "Overwrite",
    exhibitor_skip: "Skip",
    exhibitor_export_modal_title: "Export Exhibitor",
    exhibitor_export_total_data_text: "You have #total exhibitors",
    exhibitor_export_text_preparing_data:
      "Preparing the data... Excel file will be available soon.",
    exhibitor_export_text_export_csv_description:
      "Do you want to download the Excel file for the exhibitors? To proceed, click the download button. Depending on the number of exhibitors, it might take a little longer.",
    exhibitor_text_total_selected_exhibitor:
      "Total #total exhibitor(s) are selected",
    exhibitor_delete_selected_exhibitor: "Delete #total exhibitor(s)",
    exhibitor_text_all_speaker_selected: "All exhibitors are selected",
    exhibitor_text_clear_all_selected_exhibitors:
      "Clear all selected exhibitors",
    exhibitor_text_select_all_exhibitors: "Delete all #total exhibitors",
    exhibitor_title_delete_exhibitors: "Delete exhibitors",
    exhibitor_delete_exhibitors_subtitle:
      "Are you sure you want to delete #total exhibitor(s)?",
    exhibitor_deleteall: "Delete All",
    exhibitor_title_delete: "Delete All Exhibitors",
    exhibitor_text_are_you_sure_delete:
      "Are you sure you want to delete? This will delete all the exhibitors.",
    exhibitor_message_deleted: "Exhibitors deleted successfully!",

    // GALLERY
    gallery_dropzonetext: "Drag & drop or click here to upload image",
    gallery_uploadimage: "Upload Image",

    // GAMIFICATION
    gamification_clickhere: "Click Here",

    // MAPS
    maps_addnew: "Add New",
    map_label_name: "Name",
    map_label_placeholder: "Enter map name",
    map_label_address: "Address",
    map_placeholder_address: "Search address",
    map_label_city: "City",
    map_placeholder_city: "Enter city",
    map_label_state: "State",
    map_placeholder_state: "Enter state name",
    map_label_zipcode: "Zip code",
    map_placeholder_zipcode: "Enter zip code",
    map_locationmap: "Location Maps",
    map_savechanges: "Save Changes",
    map_mapname: "Please input Map name!",
    map_location: "Location is required!",
    map_interactive: "Interactive Maps",
    map_label_boothname: "Booth Name",
    map_placeholder_boothname: "Enter booth name",
    map_label_boothnumber: "Booth Number",
    map_placeholder_boothnumber: "Enter booth number",
    map_label_boothcolor: "Booth Color",
    map_placeholder_boothcolor: "Choose booth color",
    map_label_searchandlinkbooth: "Search & Link with Booth",
    map_validation_boothname: "Please input Booth Name!",
    map_validation_boothnumber: "Please input Booth Number!",
    map_label_mapname: "Map Name",
    map_placeholder_mapname: "Enter map name",
    map_validation_mapname: "Please input Map Name!",
    imap_draganddrop: "Drag & drop or click here to upload map image,",
    imap_maintain: "Please maintain at least",
    imap_400X400: "400 X 400",
    imap_2000X2000: " 2000 X 2000 ",
    imap_maxmaintain: " & max size upto ",
    imap_resolution: "resolution!",
    imap_addatleast: "Please add an image of at least,",

    // MESSAGE
    message_interest_form_modal_title_add: "Add Event Tags",
    message_interest_form_modal_title_edit: "Edit Event Tags",
    message_interest_subtitle_info1:
      "For ex - Infrastructure, Automation, Android Programming, Full Stack Developer",
    message_interest_subtitle_info2:
      "You have reached the maximum limit for event tags. You need to delete from existing ones, to add new.",
    message_eventags: "Event Tags",
    message_placeholder_eventags: "Enter event Tags",
    message_action: "Action",
    message_closebutton: "Close",
    message_savebutton: "Save",
    message_interest_title: "Attendee Invitation before messaging?",
    message_interest_subtitle_info:
      "(Recommended: If you are in doubt, leave this setting as is)",
    message_interest_note:
      "(Enter relevant tags for attendee match making & session filter)",
    message_interest_form_error_min1: "Atleast one event tag is mandatory",
    message_interest_form_error_exists: "Interest already exist",
    message_interest_form_add_success: "Event Tags Added Successfully!",
    message_interest_form_update_success: "Interest updated successfully!",

    // NEWS
    news_addNews: "Add News",
    news_closebutton: "Close",
    news_savebutton: "Save ",
    news_th_image: "Image",
    news_th_title: "Title & News",
    news_th_action: "Action",
    news_label_content: "News Content",
    news_placeholder_content: "Enter news content",
    content_news_dlt_message:
      "This will permanently delete the News. Continue?",
    content_news_dlt: "News deleted successfully",

    // POLLS
    polls_clickhere: "Click Here",

    // SCHEDULE

    // SOCIAL
    social_add_twitter: "Add Twitter",
    social_add_instagram: "Add Instagram",
    social_th_socialtype: "Social type",
    social_th_link: "Link",
    social_th_action: "Action",
    social_delete_message: "This will permanently delete the social. Continue?",
    social_insta_loading_text:
      "Please wait while we are connecting with Instagram",
    social_instagram_media_success: "You are now successfully connected",

    // SPEAKER
    speaker_addnew: "Add New",
    speaker_close: "Close",
    speaker_save: "Save Changes",
    speaker_userlist: "Users List",
    speaker_permitted_users: "Permitted Users List",
    speaker_name: "Name",
    speaker_total: "Total:",
    speaker_duplicate: "Duplicate Data(By Name) in Speakers will be",
    speaker_overwrite: "Overwrite",
    speaker_skip: "Skip",
    speaker_th_company: "Company",
    speaker_th_title: "Position",
    speaker_th_action: "Action",
    speaker_label_fname: "First name",
    speaker_placeholder_fname: "Enter your first name",
    speaker_label_lname: "Last name",
    speaker_placeholder_lname: "Enter your last name",
    speaker_label_email: "Email",
    speaker_label_email_with_info:
      "Email (required if you want to add as an app user too)",
    speaker_placeholder_email: "Enter email ID",
    speaker_label_profile: "Profile Image",
    speaker_label_profile_text_size:
      "Recommended image size - 320 wide x 480 tall",
    speaker_label_company: "Company",
    speaker_placeholder_company: "Enter your company name",
    speaker_label_position: "Designation",
    speaker_placeholder_position: "Enter your designation in the company",
    speaker_label_aboutyou: "About",
    speaker_placeholder_aboutyou: "Enter something about yourself",
    speaker_label_createuser: "Add as a user too",
    speaker_label_phone: "Phone no.",
    speaker_placeholder_phone: "Enter phone",
    speaker_label_country: "Country",
    speaker_placeholder_country: "Select your country",
    speaker_label_fb: "Facebook Profile",
    speaker_placeholder_fb: "Enter Facebook Profile Link",
    speaker_label_linkedin: "LinkedIn Profile",
    speaker_placeholder_linkedin: "Enter LinkedIn Profile Link",
    speaker_label_twitter: "Twitter Profile",
    speaker_placeholder_twitter: "Enter Twitter Profile Link",
    speaker_label_instagram: "Instagram Profile",
    speaker_placeholder_instagram: "Enter Instagram Profile Link",
    speaker_form_success:
      DEVELOPMENT_TYPE === "koachify"
        ? "Instructor updated successfully!"
        : "Speaker updated successfully!",
    speaker_error_message: "Something is wrong with associated users",
    speaker_dlt_success: "Speaker deleted successfully!",
    speaker_export_modal_title: "Export Speaker",
    speaker_export_total_data_text: "You have #total speakers",
    speaker_export_text_preparing_data:
      "Preparing the data... Excel file will be available soon.",
    speaker_export_text_export_csv_description:
      "Do you want to download the Excel file for the speakers? To proceed, click the download button. Depending on the number of sponsors, it might take a little longer.",
    speaker_deleteall: "Delete All",
    speaker_title_delete: "Delete All Speakers",
    speaker_text_are_you_sure_delete:
      "Are you sure you want to delete? This will remove all the speakers.",
    speaker_message_deleted: "Speakers deleted successfully!",
    speaker_text_total_selected_speaker: "Total #total speaker(s) are selected",
    speaker_delete_selected_speaker: "Delete #total speaker(s)",
    speaker_text_all_speaker_selected: "All speakers are selected",
    speaker_text_clear_all_selected_speakers: "Clear all selected speakers",
    speaker_text_select_all_speakers: "Delete all #total speakers",
    speaker_title_delete_speakers: "Delete Speakers",
    speaker_delete_speakers_subtitle:
      "Are you sure you want to delete #total speaker(s)?",

    // SPONSOR
    sponsor_addnew: "Add New",
    sponsor_close: "Close",
    sponsorsave: "Save Changes",
    sponsor_managecategories: "Manage Categories",
    sponsor_banner: "Banner",
    sponsor_recommended_image_size:
      "*Recommended image size - 566 wide x 368 tall",
    sponsor_logo: "Logo",
    sponsor_recommender_image_size300:
      "*Recommended image size - 300 wide x 300 tall",
    sponsor_userlist: "Users List",
    sponsor_th_name: "Name",
    sponsor_th_total: "Total:",
    sponsor_preview: "Preview",
    sponsor_duplicate: "Duplicate Data(By Name) in Sponsor will be",
    sponsor_overwrite: "Overwrite",
    sponsor_skip: "Skip",
    sponsor_membership:
      "You can manage the Sponsor Membership Category, choose a color for the badge, and set the priority from here.",
    sponsor_th_preview: "Preview",
    sponsor_th_action: "Action",
    sponsor_th_type: "Type",
    sponsor_placeholder_selectmembership: "Select Membership Type",
    sponsor_label_description: "Description",
    sponsor_placeholder_description: "Enter Description",
    sponsor_label_weblink: "Website",
    sponsor_placeholder_weblink: "Enter Website address",
    sponsor_label_fb: "Facebook Profile",
    sponsor_placeholder_fb: "Enter Facebook Profile Link",
    sponsor_label_linkedin: "Linkedn Profile",
    sponsor_placeholder_linkedin: "Enter LinkedIn Profile Link",
    sponsor_label_twitter: "Twitter Profile",
    sponsor_placeholder_twitter: "Enter Twitter Profile Link",
    sponsor_label_membershiptype: "Category Type",
    sponsor_placeholder_membershiptype: "Enter Category Type",
    sponsor_label_membershiptitle: "Category Title",
    sponsor_placeholder_membershiptitle: "Enter Category Title",
    sponsor_label_bgcolor: "Background Color",
    sponsor_placeholder_bgcolor: "Choose Badge Background Color",
    sponsor_label_textcolor: "Text Color",
    sponsor_placeholder_textcolor: "Choose Badge Text Color",
    sponsor_label_priority: "Priority",
    sponsor_placeholder_priorty: "Enter Category Priority",
    sponsor_error_message: "Something is wrong with associated users",
    sponsor_dlt_successfully: "Sponsor deleted successfully",
    sponsor_export_modal_title: "Export Sponsor",
    sponsor_export_total_data_text: "You have #total sponsors",
    sponsor_export_text_preparing_data:
      "Preparing the data... Excel file will be available soon.",
    sponsor_export_text_export_csv_description:
      "Do you want to download the Excel file for the sponsors? To proceed, click the download button. Depending on the number of sponsors, it might take a little longer.",
    sponsor_deleteall: "Delete All",
    sponsor_title_delete: "Delete all sponsors",
    sponsor_text_are_you_sure_delete:
      "Are you sure you want to delete? This will remove all sponsors.",
    sponsor_message_deleted: "Sponsors deleted successfully!",
    sponsor_text_total_selected_sponsor: "Total #total sponsor(s) are selected",
    sponsor_delete_selected_sponsor: "Delete #total sponsor(s)",
    sponsor_text_all_sponsor_selected: "All sponsors are selected",
    sponsor_text_clear_all_selected_sponsors: "Clear all selected sponsors",
    sponsor_text_select_all_sponsors: "Delete all #total sponsors",
    sponsor_title_delete_sponsors: "Delete Sponsors",
    sponsor_delete_sponsors_subtitle:
      "Are you sure you want to delete #total sponsor(s)?",

    // WEBVIEW
    webview_html: "Or use the HTML editor to create one",
    webview_save: "Save",
    webview_label_websiteurl: "You can link your website",
    webview_placeholder_websiteurl: "Insert Website URL here..",
    webview_placeholder_html: "Enter HTML content here..",

    // DASHBOARD
    dashboard_checklist_general_text: "General",
    dashboard_checklist_branding_text: "Branding",
    dashboard_checklist_content_text: "Content",
    dashboard_checklist_settings_text: "Settings",
    dashboard_checklist_payment_text: "Payment Gateway",
    dashboard_checklist_general_subtext:
      "Fill up general info like App name, Description & URL.",
    dashboard_checklist_branding_subtext:
      "Customize and match the look and feel of the apps, to your brand.",
    dashboard_checklist_content_subtext:
      "Manage, add, or remove your app contents.",
    dashboard_checklist_settings_subtext:
      "Setup User Registration type & info ",
    dashboard_checklist_payment_subtext:
      "Your payment gateway account has to be connected with Eventify to process payments.",

    /* BADGE DESIGNER */
    badge_element_event_name: "Event Name",
    badge_element_event_location: "Event Location",
    badge_element_event_logo: "Event Logo",
    badge_element_full_name: "Full Name",
    badge_element_first_name: "First Name",
    badge_element_last_name: "Last Name",
    badge_element_company_name: "Company Name",
    badge_element_designation: "Designation",
    badge_element_qr_code: "QR Code",
    badge_element_registration_type: "Registration Type",
    badge_element_input_type: "Custom Text",
    badge_element_image_type: "Custom Image",
    badge_element_primary_group: "Primary group",

    dashboard_badgedesign_loeader_text: "Preparing Badge Design",
    dashboard_badgedesign_modal_header: "Badge Design",
    dashboard_badgedesign_edit_modal_header: "Edit Badge Design",

    badge_element_choose_atleast_one: "At least 1 badge element is required.",

    // badge table
    dashboard_badgedesign_table_thead1: "Badge Name",
    dashboard_badgedesign_table_thead2: "Created on",
    dashboard_badgedesign_table_thead3: "Action",

    dashboard_badgedesign_select_Generate: "Select Attendee & Generate",
    dashboard_badgedesign_select_template: "Select template",

    // Badge add / edit form
    dashboard_badgedesign_form_label_badge_name: "Badge name",
    dashboard_badgedesign_form_badge_name: "Enter badge name",
    dashboard_badgedesign_form_label_page_padding: "Page Padding",
    dashboard_badgedesign_form_label_page_padding_top: "Page Padding Top",
    dashboard_badgedesign_form_label_page_padding_left: "Page Padding Left",
    dashboard_badgedesign_form_ph_page_padding_top: "Top",
    dashboard_badgedesign_form_ph_page_padding_left: "Left",
    dashboard_badgedesign_form_label_column_spacing: "Column Spacing",
    dashboard_badgedesign_form_ph_column_spacing: "Column spacing",
    dashboard_badgedesign_form_label_row_spacing: "Row Spacing",
    dashboard_badgedesign_form_ph_row_spacing: "Row spacing",
    dashboard_badgedesign_form_label_page_size: "Page Size",
    dashboard_badgedesign_form_page_size: "Select page size",
    dashboard_badgedesign_form_label_custom_page_size: "W x H",
    dashboard_badgedesign_form_ph_custom_page_size: "x.x",
    dashboard_badgedesign_form_label_page_custom_or_list: "Page default/custom",
    dashboard_badgedesign_form_page_custom_or_list: "Select ",
    dashboard_badgedesign_form_label_badge_size: "Badge Size",
    dashboard_badgedesign_form_badge_size: "Select badge size",
    dashboard_badgedesign_form_label_custon_badge_size: "W x H",
    dashboard_badgedesign_form_ph_custon_badge_size: "x.x",
    dashboard_badgedesign_form_label_linkcategory: "Link Categories",
    dashboard_badgedesign_form_ph_linkcategory:
      "Select categories to link with badge",
    dashboard_badgedesign_form_labelinfo_linkcategory:
      "Listing only categories which are not linked to any other badge.",
    dashboard_badgedesign_form_label_badge_custom_or_lisies:
      "Badge default/custom",
    dashboard_badgedesign_form_badge_custom_or_list: "Select ",
    dashboard_badgedesign_form_label_badge_elements: "Badge elements",
    dashboard_badgedesign_form_badge_elements: "Select badge elements",
    dashboard_badgedesign_form_badge_elements_note1:
      "Use {{variable_name}} inside custom text for checkout form fields.",
    dashboard_badgedesign_botton_custom_add_text_field: "Add Text",
    dashboard_badgedesign_botton_custom_add_image_field: "Add Image",

    // Add / edit badge validation
    dashboard_badgedesign_custom_badge_min_width: "Badge min-width should be 1",
    dashboard_badgedesign_custom_badge_min_height:
      "Badge min-height should be 1",
    dashboard_badgedesign_custom_badge_max_width:
      "Badge max-width should be 100",
    dashboard_badgedesign_custom_badge_max_height:
      "Badge max-height should be 100",
    dashboard_badgedesign_inappropriate_size_error:
      "Invalid badge / page size! Badge size cannot be greater than or equal to the page size.",

    // Generate badge modal
    dashboard_badgedesign_generate_badge_option1: "Choose attendees",
    dashboard_badgedesign_generate_badge_option2: "Specific primary category",
    dashboard_badgedesign_generate_badge_option3: "All confirmed attendees",
    dashboard_badgedesign_generate_badge_title: "Generate badge",
    generate_badge_for_select_category_validation: "Please select a category",
    dashboard_badgedesign_generate_badge_table_th_name: "Name",
    dashboard_badgedesign_generate_wait_message:
      "Please wait for some time; data is being prepared.",
    dashboard_badgedesign_generate_badge_message:
      "Please do not leave this page, as the generation of # badge(s) may take up to 2 minutes.",
    dashboard_badgedesign_generate_badge_wait_message:
      "Generating badges. Please wait, it will take some time.",

    // Badge print preview
    badge_print_preview: "Print Preview",

    // Badge editor header
    dashboard_badgedesign_preview: "Preview",

    // Select Attendee & Generate
    dashboard_badgedesign_search: "Search user with the name or email",
    dashboard_badgedesign_form_label_generate_badge_for: "Generate badge for",

    dashboard_badgedesign_generate_badge_loeader_text:
      "Preparing to Generate Badges",
    dashboard_badgedesign_generate_badge_modal_header: "Generate Badges",
    dashboard_badgedesign_generate_printtype_option1: "Single",
    dashboard_badgedesign_generate_printtype_option2: "Multiple",

    dashboard_badgedesign_form_label_badge_for: "Generate badge for",
    dashboard_badgedesign_form_badge_for: "Enter badge for",

    dashboard_badgedesign_form_ph_category: "Select a category",

    dashboard_badgedesign_form_label_pdf_settings: "PDF Settings",
    dashboard_badgedesign_form_pdf_settings:
      "Only print badges that have not already been generated.",

    dashboard_badgedesign_generate_btn: "Generate",

    dashboard_badgedesign_form_add_uccess: "Template added successfully..",
    dashboard_badgedesign_form_update_success:
      "Template updated successfully..",

    dashboard_badgedesign_delete_template: "Delete template",
    dashboard_badgedesign_delete_template_message:
      "Do you want to delete this template?",
    dashboard_badgedesign_delete_template_success:
      "Data deleted successfully ..",

    dashboard_badgedesign_default_update_title: "Set Default",
    dashboard_badgedesign_default_update_subtitle:
      "Would you like to set this badge as the default badge?",
    dashboard_badgedesign_default_update_success:
      "Badge successfully set as default!",

    // Email Log
    loaderDesc_EmailLog: "Preparing Email Logs",
    headertext_EmailLog: "Email Log Status",
    th_receiver_EmailLog: "Receiver",
    th_datetime_EmailLog: "DateTime",
    th_logfrom_EmailLog: "Email Type",
    th_finalstatus_EmailLog: "Final Status",
    th_statusfromlogs_EmailLog: "Status From Logs",
    th_content_EmailLog: "Content",
    view_content_EmailLog: "View Content",
    view__EmailLog: "View",
    no_content_EmailLog: "No Content Available",
    content_modal_EmailLog: "Email Content",
    email_log_counting_per_page: "startnum - endnum out of totalnum emails",

    // Events
    upcoming_event_tab_title_string: "Current and Upcoming Events",
    past_event_tab_title_string: "Past Events",
    valid_event_validity_string: "Validity till ",
    expired_event_validity_string: "Validity expired ",

    // Billing Payment Page and Thank you Page
    billing_payment_header: "Payment",
    billing_payment_desc: " Payment for billing",
    billing_payment_button_payment: "Tap to Pay Here",
    billing_payment_quote_already_paid: "Payment for this Quote is done!",
    billing_payment_quote_already_cancelled: "This Quote has been cancelled!",
    billing_payment_noinvoicefound: "No Invoice Found",
    thankyoupage_text:
      "Thank you! Your payment has been successfully processed! Please log in to continue",

    //Integration
    headertext_integrations: "Integrations",
    integration_api_docs: "API Docs",
    integration_embed_schedule: "Embed Schedule",
    integration_embed_tickets: "Embed Tickets",
    integration_live_screen: "Live Screen",
    integration_registration_forms: "Registration Forms",
    integration_abstracts: "Abstracts",

    integration_title_apidocs: "API Docs",
    integration_title_embed: "Embed",
    integration_title_tickets: "Tickets",
    integration_title_livescreen: "Live Screen",
    integration_title_regforms: "Registration Forms",
    integration_title_abstracts: "Abstracts",
    integration_title_zapier: "Zapier",

    integration_desc_apidocs:
      "Technical documentation for interacting with software application via its API",
    integration_desc_embed:
      "Easily create and seamlessly embed Sessions, Speakers, Sponsors, or all into any website individually.",
    integration_desc_tickets:
      "Create, integrate, and sell event tickets directly from your website.",
    integration_desc_livescreen:
      "Engage your audience by displaying a live poll on a screen using this module.",
    integration_desc_regforms:
      "Create a dynamic registration form to streamline the sign-up process.",
    integration_desc_abstracts:
      "Create forms to accept speaker submissions on your Call for Papers.",
    integration_desc_zapier:
      "Build custom automation and integrations with apps.",

    integration_linktext_apidocs: "View Docs",
    integration_linktext_embed: "Add Embed",
    integration_linktext_tickets: "Add Tickets",
    integration_linktext_livescreen: "Add Live screen",
    integration_linktext_regforms: "Registration Forms",
    integration_linktext_abstracts: "View Abstracts",
    integration_linktext_zapier: "Go to Zapier",

    integration_modal_title_apidocs: "Api Docs",
    integration_modal_title_embed: "Customize Embeds",
    integration_modal_title_tickets: "Embed Tickets",
    integration_modal_title_livescreen: "Live Screen",
    integration_modal_title_regforms: "Registration Forms",
    integration_modal_title_abstracts: "Abstracts",
    integration_modal_title_zapier: "",

    integration_ticket_link_address: "Link Address",
    integration_ticket_link_address_text:
      "You can view and sell tickets directly using this URL",
    integration_ticket_embed: "Embed as iFrame",
    integration_ticket_embed_text: "Embed tickets to your website as iFrame",
    integration_ticket_select: "Ticket",
    integration_hide_header_footer: "Hide Header",
    integration_hide_header_footer_text:
      "Check if you would like to hide the logo and header",

    integration_schedule_link_address: "Link Address",
    integration_schedule_link_address_text:
      "You can view schedules directly using this URL.",
    integration_schedule_embed: "Embed as iFrame",
    integration_schedule_embed_text:
      "Embed schedules to your website as iFrame",

    integration_live_link_address: "Live Screen",
    integration_live_link_address_text:
      "Engage your audience by displaying a live poll on a screen, using this module.",

    integration_form_link_address: "Registration Form",
    integration_form_link_address_text:
      "Your event registration form to streamline the sign-up process.",

    integration_abstract_link_address: "Abstract Form",
    integration_abstract_link_address_text:
      "Your event abstract form to collect submissions.",
    integration_schedule_select: "Session",

    integration_embed_what_to_embed: "Choose what to embed (Required)",
    integration_embed_how_to_embed: "Choose how to embed (Required)",
    integration_embed_hide_header_label: "Hide Header",
    integration_embed_add_sessioncolor_label: "Show Session-colors",
    integration_embed_choose_bg_label: "Choose the background color",
    integration_embed_choose_fontcolor_label: "Choose the font color",
    integration_embed_choose_font_label: "Use your font",

    integration_embed_hide_header:
      "Check if you would like to hide the logo and header",
    integration_embed_add_sessioncolor:
      "Check if you would like to show session colors in Schedule page",
    integration_embed_use_picker: "Use color picker",
    integration_embed_choose_bg_or_generate: "Or, Generate color",
    integration_embed_choose_bg_placeholder: "Provie a color hexcode",

    integration_embed_opt_schedule: "Schedule",
    integration_embed_opt_speaker: "Speaker",
    integration_embed_opt_sponsor: "Sponsor",
    integration_embed_opt_all: "All",
    integration_embed_opt_url: "Link",
    integration_embed_opt_iframe: "iFrame",

    integration_caution_text:
      "*Editing any information may result in changes to the link and iFrame URLs. If you make any updates, please be sure to replace the old URLs wherever they were previously used.",
    integration_common_type_url: "URL",
    integration_common_type_embed: "Embed Code",

    promo_overview_modal_header: "Preview",
    promo_overview_copy_title:
      "Your event's promotional link has been created!",
    promo_overview_copy_subtitle:
      "Promote your event and share this URL with your connections.",
    export_scanned_items: "Export User Scanned Items",
  },
  it: {
    general_building_with_eventify: "Building with Eventify",
    general_building_with_eventify_subtitle1:
      "With Eventify, it's extremely simple to put information right in your audience's hands, and it all starts here with our app builder.",
  },
});

// module.exports = LocaleStrings;
export default LocaleStrings;
